import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Long2qws0ah9gnpki as Long,
  equalsLong28bsrfhwvd686 as equalsLong,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID3gxj6tk5isa35 as VOID,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  startsWith1bgirhbedtv2y as startsWith,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString,
  contains2el4s70rdq4ld as contains,
  isBlank1dvkhjjvox3p0 as isBlank,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  createThis2j2avj17cvnv2 as createThis,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  constructCallableReference23y65rf941mch as constructCallableReference,
  getKClass3t8tygqu4lcxf as getKClass,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  isInterface3d6p8outrmvmk as isInterface,
  CancellationException3b36o9qz53rgr as CancellationException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  println2shhhgwwt4c61 as println,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException,
  indexOf382xk9sq5x0r4 as indexOf,
  emptySetcxexqki71qfa as emptySet,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf,
  printStackTrace18lnx7a39cni as printStackTrace,
  last1vo29oleiqj36 as last,
  fromInt1lka3ktyu79a4 as fromInt,
  captureStack1fzi4aczwc4hg as captureStack,
  contains3ue2qo8xhmpf1 as contains_0,
  to2cs3ny02qtbcb as to,
  emptyList1g2z5xcrvp2zy as emptyList,
  removeLast3759euu1xvfa3 as removeLast,
  ArrayList3it5z8td81qkl as ArrayList,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  reversed22y3au42jl32b as reversed,
  listOfvhqybd2zx248 as listOf_0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  KtSetjrjc7fhfd6b9 as KtSet,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
  PrimitiveClasses_getInstance143761yrsca9q as PrimitiveClasses_getInstance,
  Unitkvevlwgzwiuc as Unit,
  KtList3hktaavzmj137 as KtList,
  mapOf1xd03cq9cnmy8 as mapOf,
  LazyThreadSafetyMode_PUBLICATION_getInstance20ynwq7b0awd8 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  Enum3alwj03lh1n41 as Enum,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  IntSerializer_getInstance3hkg1llvt1c0z as IntSerializer_getInstance,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  StringSerializer_getInstancerxlnwnlbnwri as StringSerializer_getInstance,
  get_nullable197rfua9r7fsz as get_nullable,
  LongSerializer_getInstance1q1voa3zes72d as LongSerializer_getInstance,
  BooleanSerializer_getInstance3sa31xxwvx0ks as BooleanSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  SerializableWithd2dap36updxd as SerializableWith,
  ObjectSerializer2kjkucmygguwd as ObjectSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  PolymorphicSerializer3p3fzpdobi8hh as PolymorphicSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  $serializer_getInstance27hkret7vzdua as $serializer_getInstance,
  ClientLinksxthcu9kzrmk2 as ClientLinks,
  MasterFixingSupportingAgent3u14yuiuqy94 as MasterFixingSupportingAgent,
  get_JsonFormat2dpsvlhx9egj5 as get_JsonFormat,
  get_canBeUsedForResume1refd7w2k1te6 as get_canBeUsedForResume,
  Replay2zkg7vntz6tyx as Replay,
  GameStatus_Canceled_getInstancea7e586cxedya as GameStatus_Canceled_getInstance,
  SandboxGameWasCanceled2nl70tvde70p0 as SandboxGameWasCanceled,
  ReconnectSandboxPlaying17178inq9l5qg as ReconnectSandboxPlaying,
  Sandbox19coq947eyfc7 as Sandbox,
  NotFound_getInstance3eu74dij8p98e as NotFound_getInstance,
  Forbidden_getInstance2861raorwliaj as Forbidden_getInstance,
  Terminal38l09gyco2ri1 as Terminal,
  Resumed2m0t3m7h42101 as Resumed,
  Duel1tcmns9b4sqco as Duel,
  GameSessionReloadRequiredExceptionrlm8v4elghny as GameSessionReloadRequiredException,
  GameTeamukq9bbth76rc as GameTeam,
  boundAwait1gsd6dbqqqgm5 as boundAwait,
  InitGameStateEvent3t2iihh898bro as InitGameStateEvent,
  DraftStateEvent1fq4tkme4t2vi as DraftStateEvent,
  ConnectionStatus_Connected_getInstanceirwnp475015r as ConnectionStatus_Connected_getInstance,
  ConnectionStatus_Disconnected_getInstance3iw8gizz4cthw as ConnectionStatus_Disconnected_getInstance,
  ServerDrivenConfigurationTransparentException1fdsqb7291ke7 as ServerDrivenConfigurationTransparentException,
  reconnectGame$default3pfi1zzg9pgpr as reconnectGame$default,
  get_beastsGameTeam1y1bdmzuny63m as get_beastsGameTeam,
  get_huntersGameTeamiqiqxeugntgm as get_huntersGameTeam,
  calculateCheckCode2pl8736fah0hq as calculateCheckCode,
  SandboxGameStartedwoow2knuxnsj as SandboxGameStarted,
  processClient$default2gs0pei275yae as processClient$default,
  InternalRevertError2kax2xf0fyfgs as InternalRevertError,
  ServerDrivenConfiguration1321dh2c0itx2 as ServerDrivenConfiguration,
  GameStartedizt21rsqpez9 as GameStarted,
  get_gameContentVersion1sb5b1ke1q3q5 as get_gameContentVersion,
  SetupEnded27wh719dvkgtt as SetupEnded,
  RevertResult1o7bp0ynmtbw4 as RevertResult,
  WhatWillBeReapply_NoStateBefore_getInstance3uvn2i68us7s9 as WhatWillBeReapply_NoStateBefore_getInstance,
  WhatWillBeReapply_GameQuestion_getInstance3bzstdqe7zbi6 as WhatWillBeReapply_GameQuestion_getInstance,
  WhatWillBeReapply_GameNotification_getInstancegdd46s353szd as WhatWillBeReapply_GameNotification_getInstance,
  WhatWillBeReapply_InitialStateNotification_getInstance3h7h3bfq48y51 as WhatWillBeReapply_InitialStateNotification_getInstance,
  applytwfxifc6ncun as apply,
  QuestionDataToRestore7nu221sx1nm6 as QuestionDataToRestore,
  withStateRuntime2d9i5e0jyf3jd as withStateRuntime,
  get_anyGameTeamMarker2imsc9ntunywg as get_anyGameTeamMarker,
  withDiagnostics2iqjuui3sgjwn as withDiagnostics,
  StartPhaseEvent16kv7wan6gsti as StartPhaseEvent,
  Night1uaxo2yue9zq5 as Night,
  NightPhase_getInstance7ju3w96rz5 as NightPhase_getInstance,
  get_objectType3emg51nk00g59 as get_objectType,
  Turn1jw0phk9n3bzf as Turn,
  PlayerTurnPhase3jebsnvqgqk4f as PlayerTurnPhase,
  Dawn15251dwb1cvog as Dawn,
  DawnPhase1gkmlp1a4ffp0 as DawnPhase,
  replayTimeline2mije5qj967dw as replayTimeline,
  get_terminalInfoSourceCursor8s5m3nezendz as get_terminalInfoSourceCursor,
  BeastUserSettingsPatch1azd66vd7ktrk as BeastUserSettingsPatch,
  GameCodew6y6zhq2wcqb as GameCode,
  InfoSourceCursor2c5o44ahzccir as InfoSourceCursor,
  GameContentVersion2in87ovmr1f1t as GameContentVersion,
  GameRules28rlrtrb6hjnd as GameRules,
  GameSetupStatech68jqj7snwm as GameSetupState,
  GameStateCheckCode2c81inh90t5wq as GameStateCheckCode,
  GameStateEvent30j2xc3zcxtea as GameStateEvent,
  SandboxStartParams25sblc3uw8123 as SandboxStartParams,
  PingElement29w3g0l8uh6ka as PingElement,
  BeastResourceLookupRequestvc1aq5f9azrx as BeastResourceLookupRequest,
  ServerMessage2o1t59ukliaye as ServerMessage,
  BeastAuthenticationCapabilities2l6x7ao3b52st as BeastAuthenticationCapabilities,
  BeastLoginResultz38bkdv62i03 as BeastLoginResult,
  BeastSessionState2lxyj6p35g097 as BeastSessionState,
  BeastUserSettingValues1awalw0b537gv as BeastUserSettingValues,
  ActiveGameSessions34jfg96df0ktg as ActiveGameSessions,
  LobbyList3vahn6xsy63bi as LobbyList,
  ResumeDuelGameResult1wgqp1tw8w1yi as ResumeDuelGameResult,
  SetupUpdateFromServer12nxqfl8delrq as SetupUpdateFromServer,
  BeastClientConfiguration1q00ciajuydzi as BeastClientConfiguration,
  InitSandboxResult3vrtfstrzby3t as InitSandboxResult,
  SandboxInitApplyEventResult23wxz17np7x8k as SandboxInitApplyEventResult,
  StartSandboxResult3exx6b2ecj4s3 as StartSandboxResult,
  ReconnectSandboxResult2qqhhm1ubtikg as ReconnectSandboxResult,
  GamePresence3mddfrxug64dh as GamePresence,
  RequestRevertTurnResult1tg782ml2y54i as RequestRevertTurnResult,
  CompletedGame24rbxwso5h9gw as CompletedGame,
  RetainedResourceHandoff3pll0b3rqi74p as RetainedResourceHandoff,
  ReplaySharingStatus26nfriwmr9i87 as ReplaySharingStatus,
  PendingReplayConsentzqvvvfrqpye1 as PendingReplayConsent,
  $serializer_getInstance2yzdywy4f5ghd as $serializer_getInstance_0,
  values3mdu86jyfb86y as values,
  $serializer_getInstancen2q4l5h5oro1 as $serializer_getInstance_1,
  get_canceledSessionInfoSourceCursor1tdcqmn494m1b as get_canceledSessionInfoSourceCursor,
  $serializer_getInstance20667iq8deuyb as $serializer_getInstance_2,
  GameQuestion1nmeqeqr9sno8 as GameQuestion,
  AncientPowerNumberQuestion3cdrapqw1ph4u as AncientPowerNumberQuestion,
  BeastMovementCardQuestion1j0j9jcqebpmg as BeastMovementCardQuestion,
  PlaceHatchlingWithInfestQuestion1hmc3ecm88cyr as PlaceHatchlingWithInfestQuestion,
  PlayOverloadedQuestion3v4ahyk6t5705 as PlayOverloadedQuestion,
  RevealToMoveQuestion3jejh8jnus19n as RevealToMoveQuestion,
  SpendLydanHarvestQuestion1zfcwnkevgsnd as SpendLydanHarvestQuestion,
  SpendValdiBloodQuestion200psr5oz6oqw as SpendValdiBloodQuestion,
  UseVackerSoulsQuestion3f8ph15lill3r as UseVackerSoulsQuestion,
  CardPlayColorQuestion1njsep2xnid70 as CardPlayColorQuestion,
  ChooseCardOnDraftQuestion3dw7wif1c6a1e as ChooseCardOnDraftQuestion,
  ChooseCardsQuestion236iunubwe5yh as ChooseCardsQuestion,
  ChooseCharacterQuestion15prhcvmg0xx6 as ChooseCharacterQuestion,
  ContinueAfterRecoveryQuestioniefkyt7x2a8e as ContinueAfterRecoveryQuestion,
  DestinationQuestion3h9r448czxeoe as DestinationQuestion,
  BarrierConnectedLocationQuestion2mxsuoje65g5h as BarrierConnectedLocationQuestion,
  GrapnelQuestion2ejkh7zbeaiey as GrapnelQuestion,
  LocationQuestion3nq53tkbsl0bw as LocationQuestion,
  PlaceNewObjectQuestion2hcww1pm3bmd7 as PlaceNewObjectQuestion,
  SearchLocationQuestion2ib0yfp46z7bp as SearchLocationQuestion,
  TransformLocationQuestion1tv0p4ejdq4vl as TransformLocationQuestion,
  LocationTypeQuestion1z8yhezyamvr0 as LocationTypeQuestion,
  ObjectsGameQuestion2boxyklmnsg55 as ObjectsGameQuestion,
  PhaseRecoveryQuestiono68nj60zs5zl as PhaseRecoveryQuestion,
  PlayCardInTurnQuestion1hww2zcmfisni as PlayCardInTurnQuestion,
  SnareTypeQuestion3gp1wpngxoqkh as SnareTypeQuestion,
  StatementQuestion1lxt2f1cnz3ov as StatementQuestion,
  TrapByNumberQuestion2bnfeidyvay5a as TrapByNumberQuestion,
  TriggersQuestionesdw70q2hiv1 as TriggersQuestion,
  UpgradeQuestion1yilwq9twob5k as UpgradeQuestion,
  UrgullMoltEggsToReturnQuestionn32b555is0iq as UrgullMoltEggsToReturnQuestion,
  ZoneQuestion1169zovvoqch5 as ZoneQuestion,
  $serializer_getInstance2uw2ug8urikwh as $serializer_getInstance_3,
  $serializer_getInstance2e2wi0y1bwmvv as $serializer_getInstance_4,
  PlaceHatchlingWithInfestQuestion_getInstance31ahka7m2vhps as PlaceHatchlingWithInfestQuestion_getInstance,
  PlayOverloadedQuestion_getInstance1ujm5rvbvzag1 as PlayOverloadedQuestion_getInstance,
  RevealToMoveQuestion_getInstance1nmmcl3l356x0 as RevealToMoveQuestion_getInstance,
  $serializer_getInstancemd15awmf326k as $serializer_getInstance_5,
  $serializer_getInstance3imr24z4qrf8t as $serializer_getInstance_6,
  $serializer_getInstancey79lt5yftlqd as $serializer_getInstance_7,
  CardPlayColorQuestion_getInstance3ach19sphyo7c as CardPlayColorQuestion_getInstance,
  $serializer_getInstance27d2dyrgjs6va as $serializer_getInstance_8,
  $serializer_getInstance4kawrh7s0kng as $serializer_getInstance_9,
  $serializer_getInstance1r78mhw99hua4 as $serializer_getInstance_10,
  ContinueAfterRecoveryQuestion_getInstance298fsbtle0scw as ContinueAfterRecoveryQuestion_getInstance,
  $serializer_getInstance3ptg9vd9z065e as $serializer_getInstance_11,
  $serializer_getInstance1qqoh32x8kl1a as $serializer_getInstance_12,
  $serializer_getInstance134ob40ugu6yu as $serializer_getInstance_13,
  $serializer_getInstance15c1csd00l6s7 as $serializer_getInstance_14,
  $serializer_getInstance3t0frlt0da3mw as $serializer_getInstance_15,
  $serializer_getInstance10kthw6ptdhfl as $serializer_getInstance_16,
  $serializer_getInstance2g7zr0qtvsn40 as $serializer_getInstance_17,
  $serializer_getInstancex8xdvn48hb2e as $serializer_getInstance_18,
  ObjectOnBoardType251o7nzihiu95 as ObjectOnBoardType,
  $serializer1lf613kx9k3vi as $serializer,
  $serializer_getInstancegh1c2gqi2r2a as $serializer_getInstance_19,
  $serializer_getInstanceiqyd242eb9og as $serializer_getInstance_20,
  $serializer_getInstance2aa7iz284rpp8 as $serializer_getInstance_21,
  $serializer_getInstance14511g6nwgqjc as $serializer_getInstance_22,
  $serializer_getInstance1g2qm0aggk6hs as $serializer_getInstance_23,
  $serializer_getInstance3ugjj0khs6blm as $serializer_getInstance_24,
  $serializer_getInstanceby005w4fcfuh as $serializer_getInstance_25,
  $serializer_getInstance3li35c2x8pes6 as $serializer_getInstance_26,
  $serializer_getInstancew57cfjnndkci as $serializer_getInstance_27,
  GameTeam__toString_impl_wfw0a61jglj7o24etxt as GameTeam__toString_impl_wfw0a6,
  GameTeam__hashCode_impl_gu24w33k0olxizuckp1 as GameTeam__hashCode_impl_gu24w3,
  get_incorrectServerStateInfoSourceCursor1wqascr3wc9rm as get_incorrectServerStateInfoSourceCursor,
  Companion_instance34mqqcp3svcuw as Companion_instance,
  $serializer_getInstanceat3nlk9a5n53 as $serializer_getInstance_28,
  Companion_instance1bgxo4spj7zq8 as Companion_instance_0,
  Companion_instance2xr03m2pafwy5 as Companion_instance_1,
  $serializer_getInstancebm5ryeteqqrs as $serializer_getInstance_29,
  get12zahk941o61v as get,
} from './beast-beast-common.mjs';
import {
  HttpClient3584jcajl7sef as HttpClient,
  Companion_getInstance3lzla9igmrw8j as Companion_getInstance,
  AcceptAllCookiesStorage10bxtojtvirrv as AcceptAllCookiesStorage,
  WebSocketExceptionb5mwyitzck0i as WebSocketException,
} from './ktor-ktor-client-core.mjs';
import {
  rpc16ebqkyzshzc4 as rpc,
  installKrpcntft8lhf4nye as installKrpc,
  rpcConfig1aw6avpp4z7tw as rpcConfig,
} from './kotlinx-rpc-krpc-krpc-ktor-krpc-ktor-client.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  FlowCollector26clgpmzihvke as FlowCollector,
  get_job2zvlvce9o9a29 as get_job,
  delay3e2ei0hoxjoud as delay,
  CoroutineStart_UNDISPATCHED_getInstance2pq896dvru5v1 as CoroutineStart_UNDISPATCHED_getInstance,
  _ChannelResult___get_isSuccess__impl__odq1z9t6ktwy0g0q0f as _ChannelResult___get_isSuccess__impl__odq1z9,
  get_isActivehakov5bm97hw as get_isActive,
  Channel3r72atmcithql as Channel,
  cancelAndJoin21f2rd386nyt8 as cancelAndJoin,
  MutableStateFlow34bfoyvwu8czu as MutableStateFlow,
  Mutex16li1l0asjv17 as Mutex,
  coroutineScope39ukucf23mhsm as coroutineScope,
  Key_instancebefxze3q9f64 as Key_instance,
  asyncz02dsa2nb2zt as async,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  cancelChildren10wlln0b749a7 as cancelChildren,
} from './kotlinx-coroutines-core.mjs';
import {
  withServicel7yg7jrfo9nc as withService,
  Method20rthexa6dr04 as Method,
  RpcTypeDefault2e42ia4wgd8m1 as RpcTypeDefault,
  RpcCallableDefaultlp2qt3a2kvq8 as RpcCallableDefault,
  RpcParameterDefault3oy8jzl3k0lco as RpcParameterDefault,
  RpcServiceDescriptor1rrqja5trbxwd as RpcServiceDescriptor,
  RpcCall29txkfxe2d5c7 as RpcCall,
  WithServiceDescriptor1knexq36coi76 as WithServiceDescriptor,
} from './kotlinx-rpc-core.mjs';
import {
  Companion_getInstancehe53gw4v5mqu as Companion_getInstance_0,
  set_encodedPath3q0i8nsv3a7qy as set_encodedPath,
} from './ktor-ktor-http.mjs';
import { json3e0hzni0i002 as json } from './kotlinx-rpc-krpc-krpc-serialization-krpc-serialization-json.mjs';
import { IOException1wyutdmfe71nu as IOException } from './kotlinx-io-kotlinx-io-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class $serializer_0 {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ClientConnectionSettings', this, 7);
    tmp0_serialDesc.h1b('webSocketHost', false);
    tmp0_serialDesc.h1b('webSocketPort', false);
    tmp0_serialDesc.h1b('pingInterval', true);
    tmp0_serialDesc.h1b('webSocketPath', true);
    tmp0_serialDesc.h1b('expectedInteractionVersion', true);
    tmp0_serialDesc.h1b('links', true);
    tmp0_serialDesc.h1b('enableRecoveryTestContent', true);
    this.i92_1 = tmp0_serialDesc;
  }
  j92(encoder, value) {
    var tmp0_desc = this.i92_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.k92_1);
    tmp1_output.i15(tmp0_desc, 1, IntSerializer_getInstance(), value.l92_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !equalsLong(value.m92_1, new Long(40000, 0))) {
      tmp1_output.a15(tmp0_desc, 2, value.m92_1);
    }
    if (tmp1_output.m15(tmp0_desc, 3) ? true : !(value.n92_1 === '/interaction')) {
      tmp1_output.e15(tmp0_desc, 3, value.n92_1);
    }
    if (tmp1_output.m15(tmp0_desc, 4) ? true : !(value.o92_1 === '1.0.5')) {
      tmp1_output.e15(tmp0_desc, 4, value.o92_1);
    }
    if (tmp1_output.m15(tmp0_desc, 5) ? true : !value.p92_1.equals(new ClientLinks())) {
      tmp1_output.g15(tmp0_desc, 5, $serializer_getInstance(), value.p92_1);
    }
    if (tmp1_output.m15(tmp0_desc, 6) ? true : !(value.q92_1 === false)) {
      tmp1_output.w14(tmp0_desc, 6, value.q92_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j92(encoder, value instanceof ClientConnectionSettings ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i92_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_input = decoder.p13(tmp0_desc);
    if (tmp11_input.e14()) {
      tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.v13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.z13(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.z13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.b14(tmp0_desc, 5, $serializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.r13(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.d14(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.v13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.z13(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.z13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.b14(tmp0_desc, 5, $serializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.r13(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp11_input.q13(tmp0_desc);
    return ClientConnectionSettings.r92(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  }
  dz() {
    return this.i92_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance(), BooleanSerializer_getInstance()];
  }
}
class ClientConnectionSettings {
  constructor(webSocketHost, webSocketPort, pingInterval, webSocketPath, expectedInteractionVersion, links, enableRecoveryTestContent) {
    pingInterval = pingInterval === VOID ? new Long(40000, 0) : pingInterval;
    webSocketPath = webSocketPath === VOID ? '/interaction' : webSocketPath;
    expectedInteractionVersion = expectedInteractionVersion === VOID ? '1.0.5' : expectedInteractionVersion;
    links = links === VOID ? new ClientLinks() : links;
    enableRecoveryTestContent = enableRecoveryTestContent === VOID ? false : enableRecoveryTestContent;
    this.k92_1 = webSocketHost;
    this.l92_1 = webSocketPort;
    this.m92_1 = pingInterval;
    this.n92_1 = webSocketPath;
    this.o92_1 = expectedInteractionVersion;
    this.p92_1 = links;
    this.q92_1 = enableRecoveryTestContent;
    // Inline function 'kotlin.require' call
    if (!startsWith(this.n92_1, _Char___init__impl__6a9atx(47))) {
      var message = "WebSocket path must start with '/'";
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(!contains(this.n92_1, _Char___init__impl__6a9atx(63)) && !contains(this.n92_1, _Char___init__impl__6a9atx(35)))) {
      var message_0 = 'WebSocket path must not contain a query or fragment';
      throw IllegalArgumentException.h2(toString(message_0));
    }
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = this.o92_1;
    // Inline function 'kotlin.require' call
    if (!!isBlank(this_0)) {
      var message_1 = 'Expected interaction version must not be blank';
      throw IllegalArgumentException.h2(toString(message_1));
    }
  }
  toString() {
    return 'ClientConnectionSettings(webSocketHost=' + this.k92_1 + ', webSocketPort=' + this.l92_1 + ', pingInterval=' + this.m92_1.toString() + ', webSocketPath=' + this.n92_1 + ', expectedInteractionVersion=' + this.o92_1 + ', links=' + this.p92_1.toString() + ', enableRecoveryTestContent=' + this.q92_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.k92_1);
    result = imul(result, 31) + (this.l92_1 == null ? 0 : this.l92_1) | 0;
    result = imul(result, 31) + this.m92_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.n92_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o92_1) | 0;
    result = imul(result, 31) + this.p92_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q92_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClientConnectionSettings))
      return false;
    if (!(this.k92_1 === other.k92_1))
      return false;
    if (!(this.l92_1 == other.l92_1))
      return false;
    if (!equalsLong(this.m92_1, other.m92_1))
      return false;
    if (!(this.n92_1 === other.n92_1))
      return false;
    if (!(this.o92_1 === other.o92_1))
      return false;
    if (!this.p92_1.equals(other.p92_1))
      return false;
    if (!(this.q92_1 === other.q92_1))
      return false;
    return true;
  }
  static r92(seen0, webSocketHost, webSocketPort, pingInterval, webSocketPath, expectedInteractionVersion, links, enableRecoveryTestContent, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_30().i92_1);
    }
    var $this = createThis(this);
    $this.k92_1 = webSocketHost;
    $this.l92_1 = webSocketPort;
    if (0 === (seen0 & 4))
      $this.m92_1 = new Long(40000, 0);
    else
      $this.m92_1 = pingInterval;
    if (0 === (seen0 & 8))
      $this.n92_1 = '/interaction';
    else
      $this.n92_1 = webSocketPath;
    if (0 === (seen0 & 16))
      $this.o92_1 = '1.0.5';
    else
      $this.o92_1 = expectedInteractionVersion;
    if (0 === (seen0 & 32))
      $this.p92_1 = new ClientLinks();
    else
      $this.p92_1 = links;
    if (0 === (seen0 & 64))
      $this.q92_1 = false;
    else
      $this.q92_1 = enableRecoveryTestContent;
    // Inline function 'kotlin.require' call
    if (!startsWith($this.n92_1, _Char___init__impl__6a9atx(47))) {
      var message = "WebSocket path must start with '/'";
      throw IllegalArgumentException.h2(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(!contains($this.n92_1, _Char___init__impl__6a9atx(63)) && !contains($this.n92_1, _Char___init__impl__6a9atx(35)))) {
      var message_0 = 'WebSocket path must not contain a query or fragment';
      throw IllegalArgumentException.h2(toString(message_0));
    }
    // Inline function 'kotlin.text.isNotBlank' call
    var this_0 = $this.o92_1;
    // Inline function 'kotlin.require' call
    if (!!isBlank(this_0)) {
      var message_1 = 'Expected interaction version must not be blank';
      throw IllegalArgumentException.h2(toString(message_1));
    }
    return $this;
  }
}
class RevertStateData {
  constructor(revertChanges, revisionAfterRevert, checkCodeAfterRevert) {
    this.i93_1 = revertChanges;
    this.j93_1 = revisionAfterRevert;
    this.k93_1 = checkCodeAfterRevert;
  }
  jm() {
    return this.i93_1;
  }
  km() {
    return this.j93_1;
  }
  fx() {
    return this.k93_1;
  }
  toString() {
    return 'RevertStateData(revertChanges=' + toString(this.i93_1) + ', revisionAfterRevert=' + this.j93_1 + ', checkCodeAfterRevert=' + toString_0(this.k93_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.i93_1);
    result = imul(result, 31) + this.j93_1 | 0;
    result = imul(result, 31) + (this.k93_1 == null ? 0 : this.k93_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertStateData))
      return false;
    if (!equals(this.i93_1, other.i93_1))
      return false;
    if (!(this.j93_1 === other.j93_1))
      return false;
    if (!equals(this.k93_1, other.k93_1))
      return false;
    return true;
  }
}
class sam$kotlinx_coroutines_flow_FlowCollector$0 {
  constructor(function_0) {
    this.b94_1 = function_0;
  }
  *k24(value, $completion) {
    return yield* this.b94_1(value, $completion);
  }
  p5() {
    return this.b94_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class ServerDrivenConfigurationKrpc$createMasterFixingEventsConsumer$1 {
  constructor(this$0, $fixingId) {
    this.j95_1 = this$0;
    this.k95_1 = $fixingId;
  }
  *l95(event, $completion) {
    return yield* this.j95_1.f94(ServerDrivenConfigurationKrpc$createMasterFixingEventsConsumer$o$submitFixingEvent$slambda(this.k95_1, event), $completion);
  }
}
class ServerDrivenConfigurationKrpc {
  constructor(clientSettings, diagnostics, cookieStorage) {
    cookieStorage = cookieStorage === VOID ? new AcceptAllCookiesStorage() : cookieStorage;
    this.t92_1 = clientSettings;
    this.u92_1 = diagnostics;
    this.v92_1 = cookieStorage;
    this.w92_1 = MutableStateFlow(ConnectionStatus_Connected_getInstance());
    this.x92_1 = MutableStateFlow(emptySet());
    this.y92_1 = null;
    this.z92_1 = null;
    this.a93_1 = null;
    this.b93_1 = null;
    this.c93_1 = null;
    this.d93_1 = Mutex();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.e93_1 = LinkedHashMap.m7();
    this.f93_1 = Mutex();
    this.g93_1 = Mutex();
  }
  q6k() {
    var tmp;
    if (this.t92_1.l92_1 == null) {
      tmp = 'https://' + this.t92_1.k92_1;
    } else {
      tmp = this.t92_1.k92_1 + ':' + this.t92_1.l92_1;
    }
    return tmp;
  }
  r6k() {
    return this.w92_1;
  }
  s6k() {
    return this.x92_1;
  }
  *t6k($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$authenticationCapabilities$slambda(), $completion);
  }
  *m95($completion) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this.f93_1;
    yield* this_0.y2a(null, $completion);
    var tmp;
    try {
      var message = '';
      var retryAttempt = 0;
      var delaysOnTry = listOf([200, 500, 1000]);
      while (this.a93_1 == null) {
        if (!this.w92_1.k3().equals(ConnectionStatus_Disconnected_getInstance())) {
          this.w92_1.r25(ConnectionStatus_Disconnected_getInstance());
        }
        try {
          // Inline function 'kotlinx.coroutines.sync.withLock' call
          var this_1 = this.g93_1;
          yield* this_1.y2a(null, $completion);
          try {
            connectToServer(this);
          }finally {
            this_1.k2a(null);
          }
          var interaction = this.a93_1;
          if (!(interaction == null)) {
            var serverVersion = yield* interaction.e94($completion);
            if (!(serverVersion === this.t92_1.o92_1)) {
              throw ServerHasAnotherVersionError.r95(serverVersion);
            }
            yield* interaction.v6k($completion);
            var messageRpcClient = ensureNotNull(this.c93_1);
            var tmp_0 = this;
            var tmp_1 = ensureNotNull(this.b93_1);
            tmp_0.y92_1 = launch(tmp_1, VOID, VOID, ServerDrivenConfigurationKrpc$waitConnection$slambda(interaction, messageRpcClient, this));
            println('Connected!');
            return true;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            println('Exception from waitConnection');
            printStackTrace(e);
            // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
            // Inline function 'kotlin.js.getCoroutineContext' call
            var tmp$ret$4 = $completion.od();
            if (get_job(tmp$ret$4).a1n()) {
              throw e;
            }
            rethrowExceptionIfNeeded(e);
            if (!(message === e.message)) {
              var tmp0_elvis_lhs = e.message;
              message = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
              printStackTrace(e);
            }
          } else {
            throw $p;
          }
        }
        println('try ' + retryAttempt);
        closeConnection(this);
        yield* delay(fromInt(retryAttempt < delaysOnTry.s2() ? delaysOnTry.u2(retryAttempt) : last(delaysOnTry)), $completion);
        retryAttempt = retryAttempt + 1 | 0;
      }
      return false;
    }finally {
      this_0.k2a(null);
    }
  }
  *f94(fn, $completion) {
    return yield* this.p94(null, fn, $completion);
  }
  *p94(onReconnect, fn, $completion) {
    var message = '';
    while (true) {
      var wasReconnect = yield* this.m95($completion);
      var interaction = this.a93_1;
      if (!(interaction == null)) {
        if (!this.w92_1.k3().equals(ConnectionStatus_Connected_getInstance())) {
          this.w92_1.r25(ConnectionStatus_Connected_getInstance());
        }
        try {
          if (wasReconnect) {
            var reconnectResult = onReconnect == null ? null : (yield* onReconnect(interaction, $completion));
            if (reconnectResult == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              return reconnectResult;
            }
          }
          var result = yield* fn(interaction, $completion);
          return result;
        } catch ($p) {
          if ($p instanceof IOException) {
            var e = $p;
            if (!(message === e.message)) {
              var tmp2_elvis_lhs = e.message;
              message = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
              printStackTrace(e);
            }
          } else {
            if ($p instanceof CancellationException) {
              var e_0 = $p;
              var cancellationException = e_0;
              $l$loop_1: while (true) {
                var tmp3_elvis_lhs = cancellationException.cause;
                var tmp;
                if (tmp3_elvis_lhs == null) {
                  break $l$loop_1;
                } else {
                  tmp = tmp3_elvis_lhs;
                }
                var cause = tmp;
                if (isInterface(cause, ServerDrivenConfigurationTransparentException))
                  throw e_0;
                else {
                  if (equals(cause, cancellationException))
                    break $l$loop_1;
                  else {
                    if (cause instanceof CancellationException)
                      cancellationException = cause;
                    else {
                      break $l$loop_1;
                    }
                  }
                }
              }
              println('CancellationException from withInteraction');
              // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
              // Inline function 'kotlin.js.getCoroutineContext' call
              var tmp$ret$2 = $completion.od();
              if (get_job(tmp$ret$2).a1n()) {
                throw e_0;
              }
              if (!(message === e_0.message)) {
                var tmp5_elvis_lhs = e_0.message;
                message = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
                printStackTrace(e_0);
              }
            } else {
              if ($p instanceof WebSocketException) {
                var e_1 = $p;
                if (!(message === e_1.message)) {
                  var tmp6_elvis_lhs = e_1.message;
                  message = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
                  printStackTrace(e_1);
                }
              } else {
                if ($p instanceof Error) {
                  var e_2 = $p;
                  if (isInterface(e_2, ServerDrivenConfigurationTransparentException)) {
                    throw e_2;
                  }
                  println('Throwable from withInteraction');
                  printStackTrace(e_2);
                  rethrowExceptionIfNeeded(e_2);
                  printStackTrace(e_2);
                } else {
                  throw $p;
                }
              }
            }
          }
        }
      }
      println('retry!');
      closeConnection(this);
    }
  }
  *s95($completion) {
    while (true) {
      yield* delay(this.t92_1.m92_1, $completion);
      println('PING!');
      yield* coroutineScope(ServerDrivenConfigurationKrpc$pingConnection$slambda(this), $completion);
    }
    return Unit_instance;
  }
  *c6l($completion) {
    this.e93_1.a5();
    yield* this.f94(ServerDrivenConfigurationKrpc$resetCommunication$slambda(this), $completion);
    return Unit_instance;
  }
  *u6k(accessCode, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$loginWithAccessCode$slambda(accessCode), $completion);
  }
  *o6l($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$prepareSandboxSession$slambda(), $completion);
  }
  *v6k($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$restoreSession$slambda(), $completion);
  }
  *w6k($completion) {
    yield* this.f94(ServerDrivenConfigurationKrpc$logout$slambda(), $completion);
    return Unit_instance;
  }
  *x6k($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$getUserSettings$slambda(), $completion);
  }
  *y6k(patch, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$patchUserSettings$slambda(patch), $completion);
  }
  *z6k($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$resetUserSettings$slambda(), $completion);
  }
  *a6l($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$getActiveGameSessions$slambda(), $completion);
  }
  *b6l($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$requestLobbyList$slambda(), $completion);
  }
  *d6l(gameName, $completion) {
    return setupFromResult(this, yield* this.f94(ServerDrivenConfigurationKrpc$createNewGame$slambda(gameName), $completion));
  }
  *e6l(gameCode, $completion) {
    return setupFromResult(this, yield* this.f94(ServerDrivenConfigurationKrpc$connectNewGame$slambda(gameCode), $completion));
  }
  *f6l(gameCode, gameTeam, lastSeenInfoSourceCursor, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$reconnectGame$slambda(gameCode, gameTeam, lastSeenInfoSourceCursor), $completion);
  }
  *h6l(gameCode, $completion) {
    yield* this.f94(ServerDrivenConfigurationKrpc$cancelGame$slambda(gameCode), $completion);
    return Unit_instance;
  }
  *i6l(agent, gameTeam, $completion) {
    var tmp0 = this.e93_1;
    // Inline function 'kotlin.collections.set' call
    var key = new GameTeam(gameTeam);
    tmp0.b5(key, agent);
    var tmp0_safe_receiver = this.z92_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = isInterface(agent, MasterFixingSupportingAgent) ? agent : null;
      tmp0_safe_receiver_0 == null || (yield* tmp0_safe_receiver_0.w6q(tmp0_safe_receiver, $completion));
    }
    return Unit_instance;
  }
  *j6l($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$requestCompletedGames$slambda(), $completion);
  }
  *k6l($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$requestSandboxGames$slambda(), $completion);
  }
  *l6l(gameCode, isSandboxGame, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$getCompletedGame$slambda(gameCode, isSandboxGame), $completion);
  }
  *m6l(request, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$locateRetainedResource$slambda(request), $completion);
  }
  *n6l(gameCode, isSandboxGame, $completion) {
    var fullReplay = yield* this.f94(ServerDrivenConfigurationKrpc$replayGameReplay$slambda(gameCode, isSandboxGame), $completion);
    if (fullReplay.n1()) {
      return null;
    }
    return new FullGameReplayDriverImpl(this.e93_1, fullReplay, this.u92_1);
  }
  *p6l(gameCode, $completion) {
    yield* this.f94(ServerDrivenConfigurationKrpc$shareSandboxReplay$slambda(gameCode), $completion);
    return Unit_instance;
  }
  *q6l(gameCode, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$shareFullGameReplay$slambda(gameCode), $completion);
  }
  *r6l($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$requestPendingReplayConsents$slambda(), $completion);
  }
  *s6l(gameCode, approved, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$respondToReplayConsent$slambda(gameCode, approved), $completion);
  }
  *t6l(gameCode, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$reconnectSandboxGame$slambda(gameCode), $completion);
  }
  *k94(gameSetupState, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$initSandboxGame$slambda(gameSetupState), $completion);
  }
  *t95(beastAgentControl, huntersAgentControl, gameState, startParams, gameCode, sandboxEventsNumber, sandboxIdCallback, $completion) {
    yield* this.i6l(beastAgentControl, get_beastsGameTeam(), $completion);
    yield* this.i6l(huntersAgentControl, get_huntersGameTeam(), $completion);
    var checkCode = calculateCheckCode(gameState);
    var startAttemptResult = yield* this.f94(ServerDrivenConfigurationKrpc$startSandboxGame$slambda(gameCode, checkCode, sandboxEventsNumber, startParams), $completion);
    if (startAttemptResult instanceof SandboxGameStarted) {
      sandboxIdCallback(startAttemptResult.m6x_1);
      var reconnectResult = yield* this.t6l(startAttemptResult.m6x_1, $completion);
      if (!(reconnectResult instanceof ReconnectSandboxPlaying)) {
        // Inline function 'kotlin.error' call
        var message = 'Reconnect sandbox game result should be ReconnectSandboxPlaying, instead it is ' + toString(reconnectResult);
        throw IllegalStateException.o(toString(message));
      }
      yield* this.v6l(new Sandbox(startAttemptResult.m6x_1), VOID, $completion);
    } else {
      // Inline function 'kotlin.error' call
      var message_0 = 'Cannot start sandbox game ' + toString_0(gameCode) + ': ' + toString(startAttemptResult);
      throw IllegalStateException.o(toString(message_0));
    }
    return Unit_instance;
  }
  *h6w(gameCode, applyingEventNumber, checkCodeBeforeEvent, event, $completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$submitEventForSandboxGame$slambda(gameCode, applyingEventNumber, checkCodeBeforeEvent, event), $completion);
  }
  *u95(beastAgentControl, huntersAgentControl, gameCode, $completion) {
    yield* this.i6l(beastAgentControl, get_beastsGameTeam(), $completion);
    yield* this.i6l(huntersAgentControl, get_huntersGameTeam(), $completion);
    yield* this.v6l(new Sandbox(gameCode), VOID, $completion);
    return Unit_instance;
  }
  *u6l(goingBeastGame, onReloadRequired, $completion) {
    var lastProcessedInfo = {_v: null};
    var lastSeenInfoSourceCursor = {_v: null};
    try {
      var answerJob = {_v: null};
      var approvalJob = {_v: null};
      var approvalRequestId = {_v: null};
      yield* coroutineScope(ServerDrivenConfigurationKrpc$processClient$slambda(lastSeenInfoSourceCursor, this, approvalJob, approvalRequestId, lastProcessedInfo, answerJob, onReloadRequired, goingBeastGame), $completion);
    } catch ($p) {
      if ($p instanceof GameSessionReloadRequiredException) {
        var e = $p;
        // Inline function 'kotlinx.coroutines.sync.withLock' call
        var this_0 = this.d93_1;
        yield* this_0.y2a(null, $completion);
        try {
          this.z92_1 = null;
        }finally {
          this_0.k2a(null);
        }
        this.e93_1.a5();
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          var tmp;
          if (!(e_0 instanceof CancellationException)) {
            tmp = !isInterface(e_0, ServerDrivenConfigurationTransparentException);
          } else {
            tmp = false;
          }
          if (tmp) {
            printStackTrace(e_0);
          }
          throw e_0;
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }
  *w6l(element, isOnlyForTeam, $completion) {
    yield* this.f94(ServerDrivenConfigurationKrpc$pingElement$slambda(element, isOnlyForTeam), $completion);
    return Unit_instance;
  }
  *x6l($completion) {
    return yield* this.f94(ServerDrivenConfigurationKrpc$requestGamePresence$slambda(), $completion);
  }
  *z6l($completion) {
    yield* this.f94(ServerDrivenConfigurationKrpc$reloadGame$slambda(), $completion);
    return Unit_instance;
  }
  *a6m(gameCode, $completion) {
    yield* this.f94(ServerDrivenConfigurationKrpc$reloadGameByCode$slambda(gameCode), $completion);
    return Unit_instance;
  }
  *y6l($completion) {
    var token = yield* this.f94(ServerDrivenConfigurationKrpc$requestRevertTurn$slambda(), $completion);
    var tmp;
    if (token instanceof InternalRevertRequestTokenError) {
      tmp = new InternalRevertError(token.v95_1);
    } else {
      if (token instanceof RevertRequestToken) {
        tmp = yield* this.f94(ServerDrivenConfigurationKrpc$requestRevertTurn$slambda_0(token), $completion);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  *b6m($completion) {
    var result = yield* this.f94(ServerDrivenConfigurationKrpc$startMasterFixingEvents$slambda(), $completion);
    switch (result.w1_1) {
      case 0:
        break;
      case 1:
        // Inline function 'kotlin.error' call

        var message = 'Master fixing was not approved: the other team declined, the request expired, or the game is unavailable';
        throw IllegalStateException.o(toString(message));
      case 2:
        // Inline function 'kotlin.error' call

        var message_0 = 'Master fixing is forbidden during parallel draft';
        throw IllegalStateException.o(toString(message_0));
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  }
  *c6m(revision, errorMessage, clientStackTrace, $completion) {
    yield* this.f94(ServerDrivenConfigurationKrpc$submitGameStateError$slambda(revision, errorMessage, clientStackTrace), $completion);
    return Unit_instance;
  }
  f5c(warning, cause) {
    return this.u92_1.f5c(warning, cause);
  }
}
class InteractionServerException {}
class ServerHasAnotherVersionError extends IllegalStateException {
  constructor(serverVersion) {
    return new.target.r95(serverVersion);
  }
  static r95(serverVersion) {
    var $this = this.o('Server has another version: ' + serverVersion);
    captureStack($this, $this.q95_1);
    return $this;
  }
}
class ServerDuelGameSetupKrpc {
  constructor(serverDrivenConfiguration, setupId) {
    this.o96_1 = serverDrivenConfiguration;
    this.p96_1 = setupId;
    this.q96_1 = null;
    this.r96_1 = null;
    this.s96_1 = null;
    this.t96_1 = null;
    this.u96_1 = null;
    var tmp = this;
    tmp.v96_1 = ServerDuelGameSetupKrpc$onReconnectWhenSubmitting$slambda(this);
  }
  d97() {
    return this.p96_1.m96_1;
  }
  e97() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.p96_1.l96_1;
    var tmp;
    var tmp_0;
    if (!this.f97()) {
      // Inline function 'kotlin.text.isNotBlank' call
      tmp_0 = !isBlank(this_0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  f97() {
    return this.p96_1.n96_1;
  }
  *g97(gameContentVersion, $completion) {
    this.q96_1 = gameContentVersion;
    yield* this.o96_1.p94(this.v96_1, ServerDuelGameSetupKrpc$submitGameContentVersion$slambda(this, gameContentVersion), $completion);
    return Unit_instance;
  }
  *h97(rules, $completion) {
    var tmp = this;
    var tmp1_elvis_lhs = rules == null ? null : get_gameContentVersion(rules);
    tmp.q96_1 = tmp1_elvis_lhs == null ? this.q96_1 : tmp1_elvis_lhs;
    this.r96_1 = rules;
    yield* this.o96_1.p94(this.v96_1, ServerDuelGameSetupKrpc$submitContract$slambda(this, rules), $completion);
    return Unit_instance;
  }
  *i97(gameTeam, $completion) {
    this.s96_1 = gameTeam;
    yield* this.o96_1.p94(this.v96_1, ServerDuelGameSetupKrpc$submitGameTeam$slambda(this, gameTeam), $completion);
    return Unit_instance;
  }
  *j97(isRecordingGameMode, $completion) {
    this.t96_1 = isRecordingGameMode;
    yield* this.o96_1.p94(this.v96_1, ServerDuelGameSetupKrpc$submitIsRecordingGameMode$slambda(this, isRecordingGameMode), $completion);
    return Unit_instance;
  }
  *k97(isPubliclyObserved, $completion) {
    this.u96_1 = isPubliclyObserved;
    yield* this.o96_1.p94(this.v96_1, ServerDuelGameSetupKrpc$submitIsPubliclyObserved$slambda(this, isPubliclyObserved), $completion);
    return Unit_instance;
  }
  *l97($completion) {
    var onReconnectForStartAttempt = ServerDuelGameSetupKrpc$startGame$slambda(this);
    return yield* this.o96_1.p94(onReconnectForStartAttempt, ServerDuelGameSetupKrpc$startGame$slambda_0(this), $completion);
  }
  *m97(updater, $completion) {
    var onReconnectWhenReceiving = ServerDuelGameSetupKrpc$processUpdatesFromServer$slambda(this);
    $l$loop: while (true) {
      var requestSetupUpdate = yield* this.o96_1.p94(onReconnectWhenReceiving, ServerDuelGameSetupKrpc$processUpdatesFromServer$slambda_0(this), $completion);
      yield* updater(requestSetupUpdate, $completion);
      var tmp;
      if (requestSetupUpdate instanceof GameStarted) {
        tmp = true;
      } else {
        tmp = requestSetupUpdate instanceof SetupEnded;
      }
      if (tmp) {
        break $l$loop;
      }
    }
    return Unit_instance;
  }
}
class FullGameReplayDriverImpl {
  constructor(agentMap, fullReplay, diagnostics) {
    this.n97_1 = diagnostics;
    this.o97_1 = agentMap;
    this.p97_1 = fullReplay;
    this.q97_1 = createReplayTimeline(this, this.p97_1);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.s97_1 = ArrayList.p2();
    this.t97_1 = Mutex();
    this.u97_1 = 0;
    this.v97_1 = null;
  }
  z97() {
    return this.q97_1;
  }
  x97() {
    var tmp = this.r97_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('currentGameState');
    }
  }
  y97() {
    var tmp = this.w97_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('shouldContinueDeferred');
    }
  }
  *a98(revertCallback, $completion) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this.t97_1;
    yield* this_0.y2a(null, $completion);
    try {
      var job = this.v97_1;
      if (job == null || !job.e1m() || this.u97_1 < 1) {
        return Unit_instance;
      }
      job.o1n();
      this.v97_1 = null;
      var isFirstRevert = {_v: true};
      yield* revertCallback(FullGameReplayDriverImpl$performRevertStates$slambda(isFirstRevert, this), $completion);
      if (!this.y97().z1m()) {
        this.y97().l1t(true);
      }
    }finally {
      this_0.k2a(null);
    }
    return Unit_instance;
  }
  *v6t($completion) {
    $l$loop_0: while (true) {
      // Inline function 'kotlinx.coroutines.sync.withLock' call
      var this_0 = this.t97_1;
      yield* this_0.y2a(null, $completion);
      var tmp;
      try {
        if (this.u97_1 >= this.p97_1.s2())
          break $l$loop_0;
        var info = this.p97_1.u2(this.u97_1);
        var tmp0_safe_receiver = info instanceof GameNotificationInfo ? info : null;
        var notification = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u93_1;
        if (!(notification == null)) {
          var checkInfo = notification.y3p_1;
          var event = notification.x3p_1;
          if (event instanceof InitGameStateEvent) {
            this.r97_1 = event.a54_1.y4l();
            this.s97_1.d2(new RevertStateData(emptyList(), 0, null));
          } else {
            // Inline function 'kotlin.require' call
            if (!(checkInfo == null || checkInfo.d3q_1 === this.x97().g38_1)) {
              var message = 'Check info revision ' + (checkInfo == null ? null : checkInfo.d3q_1) + ' is not equal to current revision ' + this.x97().g38_1;
              throw IllegalArgumentException.h2(toString(message));
            }
            var oldCheckCode = calculateCheckCode(this.x97());
            // Inline function 'kotlin.with' call
            var $this$with = this.x97();
            var changes = withStateRuntime(this, $this$with, FullGameReplayDriverImpl$performGameReplay$lambda(event));
            // Inline function 'kotlin.collections.mutableListOf' call
            var revertChanges = ArrayList.p2();
            var _iterator__ex2g4s = changes.p1();
            while (_iterator__ex2g4s.q1()) {
              var change = _iterator__ex2g4s.r1();
              revertChanges.d2(change.n37($this$with));
              apply($this$with, change);
            }
            this.s97_1.d2(new RevertStateData(reversed(revertChanges), this.x97().g38_1, oldCheckCode));
            if (!(checkInfo == null)) {
              this.x97().g38_1 = checkInfo.e3q_1;
              var checkCode = calculateCheckCode(this.x97());
              // Inline function 'kotlin.require' call
              if (!checkInfo.f3q_1.equals(checkCode)) {
                var message_0 = 'Check code from server = ' + checkInfo.f3q_1.toString() + ' is not equal to local ' + checkCode.toString();
                throw IllegalArgumentException.h2(toString(message_0));
              }
            }
          }
        }
        tmp = info;
      }finally {
        this_0.k2a(null);
      }
      var info_0 = tmp;
      var shouldContinue = yield* coroutineScope(FullGameReplayDriverImpl$performGameReplay$slambda(this, info_0), $completion);
      if (!shouldContinue)
        break $l$loop_0;
    }
    return Unit_instance;
  }
  f5c(warning, cause) {
    return this.n97_1.f5c(warning, cause);
  }
}
class SandboxAccessDeniedException extends IllegalStateException {
  constructor() {
    return new.target.a96();
  }
  static a96() {
    var $this = this.o('Sandbox access is not allowed');
    captureStack($this, $this.z95_1);
    return $this;
  }
}
class BeastAuthenticationRequiredException extends IllegalStateException {
  constructor() {
    return new.target.f96();
  }
  static f96() {
    var $this = this.o('Authentication required');
    captureStack($this, $this.e96_1);
    return $this;
  }
}
class WrappedServerError extends IllegalStateException {
  constructor(messageFromServer) {
    return new.target.k96(messageFromServer);
  }
  static k96(messageFromServer) {
    var $this = this.o('Server Internal Error: ' + messageFromServer);
    captureStack($this, $this.j96_1);
    return $this;
  }
}
class TranslatedServerError extends IllegalStateException {
  constructor(messageFromServer) {
    return new.target.f98(messageFromServer);
  }
  static f98(messageFromServer) {
    var $this = this.o('Server Error: ' + messageFromServer);
    captureStack($this, $this.e98_1);
    return $this;
  }
}
class GameSessionIsCanceledException extends IllegalStateException {
  constructor() {
    return new.target.w98();
  }
  static w98() {
    var $this = this.o('Session canceled');
    captureStack($this, $this.v98_1);
    return $this;
  }
}
class GameSessionFailedException extends IllegalStateException {
  constructor(message) {
    return new.target.b99(message);
  }
  static b99(message) {
    message = message === VOID ? 'Session failed' : message;
    var $this = this.o(message);
    captureStack($this, $this.a99_1);
    return $this;
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0 {
  constructor(function_0) {
    this.c99_1 = function_0;
  }
  p5() {
    return this.c99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_0 {
  constructor(function_0) {
    this.d99_1 = function_0;
  }
  p5() {
    return this.d99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_1 {
  constructor(function_0) {
    this.e99_1 = function_0;
  }
  p5() {
    return this.e99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_2 {
  constructor(function_0) {
    this.f99_1 = function_0;
  }
  p5() {
    return this.f99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_3 {
  constructor(function_0) {
    this.g99_1 = function_0;
  }
  p5() {
    return this.g99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_4 {
  constructor(function_0) {
    this.h99_1 = function_0;
  }
  p5() {
    return this.h99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_5 {
  constructor(function_0) {
    this.i99_1 = function_0;
  }
  p5() {
    return this.i99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_6 {
  constructor(function_0) {
    this.j99_1 = function_0;
  }
  p5() {
    return this.j99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_7 {
  constructor(function_0) {
    this.k99_1 = function_0;
  }
  p5() {
    return this.k99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_8 {
  constructor(function_0) {
    this.l99_1 = function_0;
  }
  p5() {
    return this.l99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_9 {
  constructor(function_0) {
    this.m99_1 = function_0;
  }
  p5() {
    return this.m99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_10 {
  constructor(function_0) {
    this.n99_1 = function_0;
  }
  p5() {
    return this.n99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_11 {
  constructor(function_0) {
    this.o99_1 = function_0;
  }
  p5() {
    return this.o99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_12 {
  constructor(function_0) {
    this.p99_1 = function_0;
  }
  p5() {
    return this.p99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_13 {
  constructor(function_0) {
    this.q99_1 = function_0;
  }
  p5() {
    return this.q99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_14 {
  constructor(function_0) {
    this.r99_1 = function_0;
  }
  p5() {
    return this.r99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_15 {
  constructor(function_0) {
    this.s99_1 = function_0;
  }
  p5() {
    return this.s99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_16 {
  constructor(function_0) {
    this.t99_1 = function_0;
  }
  p5() {
    return this.t99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_17 {
  constructor(function_0) {
    this.u99_1 = function_0;
  }
  p5() {
    return this.u99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_18 {
  constructor(function_0) {
    this.v99_1 = function_0;
  }
  p5() {
    return this.v99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_19 {
  constructor(function_0) {
    this.w99_1 = function_0;
  }
  p5() {
    return this.w99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_20 {
  constructor(function_0) {
    this.x99_1 = function_0;
  }
  p5() {
    return this.x99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_21 {
  constructor(function_0) {
    this.y99_1 = function_0;
  }
  p5() {
    return this.y99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_22 {
  constructor(function_0) {
    this.z99_1 = function_0;
  }
  p5() {
    return this.z99_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_23 {
  constructor(function_0) {
    this.a9a_1 = function_0;
  }
  p5() {
    return this.a9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_24 {
  constructor(function_0) {
    this.b9a_1 = function_0;
  }
  p5() {
    return this.b9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_25 {
  constructor(function_0) {
    this.c9a_1 = function_0;
  }
  p5() {
    return this.c9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_26 {
  constructor(function_0) {
    this.d9a_1 = function_0;
  }
  p5() {
    return this.d9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_27 {
  constructor(function_0) {
    this.e9a_1 = function_0;
  }
  p5() {
    return this.e9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_28 {
  constructor(function_0) {
    this.f9a_1 = function_0;
  }
  p5() {
    return this.f9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_29 {
  constructor(function_0) {
    this.g9a_1 = function_0;
  }
  p5() {
    return this.g9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_30 {
  constructor(function_0) {
    this.h9a_1 = function_0;
  }
  p5() {
    return this.h9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_31 {
  constructor(function_0) {
    this.i9a_1 = function_0;
  }
  p5() {
    return this.i9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_32 {
  constructor(function_0) {
    this.j9a_1 = function_0;
  }
  p5() {
    return this.j9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_33 {
  constructor(function_0) {
    this.k9a_1 = function_0;
  }
  p5() {
    return this.k9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_34 {
  constructor(function_0) {
    this.l9a_1 = function_0;
  }
  p5() {
    return this.l9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_35 {
  constructor(function_0) {
    this.m9a_1 = function_0;
  }
  p5() {
    return this.m9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_36 {
  constructor(function_0) {
    this.n9a_1 = function_0;
  }
  p5() {
    return this.n9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_37 {
  constructor(function_0) {
    this.o9a_1 = function_0;
  }
  p5() {
    return this.o9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_38 {
  constructor(function_0) {
    this.p9a_1 = function_0;
  }
  p5() {
    return this.p9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_39 {
  constructor(function_0) {
    this.q9a_1 = function_0;
  }
  p5() {
    return this.q9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_40 {
  constructor(function_0) {
    this.r9a_1 = function_0;
  }
  p5() {
    return this.r9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_41 {
  constructor(function_0) {
    this.s9a_1 = function_0;
  }
  p5() {
    return this.s9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_42 {
  constructor(function_0) {
    this.t9a_1 = function_0;
  }
  p5() {
    return this.t9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_43 {
  constructor(function_0) {
    this.u9a_1 = function_0;
  }
  p5() {
    return this.u9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_44 {
  constructor(function_0) {
    this.v9a_1 = function_0;
  }
  p5() {
    return this.v9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_45 {
  constructor(function_0) {
    this.w9a_1 = function_0;
  }
  p5() {
    return this.w9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_46 {
  constructor(function_0) {
    this.x9a_1 = function_0;
  }
  p5() {
    return this.x9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_47 {
  constructor(function_0) {
    this.y9a_1 = function_0;
  }
  p5() {
    return this.y9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_48 {
  constructor(function_0) {
    this.z9a_1 = function_0;
  }
  p5() {
    return this.z9a_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_49 {
  constructor(function_0) {
    this.a9b_1 = function_0;
  }
  p5() {
    return this.a9b_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Method) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_3 = this;
    this.b9b_1 = 'steelart.beast.network.BeastServerInteraction';
    var tmp = this;
    var tmp_0 = BeastServerInteraction$$rpcServiceStub$Companion$serverMessagesInvokator$slambda();
    tmp.c9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0(tmp_0);
    var tmp_1 = this;
    var tmp_2 = BeastServerInteraction$$rpcServiceStub$Companion$requestServerVersionInvokator$slambda();
    tmp_1.d9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_0(tmp_2);
    var tmp_3 = this;
    var tmp_4 = BeastServerInteraction$$rpcServiceStub$Companion$requestAuthenticationCapabilitiesInvokator$slambda();
    tmp_3.e9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_1(tmp_4);
    var tmp_5 = this;
    var tmp_6 = BeastServerInteraction$$rpcServiceStub$Companion$loginWithAccessCodeInvokator$slambda();
    tmp_5.f9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_2(tmp_6);
    var tmp_7 = this;
    var tmp_8 = BeastServerInteraction$$rpcServiceStub$Companion$restoreSessionInvokator$slambda();
    tmp_7.g9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_3(tmp_8);
    var tmp_9 = this;
    var tmp_10 = BeastServerInteraction$$rpcServiceStub$Companion$logoutInvokator$slambda();
    tmp_9.h9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_4(tmp_10);
    var tmp_11 = this;
    var tmp_12 = BeastServerInteraction$$rpcServiceStub$Companion$getUserSettingsInvokator$slambda();
    tmp_11.i9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_5(tmp_12);
    var tmp_13 = this;
    var tmp_14 = BeastServerInteraction$$rpcServiceStub$Companion$patchUserSettingsInvokator$slambda();
    tmp_13.j9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_6(tmp_14);
    var tmp_15 = this;
    var tmp_16 = BeastServerInteraction$$rpcServiceStub$Companion$resetUserSettingsInvokator$slambda();
    tmp_15.k9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_7(tmp_16);
    var tmp_17 = this;
    var tmp_18 = BeastServerInteraction$$rpcServiceStub$Companion$resetCommunicationInvokator$slambda();
    tmp_17.l9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_8(tmp_18);
    var tmp_19 = this;
    var tmp_20 = BeastServerInteraction$$rpcServiceStub$Companion$getActiveGameSessionsInvokator$slambda();
    tmp_19.m9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_9(tmp_20);
    var tmp_21 = this;
    var tmp_22 = BeastServerInteraction$$rpcServiceStub$Companion$requestLobbyListInvokator$slambda();
    tmp_21.n9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_10(tmp_22);
    var tmp_23 = this;
    var tmp_24 = BeastServerInteraction$$rpcServiceStub$Companion$createNewGameInvokator$slambda();
    tmp_23.o9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_11(tmp_24);
    var tmp_25 = this;
    var tmp_26 = BeastServerInteraction$$rpcServiceStub$Companion$connectNewGameInvokator$slambda();
    tmp_25.p9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_12(tmp_26);
    var tmp_27 = this;
    var tmp_28 = BeastServerInteraction$$rpcServiceStub$Companion$reconnectGameInvokator$slambda();
    tmp_27.q9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_13(tmp_28);
    var tmp_29 = this;
    var tmp_30 = BeastServerInteraction$$rpcServiceStub$Companion$cancelGameInvokator$slambda();
    tmp_29.r9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_14(tmp_30);
    var tmp_31 = this;
    var tmp_32 = BeastServerInteraction$$rpcServiceStub$Companion$setGameContentVersionInvokator$slambda();
    tmp_31.s9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_15(tmp_32);
    var tmp_33 = this;
    var tmp_34 = BeastServerInteraction$$rpcServiceStub$Companion$setGameContractInvokator$slambda();
    tmp_33.t9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_16(tmp_34);
    var tmp_35 = this;
    var tmp_36 = BeastServerInteraction$$rpcServiceStub$Companion$setGameTeamInvokator$slambda();
    tmp_35.u9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_17(tmp_36);
    var tmp_37 = this;
    var tmp_38 = BeastServerInteraction$$rpcServiceStub$Companion$setRecordingGameModeInvokator$slambda();
    tmp_37.v9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_18(tmp_38);
    var tmp_39 = this;
    var tmp_40 = BeastServerInteraction$$rpcServiceStub$Companion$setPubliclyObservedInvokator$slambda();
    tmp_39.w9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_19(tmp_40);
    var tmp_41 = this;
    var tmp_42 = BeastServerInteraction$$rpcServiceStub$Companion$startGameInvokator$slambda();
    tmp_41.x9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_20(tmp_42);
    var tmp_43 = this;
    var tmp_44 = BeastServerInteraction$$rpcServiceStub$Companion$requestSetupUpdateInvokator$slambda();
    tmp_43.y9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_21(tmp_44);
    var tmp_45 = this;
    var tmp_46 = BeastServerInteraction$$rpcServiceStub$Companion$prepareSandboxSessionInvokator$slambda();
    tmp_45.z9b_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_22(tmp_46);
    var tmp_47 = this;
    var tmp_48 = BeastServerInteraction$$rpcServiceStub$Companion$initSandboxGameInvokator$slambda();
    tmp_47.a9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_23(tmp_48);
    var tmp_49 = this;
    var tmp_50 = BeastServerInteraction$$rpcServiceStub$Companion$applyEventForSandboxInitInvokator$slambda();
    tmp_49.b9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_24(tmp_50);
    var tmp_51 = this;
    var tmp_52 = BeastServerInteraction$$rpcServiceStub$Companion$startSandboxGameInvokator$slambda();
    tmp_51.c9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_25(tmp_52);
    var tmp_53 = this;
    var tmp_54 = BeastServerInteraction$$rpcServiceStub$Companion$reconnectSandboxGameInvokator$slambda();
    tmp_53.d9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_26(tmp_54);
    var tmp_55 = this;
    var tmp_56 = BeastServerInteraction$$rpcServiceStub$Companion$requestInfoInvokator$slambda();
    tmp_55.e9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_27(tmp_56);
    var tmp_57 = this;
    var tmp_58 = BeastServerInteraction$$rpcServiceStub$Companion$requestGamePresenceInvokator$slambda();
    tmp_57.f9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_28(tmp_58);
    var tmp_59 = this;
    var tmp_60 = BeastServerInteraction$$rpcServiceStub$Companion$submitAnswerInvokator$slambda();
    tmp_59.g9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_29(tmp_60);
    var tmp_61 = this;
    var tmp_62 = BeastServerInteraction$$rpcServiceStub$Companion$startMasterFixingEventsInvokator$slambda();
    tmp_61.h9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_30(tmp_62);
    var tmp_63 = this;
    var tmp_64 = BeastServerInteraction$$rpcServiceStub$Companion$approveMasterFixingInvokator$slambda();
    tmp_63.i9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_31(tmp_64);
    var tmp_65 = this;
    var tmp_66 = BeastServerInteraction$$rpcServiceStub$Companion$approveRevertInvokator$slambda();
    tmp_65.j9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_32(tmp_66);
    var tmp_67 = this;
    var tmp_68 = BeastServerInteraction$$rpcServiceStub$Companion$submitMasterFixingEventInvokator$slambda();
    tmp_67.k9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_33(tmp_68);
    var tmp_69 = this;
    var tmp_70 = BeastServerInteraction$$rpcServiceStub$Companion$pingElementInvokator$slambda();
    tmp_69.l9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_34(tmp_70);
    var tmp_71 = this;
    var tmp_72 = BeastServerInteraction$$rpcServiceStub$Companion$getRevertRequestTokenInvokator$slambda();
    tmp_71.m9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_35(tmp_72);
    var tmp_73 = this;
    var tmp_74 = BeastServerInteraction$$rpcServiceStub$Companion$requestRevertTurnInvokator$slambda();
    tmp_73.n9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_36(tmp_74);
    var tmp_75 = this;
    var tmp_76 = BeastServerInteraction$$rpcServiceStub$Companion$reloadGameInvokator$slambda();
    tmp_75.o9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_37(tmp_76);
    var tmp_77 = this;
    var tmp_78 = BeastServerInteraction$$rpcServiceStub$Companion$reloadGameByCodeInvokator$slambda();
    tmp_77.p9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_38(tmp_78);
    var tmp_79 = this;
    var tmp_80 = BeastServerInteraction$$rpcServiceStub$Companion$submitGameStateErrorInvokator$slambda();
    tmp_79.q9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_39(tmp_80);
    var tmp_81 = this;
    var tmp_82 = BeastServerInteraction$$rpcServiceStub$Companion$requestCompletedGamesInvokator$slambda();
    tmp_81.r9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_40(tmp_82);
    var tmp_83 = this;
    var tmp_84 = BeastServerInteraction$$rpcServiceStub$Companion$requestSandboxGamesInvokator$slambda();
    tmp_83.s9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_41(tmp_84);
    var tmp_85 = this;
    var tmp_86 = BeastServerInteraction$$rpcServiceStub$Companion$getCompletedGameInvokator$slambda();
    tmp_85.t9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_42(tmp_86);
    var tmp_87 = this;
    var tmp_88 = BeastServerInteraction$$rpcServiceStub$Companion$locateRetainedResourceInvokator$slambda();
    tmp_87.u9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_43(tmp_88);
    var tmp_89 = this;
    var tmp_90 = BeastServerInteraction$$rpcServiceStub$Companion$requestFullReplayInvokator$slambda();
    tmp_89.v9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_44(tmp_90);
    var tmp_91 = this;
    var tmp_92 = BeastServerInteraction$$rpcServiceStub$Companion$shareSandboxReplayInvokator$slambda();
    tmp_91.w9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_45(tmp_92);
    var tmp_93 = this;
    var tmp_94 = BeastServerInteraction$$rpcServiceStub$Companion$shareFullGameReplayInvokator$slambda();
    tmp_93.x9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_46(tmp_94);
    var tmp_95 = this;
    var tmp_96 = BeastServerInteraction$$rpcServiceStub$Companion$requestPendingReplayConsentsInvokator$slambda();
    tmp_95.y9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_47(tmp_96);
    var tmp_97 = this;
    var tmp_98 = BeastServerInteraction$$rpcServiceStub$Companion$respondToReplayConsentInvokator$slambda();
    tmp_97.z9c_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_48(tmp_98);
    var tmp_99 = this;
    var tmp_100 = BeastServerInteraction$$rpcServiceStub$Companion$submitErrorInvokator$slambda();
    tmp_99.a9d_1 = new sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_49(tmp_100);
    var tmp_101 = this;
    var tmp_102 = new RpcTypeDefault(createKType(getKClass(KtSet), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ServerMessage), arrayOf([]), false))]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    var tmp_103 = to('serverMessages', new RpcCallableDefault('serverMessages', tmp_102, this.c9b_1, tmp$ret$0, true));
    var tmp_104 = new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    var tmp_105 = to('requestServerVersion', new RpcCallableDefault('requestServerVersion', tmp_104, this.d9b_1, tmp$ret$1, false));
    var tmp_106 = new RpcTypeDefault(createKType(getKClass(BeastAuthenticationCapabilities), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$2 = [];
    var tmp_107 = to('requestAuthenticationCapabilities', new RpcCallableDefault('requestAuthenticationCapabilities', tmp_106, this.e9b_1, tmp$ret$2, false));
    var tmp_108 = new RpcTypeDefault(createKType(getKClass(BeastLoginResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [new RpcParameterDefault('accessCode', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_109 = to('loginWithAccessCode', new RpcCallableDefault('loginWithAccessCode', tmp_108, this.f9b_1, tmp$ret$3, false));
    var tmp_110 = new RpcTypeDefault(createKType(getKClass(BeastSessionState), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$6 = [];
    var tmp_111 = to('restoreSession', new RpcCallableDefault('restoreSession', tmp_110, this.g9b_1, tmp$ret$6, false));
    var tmp_112 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$7 = [];
    var tmp_113 = to('logout', new RpcCallableDefault('logout', tmp_112, this.h9b_1, tmp$ret$7, false));
    var tmp_114 = new RpcTypeDefault(createKType(getKClass(BeastUserSettingValues), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$8 = [];
    var tmp_115 = to('getUserSettings', new RpcCallableDefault('getUserSettings', tmp_114, this.i9b_1, tmp$ret$8, false));
    var tmp_116 = new RpcTypeDefault(createKType(getKClass(BeastUserSettingValues), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [new RpcParameterDefault('patch', new RpcTypeDefault(createKType(getKClass(BeastUserSettingsPatch), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_117 = to('patchUserSettings', new RpcCallableDefault('patchUserSettings', tmp_116, this.j9b_1, tmp$ret$9, false));
    var tmp_118 = new RpcTypeDefault(createKType(getKClass(BeastUserSettingValues), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$12 = [];
    var tmp_119 = to('resetUserSettings', new RpcCallableDefault('resetUserSettings', tmp_118, this.k9b_1, tmp$ret$12, false));
    var tmp_120 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$13 = [];
    var tmp_121 = to('resetCommunication', new RpcCallableDefault('resetCommunication', tmp_120, this.l9b_1, tmp$ret$13, false));
    var tmp_122 = new RpcTypeDefault(createKType(getKClass(ActiveGameSessions), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$14 = [];
    var tmp_123 = to('getActiveGameSessions', new RpcCallableDefault('getActiveGameSessions', tmp_122, this.m9b_1, tmp$ret$14, false));
    var tmp_124 = new RpcTypeDefault(createKType(getKClass(LobbyList), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$15 = [];
    var tmp_125 = to('requestLobbyList', new RpcCallableDefault('requestLobbyList', tmp_124, this.n9b_1, tmp$ret$15, false));
    var tmp_126 = new RpcTypeDefault(createKType(getKClass(ConnectNewGameResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$16 = [new RpcParameterDefault('gameName', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true), emptyList()), false, emptyList())];
    var tmp_127 = to('createNewGame', new RpcCallableDefault('createNewGame', tmp_126, this.o9b_1, tmp$ret$16, false));
    var tmp_128 = new RpcTypeDefault(createKType(getKClass(ConnectNewGameResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$19 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_129 = to('connectNewGame', new RpcCallableDefault('connectNewGame', tmp_128, this.p9b_1, tmp$ret$19, false));
    var tmp_130 = new RpcTypeDefault(createKType(getKClass(ResumeDuelGameResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$22 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('gameTeam', new RpcTypeDefault(createKType(getKClass(GameTeam), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('lastSeenInfoSourceCursor', new RpcTypeDefault(createKType(getKClass(InfoSourceCursor), arrayOf([]), true), emptyList()), false, emptyList())];
    var tmp_131 = to('reconnectGame', new RpcCallableDefault('reconnectGame', tmp_130, this.q9b_1, tmp$ret$22, false));
    var tmp_132 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$25 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_133 = to('cancelGame', new RpcCallableDefault('cancelGame', tmp_132, this.r9b_1, tmp$ret$25, false));
    var tmp_134 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$28 = [new RpcParameterDefault('setupId', new RpcTypeDefault(createKType(getKClass(GameSetupId), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('gameContentVersion', new RpcTypeDefault(createKType(getKClass(GameContentVersion), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_135 = to('setGameContentVersion', new RpcCallableDefault('setGameContentVersion', tmp_134, this.s9b_1, tmp$ret$28, false));
    var tmp_136 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$31 = [new RpcParameterDefault('setupId', new RpcTypeDefault(createKType(getKClass(GameSetupId), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('gameRules', new RpcTypeDefault(createKType(getKClass(GameRules), arrayOf([]), true), emptyList()), false, emptyList())];
    var tmp_137 = to('setGameContract', new RpcCallableDefault('setGameContract', tmp_136, this.t9b_1, tmp$ret$31, false));
    var tmp_138 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$34 = [new RpcParameterDefault('setupId', new RpcTypeDefault(createKType(getKClass(GameSetupId), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('gameTeam', new RpcTypeDefault(createKType(getKClass(GameTeam), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_139 = to('setGameTeam', new RpcCallableDefault('setGameTeam', tmp_138, this.u9b_1, tmp$ret$34, false));
    var tmp_140 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$37 = [new RpcParameterDefault('setupId', new RpcTypeDefault(createKType(getKClass(GameSetupId), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('isRecordingGameMode', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_141 = to('setRecordingGameMode', new RpcCallableDefault('setRecordingGameMode', tmp_140, this.v9b_1, tmp$ret$37, false));
    var tmp_142 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$40 = [new RpcParameterDefault('setupId', new RpcTypeDefault(createKType(getKClass(GameSetupId), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('isPubliclyObserved', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_143 = to('setPubliclyObserved', new RpcCallableDefault('setPubliclyObserved', tmp_142, this.w9b_1, tmp$ret$40, false));
    var tmp_144 = new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$43 = [new RpcParameterDefault('setupId', new RpcTypeDefault(createKType(getKClass(GameSetupId), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_145 = to('startGame', new RpcCallableDefault('startGame', tmp_144, this.x9b_1, tmp$ret$43, false));
    var tmp_146 = new RpcTypeDefault(createKType(getKClass(SetupUpdateFromServer), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$46 = [new RpcParameterDefault('setupId', new RpcTypeDefault(createKType(getKClass(GameSetupId), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_147 = to('requestSetupUpdate', new RpcCallableDefault('requestSetupUpdate', tmp_146, this.y9b_1, tmp$ret$46, false));
    var tmp_148 = new RpcTypeDefault(createKType(getKClass(BeastClientConfiguration), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$49 = [];
    var tmp_149 = to('prepareSandboxSession', new RpcCallableDefault('prepareSandboxSession', tmp_148, this.z9b_1, tmp$ret$49, false));
    var tmp_150 = new RpcTypeDefault(createKType(getKClass(InitSandboxResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$50 = [new RpcParameterDefault('gameSetupState', new RpcTypeDefault(createKType(getKClass(GameSetupState), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_151 = to('initSandboxGame', new RpcCallableDefault('initSandboxGame', tmp_150, this.a9c_1, tmp$ret$50, false));
    var tmp_152 = new RpcTypeDefault(createKType(getKClass(SandboxInitApplyEventResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$53 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('applyingEventNumber', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('checkCodeBeforeEvent', new RpcTypeDefault(createKType(getKClass(GameStateCheckCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('event', new RpcTypeDefault(createKType(getKClass(GameStateEvent), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_153 = to('applyEventForSandboxInit', new RpcCallableDefault('applyEventForSandboxInit', tmp_152, this.b9c_1, tmp$ret$53, false));
    var tmp_154 = new RpcTypeDefault(createKType(getKClass(StartSandboxResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$56 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('checkCode', new RpcTypeDefault(createKType(getKClass(GameStateCheckCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('eventsNumber', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('startParams', new RpcTypeDefault(createKType(getKClass(SandboxStartParams), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_155 = to('startSandboxGame', new RpcCallableDefault('startSandboxGame', tmp_154, this.c9c_1, tmp$ret$56, false));
    var tmp_156 = new RpcTypeDefault(createKType(getKClass(ReconnectSandboxResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$59 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_157 = to('reconnectSandboxGame', new RpcCallableDefault('reconnectSandboxGame', tmp_156, this.d9c_1, tmp$ret$59, false));
    var tmp_158 = new RpcTypeDefault(createKType(getKClass(InfoFromServer), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$62 = [];
    var tmp_159 = to('requestInfo', new RpcCallableDefault('requestInfo', tmp_158, this.e9c_1, tmp$ret$62, false));
    var tmp_160 = new RpcTypeDefault(createKType(getKClass(GamePresence), arrayOf([]), true), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$63 = [];
    var tmp_161 = to('requestGamePresence', new RpcCallableDefault('requestGamePresence', tmp_160, this.f9c_1, tmp$ret$63, false));
    var tmp_162 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$64 = [new RpcParameterDefault('infoSourceCursor', new RpcTypeDefault(createKType(getKClass(InfoSourceCursor), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('answerIndex', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_163 = to('submitAnswer', new RpcCallableDefault('submitAnswer', tmp_162, this.g9c_1, tmp$ret$64, false));
    var tmp_164 = new RpcTypeDefault(createKType(getKClass(StartMasterFixingResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$67 = [];
    var tmp_165 = to('startMasterFixingEvents', new RpcCallableDefault('startMasterFixingEvents', tmp_164, this.h9c_1, tmp$ret$67, false));
    var tmp_166 = new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$68 = [new RpcParameterDefault('requestId', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('approved', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_167 = to('approveMasterFixing', new RpcCallableDefault('approveMasterFixing', tmp_166, this.i9c_1, tmp$ret$68, false));
    var tmp_168 = new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$71 = [new RpcParameterDefault('requestId', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('approved', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_169 = to('approveRevert', new RpcCallableDefault('approveRevert', tmp_168, this.j9c_1, tmp$ret$71, false));
    var tmp_170 = new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$74 = [new RpcParameterDefault('masterFixingCommunicationId', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('event', new RpcTypeDefault(createKType(getKClass(GameStateEvent), arrayOf([]), true), emptyList()), false, emptyList())];
    var tmp_171 = to('submitMasterFixingEvent', new RpcCallableDefault('submitMasterFixingEvent', tmp_170, this.k9c_1, tmp$ret$74, false));
    var tmp_172 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$77 = [new RpcParameterDefault('element', new RpcTypeDefault(createKType(getKClass(PingElement), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('isOnlyForTeam', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_173 = to('pingElement', new RpcCallableDefault('pingElement', tmp_172, this.l9c_1, tmp$ret$77, false));
    var tmp_174 = new RpcTypeDefault(createKType(getKClass(RevertRequestTokenResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$80 = [];
    var tmp_175 = to('getRevertRequestToken', new RpcCallableDefault('getRevertRequestToken', tmp_174, this.m9c_1, tmp$ret$80, false));
    var tmp_176 = new RpcTypeDefault(createKType(getKClass(RequestRevertTurnResult), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$81 = [new RpcParameterDefault('revertToken', new RpcTypeDefault(createKType(getKClass(RevertRequestToken), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_177 = to('requestRevertTurn', new RpcCallableDefault('requestRevertTurn', tmp_176, this.n9c_1, tmp$ret$81, false));
    var tmp_178 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$84 = [];
    var tmp_179 = to('reloadGame', new RpcCallableDefault('reloadGame', tmp_178, this.o9c_1, tmp$ret$84, false));
    var tmp_180 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$85 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_181 = to('reloadGameByCode', new RpcCallableDefault('reloadGameByCode', tmp_180, this.p9c_1, tmp$ret$85, false));
    var tmp_182 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$88 = [new RpcParameterDefault('revision', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().ng(), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('errorMessage', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('clientStackTrace', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), true), emptyList()), false, emptyList())];
    var tmp_183 = to('submitGameStateError', new RpcCallableDefault('submitGameStateError', tmp_182, this.q9c_1, tmp$ret$88, false));
    var tmp_184 = new RpcTypeDefault(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CompletedGame), arrayOf([]), false))]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$91 = [];
    var tmp_185 = to('requestCompletedGames', new RpcCallableDefault('requestCompletedGames', tmp_184, this.r9c_1, tmp$ret$91, false));
    var tmp_186 = new RpcTypeDefault(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(CompletedGame), arrayOf([]), false))]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$92 = [];
    var tmp_187 = to('requestSandboxGames', new RpcCallableDefault('requestSandboxGames', tmp_186, this.s9c_1, tmp$ret$92, false));
    var tmp_188 = new RpcTypeDefault(createKType(getKClass(CompletedGame), arrayOf([]), true), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$93 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('isSandboxGame', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_189 = to('getCompletedGame', new RpcCallableDefault('getCompletedGame', tmp_188, this.t9c_1, tmp$ret$93, false));
    var tmp_190 = new RpcTypeDefault(createKType(getKClass(RetainedResourceHandoff), arrayOf([]), true), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$96 = [new RpcParameterDefault('request', new RpcTypeDefault(createKType(getKClass(BeastResourceLookupRequest), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_191 = to('locateRetainedResource', new RpcCallableDefault('locateRetainedResource', tmp_190, this.u9c_1, tmp$ret$96, false));
    var tmp_192 = new RpcTypeDefault(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(InfoFromServer), arrayOf([]), false))]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$99 = [new RpcParameterDefault('replayCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('isSandboxGame', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_193 = to('requestFullReplay', new RpcCallableDefault('requestFullReplay', tmp_192, this.v9c_1, tmp$ret$99, false));
    var tmp_194 = new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$102 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_195 = to('shareSandboxReplay', new RpcCallableDefault('shareSandboxReplay', tmp_194, this.w9c_1, tmp$ret$102, false));
    var tmp_196 = new RpcTypeDefault(createKType(getKClass(ReplaySharingStatus), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$105 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_197 = to('shareFullGameReplay', new RpcCallableDefault('shareFullGameReplay', tmp_196, this.x9c_1, tmp$ret$105, false));
    var tmp_198 = new RpcTypeDefault(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PendingReplayConsent), arrayOf([]), false))]), false), emptyList());
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$108 = [];
    var tmp_199 = to('requestPendingReplayConsents', new RpcCallableDefault('requestPendingReplayConsents', tmp_198, this.y9c_1, tmp$ret$108, false));
    var tmp_200 = new RpcTypeDefault(createKType(getKClass(ReplaySharingStatus), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$109 = [new RpcParameterDefault('gameCode', new RpcTypeDefault(createKType(getKClass(GameCode), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('approved', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false), emptyList()), false, emptyList())];
    var tmp_201 = to('respondToReplayConsent', new RpcCallableDefault('respondToReplayConsent', tmp_200, this.z9c_1, tmp$ret$109, false));
    var tmp_202 = new RpcTypeDefault(createKType(getKClass(Unit), arrayOf([]), false), emptyList());
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$112 = [new RpcParameterDefault('infoSourceCursor', new RpcTypeDefault(createKType(getKClass(InfoSourceCursor), arrayOf([]), false), emptyList()), false, emptyList()), new RpcParameterDefault('errorMessage', new RpcTypeDefault(createKType(PrimitiveClasses_getInstance().sg(), arrayOf([]), false), emptyList()), false, emptyList())];
    tmp_101.b9d_1 = mapOf([tmp_103, tmp_105, tmp_107, tmp_109, tmp_111, tmp_113, tmp_115, tmp_117, tmp_119, tmp_121, tmp_123, tmp_125, tmp_127, tmp_129, tmp_131, tmp_133, tmp_135, tmp_137, tmp_139, tmp_141, tmp_143, tmp_145, tmp_147, tmp_149, tmp_151, tmp_153, tmp_155, tmp_157, tmp_159, tmp_161, tmp_163, tmp_165, tmp_167, tmp_169, tmp_171, tmp_173, tmp_175, tmp_177, tmp_179, tmp_181, tmp_183, tmp_185, tmp_187, tmp_189, tmp_191, tmp_193, tmp_195, tmp_197, tmp_199, tmp_201, to('submitError', new RpcCallableDefault('submitError', tmp_202, this.a9d_1, tmp$ret$112, false))]);
  }
  l8n() {
    return this.b9b_1;
  }
  m8n(name) {
    return this.b9d_1.w4(name);
  }
  n8n(serviceId, client) {
    return new $rpcServiceStub(serviceId, client);
  }
}
class BeastServerInteraction {}
class $rpcServiceStub {
  constructor(__rpc_stub_id, __rpc_client) {
    Companion_getInstance_2();
    this.c9d_1 = __rpc_stub_id;
    this.d9d_1 = __rpc_client;
  }
  d94() {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.d9d_1.i90(new RpcCall(tmp, 'serverMessages', tmp$ret$0, this.c9d_1));
  }
  *e94($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestServerVersion', tmp$ret$0, this.c9d_1), $completion);
  }
  *c94($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestAuthenticationCapabilities', tmp$ret$0, this.c9d_1), $completion);
  }
  *u6k(accessCode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [accessCode];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'loginWithAccessCode', tmp$ret$0, this.c9d_1), $completion);
  }
  *v6k($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'restoreSession', tmp$ret$0, this.c9d_1), $completion);
  }
  *w6k($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'logout', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *x6k($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'getUserSettings', tmp$ret$0, this.c9d_1), $completion);
  }
  *y6k(patch, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [patch];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'patchUserSettings', tmp$ret$0, this.c9d_1), $completion);
  }
  *z6k($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'resetUserSettings', tmp$ret$0, this.c9d_1), $completion);
  }
  *c6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'resetCommunication', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *a6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'getActiveGameSessions', tmp$ret$0, this.c9d_1), $completion);
  }
  *b6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestLobbyList', tmp$ret$0, this.c9d_1), $completion);
  }
  *g94(gameName, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameName];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'createNewGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *h94(gameCode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'connectNewGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *f6l(gameCode, gameTeam, lastSeenInfoSourceCursor, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode, new GameTeam(gameTeam), lastSeenInfoSourceCursor];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'reconnectGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *h6l(gameCode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'cancelGame', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *w96(setupId, gameContentVersion, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [setupId, gameContentVersion];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'setGameContentVersion', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *x96(setupId, gameRules, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [setupId, gameRules];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'setGameContract', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *y96(setupId, gameTeam, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [setupId, new GameTeam(gameTeam)];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'setGameTeam', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *z96(setupId, isRecordingGameMode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [setupId, isRecordingGameMode];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'setRecordingGameMode', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *a97(setupId, isPubliclyObserved, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [setupId, isPubliclyObserved];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'setPubliclyObserved', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *b97(setupId, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [setupId];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'startGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *c97(setupId, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [setupId];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestSetupUpdate', tmp$ret$0, this.c9d_1), $completion);
  }
  *o6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'prepareSandboxSession', tmp$ret$0, this.c9d_1), $completion);
  }
  *k94(gameSetupState, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameSetupState];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'initSandboxGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *m94(gameCode, applyingEventNumber, checkCodeBeforeEvent, event, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode, applyingEventNumber, checkCodeBeforeEvent, event];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'applyEventForSandboxInit', tmp$ret$0, this.c9d_1), $completion);
  }
  *l94(gameCode, checkCode, eventsNumber, startParams, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode, checkCode, eventsNumber, startParams];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'startSandboxGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *t6l(gameCode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'reconnectSandboxGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *n94($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestInfo', tmp$ret$0, this.c9d_1), $completion);
  }
  *x6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestGamePresence', tmp$ret$0, this.c9d_1), $completion);
  }
  *o94(infoSourceCursor, answerIndex, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [infoSourceCursor, answerIndex];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'submitAnswer', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *i95($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'startMasterFixingEvents', tmp$ret$0, this.c9d_1), $completion);
  }
  *v94(requestId, approved, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [requestId, approved];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'approveMasterFixing', tmp$ret$0, this.c9d_1), $completion);
  }
  *b95(requestId, approved, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [requestId, approved];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'approveRevert', tmp$ret$0, this.c9d_1), $completion);
  }
  *s92(masterFixingCommunicationId, event, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [masterFixingCommunicationId, event];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'submitMasterFixingEvent', tmp$ret$0, this.c9d_1), $completion);
  }
  *w6l(element, isOnlyForTeam, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [element, isOnlyForTeam];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'pingElement', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *g95($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'getRevertRequestToken', tmp$ret$0, this.c9d_1), $completion);
  }
  *h95(revertToken, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [revertToken];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestRevertTurn', tmp$ret$0, this.c9d_1), $completion);
  }
  *z6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'reloadGame', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *a6m(gameCode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'reloadGameByCode', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *c6m(revision, errorMessage, clientStackTrace, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [revision, errorMessage, clientStackTrace];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'submitGameStateError', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
  *j6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestCompletedGames', tmp$ret$0, this.c9d_1), $completion);
  }
  *k6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestSandboxGames', tmp$ret$0, this.c9d_1), $completion);
  }
  *l6l(gameCode, isSandboxGame, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode, isSandboxGame];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'getCompletedGame', tmp$ret$0, this.c9d_1), $completion);
  }
  *m6l(request, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [request];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'locateRetainedResource', tmp$ret$0, this.c9d_1), $completion);
  }
  *i94(replayCode, isSandboxGame, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [replayCode, isSandboxGame];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestFullReplay', tmp$ret$0, this.c9d_1), $completion);
  }
  *j94(gameCode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'shareSandboxReplay', tmp$ret$0, this.c9d_1), $completion);
  }
  *q6l(gameCode, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'shareFullGameReplay', tmp$ret$0, this.c9d_1), $completion);
  }
  *r6l($completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'requestPendingReplayConsents', tmp$ret$0, this.c9d_1), $completion);
  }
  *s6l(gameCode, approved, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [gameCode, approved];
    return yield* this.d9d_1.h90(new RpcCall(tmp, 'respondToReplayConsent', tmp$ret$0, this.c9d_1), $completion);
  }
  *m93(infoSourceCursor, errorMessage, $completion) {
    var tmp = Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [infoSourceCursor, errorMessage];
    yield* this.d9d_1.h90(new RpcCall(tmp, 'submitError', tmp$ret$0, this.c9d_1), $completion);
    return Unit_instance;
  }
}
class Companion_1 {}
class $serializer_1 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ConnectNewGameResult.Connected', this, 1);
    tmp0_serialDesc.h1b('setupId', false);
    this.e9d_1 = tmp0_serialDesc;
  }
  f9d(encoder, value) {
    var tmp0_desc = this.e9d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_32(), value.h93_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f9d(encoder, value instanceof Connected ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e9d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_32(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_32(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return Connected.g9d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.e9d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_32()];
  }
}
class ConnectNewGameResult {}
class Connected {
  constructor(setupId) {
    this.h93_1 = setupId;
  }
  toString() {
    return 'Connected(setupId=' + this.h93_1.toString() + ')';
  }
  hashCode() {
    return this.h93_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Connected))
      return false;
    if (!this.h93_1.equals(other.h93_1))
      return false;
    return true;
  }
  static g9d(seen0, setupId, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_31().e9d_1);
    }
    var $this = createThis(this);
    $this.h93_1 = setupId;
    return $this;
  }
}
class GameWithSuchNameIsInProgress {
  constructor() {
    GameWithSuchNameIsInProgress_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h9d_1 = lazy(tmp_0, ConnectNewGameResult$GameWithSuchNameIsInProgress$_anonymous__2odg4u);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'GameWithSuchNameIsInProgress';
  }
  hashCode() {
    return -173071190;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWithSuchNameIsInProgress))
      return false;
    return true;
  }
}
class NotFound {
  constructor() {
    NotFound_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i9d_1 = lazy(tmp_0, ConnectNewGameResult$NotFound$_anonymous__ds3gix);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_0(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'NotFound';
  }
  hashCode() {
    return 1923011923;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NotFound))
      return false;
    return true;
  }
}
class Companion_2 {
  a2g() {
    var tmp = getKClass(ConnectNewGameResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Connected), getKClass(GameWithSuchNameIsInProgress), getKClass(NotFound)];
    var tmp_1 = $serializer_getInstance_31();
    var tmp_2 = GameWithSuchNameIsInProgress_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_3 = ObjectSerializer.l1c('steelart.beast.network.ConnectNewGameResult.GameWithSuchNameIsInProgress', tmp_2, tmp$ret$3);
    var tmp_4 = NotFound_getInstance_0();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_5 = [tmp_1, tmp_3, ObjectSerializer.l1c('steelart.beast.network.ConnectNewGameResult.NotFound', tmp_4, tmp$ret$6)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    return SealedClassSerializer.i10('steelart.beast.network.ConnectNewGameResult', tmp, tmp_0, tmp_5, tmp$ret$12);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_3 {}
class $serializer_2 {
  constructor() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.GameSetupId', this, 3);
    tmp0_serialDesc.h1b('gameName', false);
    tmp0_serialDesc.h1b('gameCode', false);
    tmp0_serialDesc.h1b('isPrivate', true);
    this.j9d_1 = tmp0_serialDesc;
  }
  k9d(encoder, value) {
    var tmp0_desc = this.j9d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.l96_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_0(), value.m96_1);
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !(value.n96_1 === false)) {
      tmp1_output.w14(tmp0_desc, 2, value.n96_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.k9d(encoder, value instanceof GameSetupId ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.j9d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return GameSetupId.l9d(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.j9d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_0(), BooleanSerializer_getInstance()];
  }
}
class GameSetupId {
  constructor(gameName, gameCode, isPrivate) {
    isPrivate = isPrivate === VOID ? false : isPrivate;
    this.l96_1 = gameName;
    this.m96_1 = gameCode;
    this.n96_1 = isPrivate;
  }
  toString() {
    return 'GameSetupId(gameName=' + this.l96_1 + ', gameCode=' + this.m96_1.toString() + ', isPrivate=' + this.n96_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.l96_1);
    result = imul(result, 31) + this.m96_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n96_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameSetupId))
      return false;
    if (!(this.l96_1 === other.l96_1))
      return false;
    if (!this.m96_1.equals(other.m96_1))
      return false;
    if (!(this.n96_1 === other.n96_1))
      return false;
    return true;
  }
  static l9d(seen0, gameName, gameCode, isPrivate, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_32().j9d_1);
    }
    var $this = createThis(this);
    $this.l96_1 = gameName;
    $this.m96_1 = gameCode;
    if (0 === (seen0 & 4))
      $this.n96_1 = false;
    else
      $this.n96_1 = isPrivate;
    return $this;
  }
}
class Companion_4 {
  a2g() {
    var tmp = getKClass(InfoFromServer);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(ChooseAnswerRequestFromServer), getKClass(GameNotificationInfo), getKClass(IncorrectServerStateForRequest), getKClass(MasterFixingApprovalRequest), getKClass(PingMessage), getKClass(RevertApprovalRequest), getKClass(RevertGameEventInfo), getKClass(SessionCanceled), getKClass(SessionEnded), getKClass(SessionFinished), getKClass(SessionReloadRequired), getKClass(StartMasterFixingEvents)];
    var tmp_1 = $serializer_getInstance_34();
    var tmp_2 = $serializer_getInstance_40();
    var tmp_3 = IncorrectServerStateForRequest_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_4 = ObjectSerializer.l1c('steelart.beast.network.IncorrectServerStateForRequest', tmp_3, tmp$ret$3);
    var tmp_5 = $serializer_getInstance_37();
    var tmp_6 = $serializer_getInstance_36();
    var tmp_7 = $serializer_getInstance_38();
    var tmp_8 = $serializer_getInstance_43();
    var tmp_9 = SessionCanceled_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_10 = ObjectSerializer.l1c('steelart.beast.network.SessionCanceled', tmp_9, tmp$ret$6);
    var tmp_11 = $serializer_getInstance_33();
    var tmp_12 = $serializer_getInstance_35();
    var tmp_13 = SessionReloadRequired_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_14 = [tmp_1, tmp_2, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_10, tmp_11, tmp_12, ObjectSerializer.l1c('steelart.beast.network.SessionReloadRequired', tmp_13, tmp$ret$9), $serializer_getInstance_39()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    return SealedClassSerializer.i10('steelart.beast.network.InfoFromServer', tmp, tmp_0, tmp_14, tmp$ret$15);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class InfoFromServer {}
class Companion_5 {
  constructor() {
    Companion_instance_8 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m9d_1 = [lazy(tmp_0, SessionEnded$Companion$$childSerializers$_anonymous__lsru5i), null, null];
  }
}
class $serializer_3 {
  constructor() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.SessionEnded', this, 3);
    tmp0_serialDesc.h1b('status', false);
    tmp0_serialDesc.h1b('errorMessage', true);
    tmp0_serialDesc.h1b('sourceCursor', true);
    this.n9d_1 = tmp0_serialDesc;
  }
  o9d(encoder, value) {
    var tmp0_desc = this.n9d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_7().m9d_1;
    tmp1_output.g15(tmp0_desc, 0, tmp2_cached[0].k3(), value.p98_1);
    if (tmp1_output.m15(tmp0_desc, 1) ? true : !(value.q98_1 == null)) {
      tmp1_output.i15(tmp0_desc, 1, StringSerializer_getInstance(), value.q98_1);
    }
    if (tmp1_output.m15(tmp0_desc, 2) ? true : !value.r98_1.equals(get_terminalInfoSourceCursor())) {
      tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_1(), value.r98_1);
    }
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.o9d(encoder, value instanceof SessionEnded ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.n9d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    var tmp8_cached = Companion_getInstance_7().m9d_1;
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, tmp8_cached[0].k3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.d14(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b14(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return SessionEnded.p9d(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.n9d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_7().m9d_1[0].k3(), get_nullable(StringSerializer_getInstance()), $serializer_getInstance_1()];
  }
}
class SessionEnded {
  constructor(status, errorMessage) {
    Companion_getInstance_7();
    errorMessage = errorMessage === VOID ? null : errorMessage;
    this.p98_1 = status;
    this.q98_1 = errorMessage;
    this.r98_1 = get_terminalInfoSourceCursor();
  }
  l93() {
    return this.r98_1;
  }
  toString() {
    return 'SessionEnded(status=' + this.p98_1.toString() + ', errorMessage=' + this.q98_1 + ')';
  }
  hashCode() {
    var result = this.p98_1.hashCode();
    result = imul(result, 31) + (this.q98_1 == null ? 0 : getStringHashCode(this.q98_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SessionEnded))
      return false;
    if (!this.p98_1.equals(other.p98_1))
      return false;
    if (!(this.q98_1 == other.q98_1))
      return false;
    return true;
  }
  static p9d(seen0, status, errorMessage, sourceCursor, serializationConstructorMarker) {
    Companion_getInstance_7();
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_33().n9d_1);
    }
    var $this = createThis(this);
    $this.p98_1 = status;
    if (0 === (seen0 & 2))
      $this.q98_1 = null;
    else
      $this.q98_1 = errorMessage;
    if (0 === (seen0 & 4))
      $this.r98_1 = get_terminalInfoSourceCursor();
    else
      $this.r98_1 = sourceCursor;
    return $this;
  }
}
class SessionCanceled {
  constructor() {
    SessionCanceled_instance = this;
    this.q9d_1 = get_canceledSessionInfoSourceCursor();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.r9d_1 = lazy(tmp_0, SessionCanceled$_anonymous__mdb0zc);
  }
  l93() {
    return this.q9d_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_1(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SessionCanceled';
  }
  hashCode() {
    return 651559210;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SessionCanceled))
      return false;
    return true;
  }
}
class Companion_6 {}
class $serializer_4 {
  constructor() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.ChooseAnswerRequestFromServer', this, 6);
    tmp0_serialDesc.h1b('sourceCursor', false);
    tmp0_serialDesc.h1b('gameStateRevision', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    tmp0_serialDesc.h1b('gameQuestion', false);
    tmp0_serialDesc.h1b('mayNothing', false);
    tmp0_serialDesc.h1b('predefinedAnswerIndex', false);
    this.s9d_1 = tmp0_serialDesc;
  }
  t9d(encoder, value) {
    var tmp0_desc = this.s9d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.n93_1);
    tmp1_output.z14(tmp0_desc, 1, value.o93_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_2(), new GameTeam(value.p93_1));
    var tmp = getKClass(GameQuestion);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
    var tmp_1 = $serializer_getInstance_3();
    var tmp_2 = $serializer_getInstance_4();
    var tmp_3 = PlaceHatchlingWithInfestQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_4 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_3, tmp$ret$3);
    var tmp_5 = PlayOverloadedQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_6 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_5, tmp$ret$6);
    var tmp_7 = RevealToMoveQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_8 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_7, tmp$ret$9);
    var tmp_9 = $serializer_getInstance_5();
    var tmp_10 = $serializer_getInstance_6();
    var tmp_11 = $serializer_getInstance_7();
    var tmp_12 = CardPlayColorQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_13 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_12, tmp$ret$12);
    var tmp_14 = $serializer_getInstance_8();
    var tmp_15 = $serializer_getInstance_9();
    var tmp_16 = $serializer_getInstance_10();
    var tmp_17 = ContinueAfterRecoveryQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_18 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_17, tmp$ret$15);
    var tmp_19 = $serializer_getInstance_11();
    var tmp_20 = $serializer_getInstance_12();
    var tmp_21 = $serializer_getInstance_13();
    var tmp_22 = $serializer_getInstance_14();
    var tmp_23 = $serializer_getInstance_15();
    var tmp_24 = $serializer_getInstance_16();
    var tmp_25 = $serializer_getInstance_17();
    var tmp_26 = $serializer_getInstance_18();
    var tmp_27 = getKClass(ObjectOnBoardType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_28 = [tmp_1, tmp_2, tmp_4, tmp_6, tmp_8, tmp_9, tmp_10, tmp_11, tmp_13, tmp_14, tmp_15, tmp_16, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, $serializer.l47(PolymorphicSerializer.vz(tmp_27, tmp$ret$18)), $serializer_getInstance_19(), $serializer_getInstance_20(), $serializer_getInstance_21(), $serializer_getInstance_22(), $serializer_getInstance_23(), $serializer_getInstance_24(), $serializer_getInstance_25(), $serializer_getInstance_26(), $serializer_getInstance_27()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    tmp1_output.g15(tmp0_desc, 3, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp, tmp_0, tmp_28, tmp$ret$24), value.q93_1);
    tmp1_output.w14(tmp0_desc, 4, value.r93_1);
    tmp1_output.i15(tmp0_desc, 5, IntSerializer_getInstance(), value.s93_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.t9d(encoder, value instanceof ChooseAnswerRequestFromServer ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.s9d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_input = decoder.p13(tmp0_desc);
    if (tmp10_input.e14()) {
      tmp4_local0 = tmp10_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_2();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp10_input.b14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp_2 = getKClass(GameQuestion);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_3 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
      var tmp_4 = $serializer_getInstance_3();
      var tmp_5 = $serializer_getInstance_4();
      var tmp_6 = PlaceHatchlingWithInfestQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [];
      var tmp_7 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_6, tmp$ret$3);
      var tmp_8 = PlayOverloadedQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = [];
      var tmp_9 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_8, tmp$ret$6);
      var tmp_10 = RevealToMoveQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$9 = [];
      var tmp_11 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_10, tmp$ret$9);
      var tmp_12 = $serializer_getInstance_5();
      var tmp_13 = $serializer_getInstance_6();
      var tmp_14 = $serializer_getInstance_7();
      var tmp_15 = CardPlayColorQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$12 = [];
      var tmp_16 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_15, tmp$ret$12);
      var tmp_17 = $serializer_getInstance_8();
      var tmp_18 = $serializer_getInstance_9();
      var tmp_19 = $serializer_getInstance_10();
      var tmp_20 = ContinueAfterRecoveryQuestion_getInstance();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$15 = [];
      var tmp_21 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_20, tmp$ret$15);
      var tmp_22 = $serializer_getInstance_11();
      var tmp_23 = $serializer_getInstance_12();
      var tmp_24 = $serializer_getInstance_13();
      var tmp_25 = $serializer_getInstance_14();
      var tmp_26 = $serializer_getInstance_15();
      var tmp_27 = $serializer_getInstance_16();
      var tmp_28 = $serializer_getInstance_17();
      var tmp_29 = $serializer_getInstance_18();
      var tmp_30 = getKClass(ObjectOnBoardType);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$18 = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_31 = [tmp_4, tmp_5, tmp_7, tmp_9, tmp_11, tmp_12, tmp_13, tmp_14, tmp_16, tmp_17, tmp_18, tmp_19, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, $serializer.l47(PolymorphicSerializer.vz(tmp_30, tmp$ret$18)), $serializer_getInstance_19(), $serializer_getInstance_20(), $serializer_getInstance_21(), $serializer_getInstance_22(), $serializer_getInstance_23(), $serializer_getInstance_24(), $serializer_getInstance_25(), $serializer_getInstance_26(), $serializer_getInstance_27()];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$24 = [];
      tmp7_local3 = tmp10_input.b14(tmp0_desc, 3, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp_2, tmp_3, tmp_31, tmp$ret$24), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.r13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_32 = $serializer_getInstance_2();
            var tmp_33 = tmp6_local2;
            var tmp_34 = tmp10_input.b14(tmp0_desc, 2, tmp_32, tmp_33 == null ? null : new GameTeam(tmp_33));
            tmp6_local2 = tmp_34 == null ? null : tmp_34.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_35 = getKClass(GameQuestion);
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp_36 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
            var tmp_37 = $serializer_getInstance_3();
            var tmp_38 = $serializer_getInstance_4();
            var tmp_39 = PlaceHatchlingWithInfestQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$30 = [];
            var tmp_40 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_39, tmp$ret$30);
            var tmp_41 = PlayOverloadedQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$33 = [];
            var tmp_42 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_41, tmp$ret$33);
            var tmp_43 = RevealToMoveQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$36 = [];
            var tmp_44 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_43, tmp$ret$36);
            var tmp_45 = $serializer_getInstance_5();
            var tmp_46 = $serializer_getInstance_6();
            var tmp_47 = $serializer_getInstance_7();
            var tmp_48 = CardPlayColorQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$39 = [];
            var tmp_49 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_48, tmp$ret$39);
            var tmp_50 = $serializer_getInstance_8();
            var tmp_51 = $serializer_getInstance_9();
            var tmp_52 = $serializer_getInstance_10();
            var tmp_53 = ContinueAfterRecoveryQuestion_getInstance();
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$42 = [];
            var tmp_54 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_53, tmp$ret$42);
            var tmp_55 = $serializer_getInstance_11();
            var tmp_56 = $serializer_getInstance_12();
            var tmp_57 = $serializer_getInstance_13();
            var tmp_58 = $serializer_getInstance_14();
            var tmp_59 = $serializer_getInstance_15();
            var tmp_60 = $serializer_getInstance_16();
            var tmp_61 = $serializer_getInstance_17();
            var tmp_62 = $serializer_getInstance_18();
            var tmp_63 = getKClass(ObjectOnBoardType);
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$45 = [];
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp_64 = [tmp_37, tmp_38, tmp_40, tmp_42, tmp_44, tmp_45, tmp_46, tmp_47, tmp_49, tmp_50, tmp_51, tmp_52, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, $serializer.l47(PolymorphicSerializer.vz(tmp_63, tmp$ret$45)), $serializer_getInstance_19(), $serializer_getInstance_20(), $serializer_getInstance_21(), $serializer_getInstance_22(), $serializer_getInstance_23(), $serializer_getInstance_24(), $serializer_getInstance_25(), $serializer_getInstance_26(), $serializer_getInstance_27()];
            // Inline function 'kotlin.arrayOf' call

            // Inline function 'kotlin.js.unsafeCast' call

            // Inline function 'kotlin.js.asDynamic' call

            var tmp$ret$51 = [];
            tmp7_local3 = tmp10_input.b14(tmp0_desc, 3, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp_35, tmp_36, tmp_64, tmp$ret$51), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.r13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.d14(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp10_input.q13(tmp0_desc);
    return ChooseAnswerRequestFromServer.u9d(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  }
  dz() {
    return this.s9d_1;
  }
  y1b() {
    var tmp = $serializer_getInstance_1();
    var tmp_0 = IntSerializer_getInstance();
    var tmp_1 = $serializer_getInstance_2();
    var tmp_2 = getKClass(GameQuestion);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = [getKClass(AncientPowerNumberQuestion), getKClass(BeastMovementCardQuestion), getKClass(PlaceHatchlingWithInfestQuestion), getKClass(PlayOverloadedQuestion), getKClass(RevealToMoveQuestion), getKClass(SpendLydanHarvestQuestion), getKClass(SpendValdiBloodQuestion), getKClass(UseVackerSoulsQuestion), getKClass(CardPlayColorQuestion), getKClass(ChooseCardOnDraftQuestion), getKClass(ChooseCardsQuestion), getKClass(ChooseCharacterQuestion), getKClass(ContinueAfterRecoveryQuestion), getKClass(DestinationQuestion), getKClass(BarrierConnectedLocationQuestion), getKClass(GrapnelQuestion), getKClass(LocationQuestion), getKClass(PlaceNewObjectQuestion), getKClass(SearchLocationQuestion), getKClass(TransformLocationQuestion), getKClass(LocationTypeQuestion), getKClass(ObjectsGameQuestion), getKClass(PhaseRecoveryQuestion), getKClass(PlayCardInTurnQuestion), getKClass(SnareTypeQuestion), getKClass(StatementQuestion), getKClass(TrapByNumberQuestion), getKClass(TriggersQuestion), getKClass(UpgradeQuestion), getKClass(UrgullMoltEggsToReturnQuestion), getKClass(ZoneQuestion)];
    var tmp_4 = $serializer_getInstance_3();
    var tmp_5 = $serializer_getInstance_4();
    var tmp_6 = PlaceHatchlingWithInfestQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [];
    var tmp_7 = ObjectSerializer.l1c('PlaceHatchlingWithInfestQuestion', tmp_6, tmp$ret$3);
    var tmp_8 = PlayOverloadedQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    var tmp_9 = ObjectSerializer.l1c('PlayOverloadedQuestion', tmp_8, tmp$ret$6);
    var tmp_10 = RevealToMoveQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [];
    var tmp_11 = ObjectSerializer.l1c('RevealToMoveQuestion', tmp_10, tmp$ret$9);
    var tmp_12 = $serializer_getInstance_5();
    var tmp_13 = $serializer_getInstance_6();
    var tmp_14 = $serializer_getInstance_7();
    var tmp_15 = CardPlayColorQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [];
    var tmp_16 = ObjectSerializer.l1c('CardPlayColorQuestion', tmp_15, tmp$ret$12);
    var tmp_17 = $serializer_getInstance_8();
    var tmp_18 = $serializer_getInstance_9();
    var tmp_19 = $serializer_getInstance_10();
    var tmp_20 = ContinueAfterRecoveryQuestion_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$15 = [];
    var tmp_21 = ObjectSerializer.l1c('ContinueAfterRecoveryQuestion', tmp_20, tmp$ret$15);
    var tmp_22 = $serializer_getInstance_11();
    var tmp_23 = $serializer_getInstance_12();
    var tmp_24 = $serializer_getInstance_13();
    var tmp_25 = $serializer_getInstance_14();
    var tmp_26 = $serializer_getInstance_15();
    var tmp_27 = $serializer_getInstance_16();
    var tmp_28 = $serializer_getInstance_17();
    var tmp_29 = $serializer_getInstance_18();
    var tmp_30 = getKClass(ObjectOnBoardType);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$18 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_31 = [tmp_4, tmp_5, tmp_7, tmp_9, tmp_11, tmp_12, tmp_13, tmp_14, tmp_16, tmp_17, tmp_18, tmp_19, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, $serializer.l47(PolymorphicSerializer.vz(tmp_30, tmp$ret$18)), $serializer_getInstance_19(), $serializer_getInstance_20(), $serializer_getInstance_21(), $serializer_getInstance_22(), $serializer_getInstance_23(), $serializer_getInstance_24(), $serializer_getInstance_25(), $serializer_getInstance_26(), $serializer_getInstance_27()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$24 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp, tmp_0, tmp_1, SealedClassSerializer.i10('steelart.beast.GameQuestion', tmp_2, tmp_3, tmp_31, tmp$ret$24), BooleanSerializer_getInstance(), get_nullable(IntSerializer_getInstance())];
  }
}
class ChooseAnswerRequestFromServer {
  constructor(sourceCursor, gameStateRevision, gameTeam, gameQuestion, mayNothing, predefinedAnswerIndex) {
    this.n93_1 = sourceCursor;
    this.o93_1 = gameStateRevision;
    this.p93_1 = gameTeam;
    this.q93_1 = gameQuestion;
    this.r93_1 = mayNothing;
    this.s93_1 = predefinedAnswerIndex;
  }
  l93() {
    return this.n93_1;
  }
  v9d(sourceCursor, gameStateRevision, gameTeam, gameQuestion, mayNothing, predefinedAnswerIndex) {
    return new ChooseAnswerRequestFromServer(sourceCursor, gameStateRevision, gameTeam, gameQuestion, mayNothing, predefinedAnswerIndex);
  }
  m98(sourceCursor, gameStateRevision, gameTeam, gameQuestion, mayNothing, predefinedAnswerIndex, $super) {
    sourceCursor = sourceCursor === VOID ? this.n93_1 : sourceCursor;
    gameStateRevision = gameStateRevision === VOID ? this.o93_1 : gameStateRevision;
    gameTeam = gameTeam === VOID ? this.p93_1 : gameTeam;
    gameQuestion = gameQuestion === VOID ? this.q93_1 : gameQuestion;
    mayNothing = mayNothing === VOID ? this.r93_1 : mayNothing;
    predefinedAnswerIndex = predefinedAnswerIndex === VOID ? this.s93_1 : predefinedAnswerIndex;
    return $super === VOID ? this.v9d(sourceCursor, gameStateRevision, gameTeam, gameQuestion, mayNothing, predefinedAnswerIndex) : $super.v9d.call(this, sourceCursor, gameStateRevision, new GameTeam(gameTeam), gameQuestion, mayNothing, predefinedAnswerIndex);
  }
  toString() {
    return 'ChooseAnswerRequestFromServer(sourceCursor=' + this.n93_1.toString() + ', gameStateRevision=' + this.o93_1 + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.p93_1) + ', gameQuestion=' + toString(this.q93_1) + ', mayNothing=' + this.r93_1 + ', predefinedAnswerIndex=' + this.s93_1 + ')';
  }
  hashCode() {
    var result = this.n93_1.hashCode();
    result = imul(result, 31) + this.o93_1 | 0;
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.p93_1) | 0;
    result = imul(result, 31) + hashCode(this.q93_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r93_1) | 0;
    result = imul(result, 31) + (this.s93_1 == null ? 0 : this.s93_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChooseAnswerRequestFromServer))
      return false;
    if (!this.n93_1.equals(other.n93_1))
      return false;
    if (!(this.o93_1 === other.o93_1))
      return false;
    if (!(this.p93_1 === other.p93_1))
      return false;
    if (!equals(this.q93_1, other.q93_1))
      return false;
    if (!(this.r93_1 === other.r93_1))
      return false;
    if (!(this.s93_1 == other.s93_1))
      return false;
    return true;
  }
  static u9d(seen0, sourceCursor, gameStateRevision, gameTeam, gameQuestion, mayNothing, predefinedAnswerIndex, serializationConstructorMarker) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_34().s9d_1);
    }
    var $this = createThis(this);
    $this.n93_1 = sourceCursor;
    $this.o93_1 = gameStateRevision;
    $this.p93_1 = gameTeam;
    $this.q93_1 = gameQuestion;
    $this.r93_1 = mayNothing;
    $this.s93_1 = predefinedAnswerIndex;
    return $this;
  }
}
class Companion_7 {}
class $serializer_5 {
  constructor() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.SessionFinished', this, 1);
    tmp0_serialDesc.h1b('sourceCursor', false);
    this.w9d_1 = tmp0_serialDesc;
  }
  x9d(encoder, value) {
    var tmp0_desc = this.w9d_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.n98_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.x9d(encoder, value instanceof SessionFinished ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.w9d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return SessionFinished.y9d(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.w9d_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1()];
  }
}
class SessionFinished {
  constructor(sourceCursor) {
    this.n98_1 = sourceCursor;
  }
  l93() {
    return this.n98_1;
  }
  o98(sourceCursor) {
    return new SessionFinished(sourceCursor);
  }
  toString() {
    return 'SessionFinished(sourceCursor=' + this.n98_1.toString() + ')';
  }
  hashCode() {
    return this.n98_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SessionFinished))
      return false;
    if (!this.n98_1.equals(other.n98_1))
      return false;
    return true;
  }
  static y9d(seen0, sourceCursor, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_35().w9d_1);
    }
    var $this = createThis(this);
    $this.n98_1 = sourceCursor;
    return $this;
  }
}
class SessionReloadRequired {
  constructor() {
    SessionReloadRequired_instance = this;
    this.z9d_1 = get_terminalInfoSourceCursor();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.a9e_1 = lazy(tmp_0, SessionReloadRequired$_anonymous__1y78g9);
  }
  l93() {
    return this.z9d_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_2(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'SessionReloadRequired';
  }
  hashCode() {
    return 1997763625;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SessionReloadRequired))
      return false;
    return true;
  }
}
class IncorrectServerStateForRequest {
  constructor() {
    IncorrectServerStateForRequest_instance = this;
    this.b9e_1 = get_incorrectServerStateInfoSourceCursor();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.c9e_1 = lazy(tmp_0, IncorrectServerStateForRequest$_anonymous__c8ld54);
  }
  l93() {
    return this.b9e_1;
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_3(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
  toString() {
    return 'IncorrectServerStateForRequest';
  }
  hashCode() {
    return -1505839276;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IncorrectServerStateForRequest))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d9e_1 = [null, lazy(tmp_0, PingMessage$Companion$$childSerializers$_anonymous__ej5lbp)];
  }
}
class $serializer_6 {
  constructor() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.PingMessage', this, 2);
    tmp0_serialDesc.h1b('sourceCursor', false);
    tmp0_serialDesc.h1b('element', false);
    this.e9e_1 = tmp0_serialDesc;
  }
  f9e(encoder, value) {
    var tmp0_desc = this.e9e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().d9e_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.c95_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.d95_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.f9e(encoder, value instanceof PingMessage ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.e9e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.p13(tmp0_desc);
    var tmp7_cached = Companion_getInstance_10().d9e_1;
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.b14(tmp0_desc, 1, tmp7_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return PingMessage.g9e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.e9e_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_10().d9e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), tmp0_cached[1].k3()];
  }
}
class PingMessage {
  constructor(sourceCursor, element) {
    Companion_getInstance_10();
    this.c95_1 = sourceCursor;
    this.d95_1 = element;
  }
  l93() {
    return this.c95_1;
  }
  h9e(sourceCursor, element) {
    return new PingMessage(sourceCursor, element);
  }
  h98(sourceCursor, element, $super) {
    sourceCursor = sourceCursor === VOID ? this.c95_1 : sourceCursor;
    element = element === VOID ? this.d95_1 : element;
    return $super === VOID ? this.h9e(sourceCursor, element) : $super.h9e.call(this, sourceCursor, element);
  }
  toString() {
    return 'PingMessage(sourceCursor=' + this.c95_1.toString() + ', element=' + toString(this.d95_1) + ')';
  }
  hashCode() {
    var result = this.c95_1.hashCode();
    result = imul(result, 31) + hashCode(this.d95_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PingMessage))
      return false;
    if (!this.c95_1.equals(other.c95_1))
      return false;
    if (!equals(this.d95_1, other.d95_1))
      return false;
    return true;
  }
  static g9e(seen0, sourceCursor, element, serializationConstructorMarker) {
    Companion_getInstance_10();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_36().e9e_1);
    }
    var $this = createThis(this);
    $this.c95_1 = sourceCursor;
    $this.d95_1 = element;
    return $this;
  }
}
class Companion_9 {}
class $serializer_7 {
  constructor() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.MasterFixingApprovalRequest', this, 5);
    tmp0_serialDesc.h1b('sourceCursor', false);
    tmp0_serialDesc.h1b('requestId', false);
    tmp0_serialDesc.h1b('requestingTeam', false);
    tmp0_serialDesc.h1b('approvingTeam', false);
    tmp0_serialDesc.h1b('isPending', false);
    this.i9e_1 = tmp0_serialDesc;
  }
  j9e(encoder, value) {
    var tmp0_desc = this.i9e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.q94_1);
    tmp1_output.z14(tmp0_desc, 1, value.r94_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_2(), new GameTeam(value.s94_1));
    tmp1_output.g15(tmp0_desc, 3, $serializer_getInstance_2(), new GameTeam(value.t94_1));
    tmp1_output.w14(tmp0_desc, 4, value.u94_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.j9e(encoder, value instanceof MasterFixingApprovalRequest ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.i9e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_2();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp9_input.b14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp_2 = $serializer_getInstance_2();
      var tmp_3 = tmp7_local3;
      var tmp_4 = tmp9_input.b14(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
      tmp7_local3 = tmp_4 == null ? null : tmp_4.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_5 = $serializer_getInstance_2();
            var tmp_6 = tmp6_local2;
            var tmp_7 = tmp9_input.b14(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new GameTeam(tmp_6));
            tmp6_local2 = tmp_7 == null ? null : tmp_7.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_8 = $serializer_getInstance_2();
            var tmp_9 = tmp7_local3;
            var tmp_10 = tmp9_input.b14(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new GameTeam(tmp_9));
            tmp7_local3 = tmp_10 == null ? null : tmp_10.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return MasterFixingApprovalRequest.k9e(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.i9e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), IntSerializer_getInstance(), $serializer_getInstance_2(), $serializer_getInstance_2(), BooleanSerializer_getInstance()];
  }
}
class MasterFixingApprovalRequest {
  constructor(sourceCursor, requestId, requestingTeam, approvingTeam, isPending) {
    this.q94_1 = sourceCursor;
    this.r94_1 = requestId;
    this.s94_1 = requestingTeam;
    this.t94_1 = approvingTeam;
    this.u94_1 = isPending;
  }
  l93() {
    return this.q94_1;
  }
  l9e(sourceCursor, requestId, requestingTeam, approvingTeam, isPending) {
    return new MasterFixingApprovalRequest(sourceCursor, requestId, requestingTeam, approvingTeam, isPending);
  }
  k98(sourceCursor, requestId, requestingTeam, approvingTeam, isPending, $super) {
    sourceCursor = sourceCursor === VOID ? this.q94_1 : sourceCursor;
    requestId = requestId === VOID ? this.r94_1 : requestId;
    requestingTeam = requestingTeam === VOID ? this.s94_1 : requestingTeam;
    approvingTeam = approvingTeam === VOID ? this.t94_1 : approvingTeam;
    isPending = isPending === VOID ? this.u94_1 : isPending;
    return $super === VOID ? this.l9e(sourceCursor, requestId, requestingTeam, approvingTeam, isPending) : $super.l9e.call(this, sourceCursor, requestId, new GameTeam(requestingTeam), new GameTeam(approvingTeam), isPending);
  }
  toString() {
    return 'MasterFixingApprovalRequest(sourceCursor=' + this.q94_1.toString() + ', requestId=' + this.r94_1 + ', requestingTeam=' + GameTeam__toString_impl_wfw0a6(this.s94_1) + ', approvingTeam=' + GameTeam__toString_impl_wfw0a6(this.t94_1) + ', isPending=' + this.u94_1 + ')';
  }
  hashCode() {
    var result = this.q94_1.hashCode();
    result = imul(result, 31) + this.r94_1 | 0;
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.s94_1) | 0;
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.t94_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u94_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MasterFixingApprovalRequest))
      return false;
    if (!this.q94_1.equals(other.q94_1))
      return false;
    if (!(this.r94_1 === other.r94_1))
      return false;
    if (!(this.s94_1 === other.s94_1))
      return false;
    if (!(this.t94_1 === other.t94_1))
      return false;
    if (!(this.u94_1 === other.u94_1))
      return false;
    return true;
  }
  static k9e(seen0, sourceCursor, requestId, requestingTeam, approvingTeam, isPending, serializationConstructorMarker) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_37().i9e_1);
    }
    var $this = createThis(this);
    $this.q94_1 = sourceCursor;
    $this.r94_1 = requestId;
    $this.s94_1 = requestingTeam;
    $this.t94_1 = approvingTeam;
    $this.u94_1 = isPending;
    return $this;
  }
}
class Companion_10 {}
class $serializer_8 {
  constructor() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.RevertApprovalRequest', this, 5);
    tmp0_serialDesc.h1b('sourceCursor', false);
    tmp0_serialDesc.h1b('requestId', false);
    tmp0_serialDesc.h1b('requestingTeam', false);
    tmp0_serialDesc.h1b('approvingTeam', false);
    tmp0_serialDesc.h1b('isPending', false);
    this.m9e_1 = tmp0_serialDesc;
  }
  n9e(encoder, value) {
    var tmp0_desc = this.m9e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.w94_1);
    tmp1_output.z14(tmp0_desc, 1, value.x94_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_2(), new GameTeam(value.y94_1));
    tmp1_output.g15(tmp0_desc, 3, $serializer_getInstance_2(), new GameTeam(value.z94_1));
    tmp1_output.w14(tmp0_desc, 4, value.a95_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.n9e(encoder, value instanceof RevertApprovalRequest ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.m9e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.p13(tmp0_desc);
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_2();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp9_input.b14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      var tmp_2 = $serializer_getInstance_2();
      var tmp_3 = tmp7_local3;
      var tmp_4 = tmp9_input.b14(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
      tmp7_local3 = tmp_4 == null ? null : tmp_4.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_5 = $serializer_getInstance_2();
            var tmp_6 = tmp6_local2;
            var tmp_7 = tmp9_input.b14(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new GameTeam(tmp_6));
            tmp6_local2 = tmp_7 == null ? null : tmp_7.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            var tmp_8 = $serializer_getInstance_2();
            var tmp_9 = tmp7_local3;
            var tmp_10 = tmp9_input.b14(tmp0_desc, 3, tmp_8, tmp_9 == null ? null : new GameTeam(tmp_9));
            tmp7_local3 = tmp_10 == null ? null : tmp_10.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.r13(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return RevertApprovalRequest.o9e(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.m9e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), IntSerializer_getInstance(), $serializer_getInstance_2(), $serializer_getInstance_2(), BooleanSerializer_getInstance()];
  }
}
class RevertApprovalRequest {
  constructor(sourceCursor, requestId, requestingTeam, approvingTeam, isPending) {
    this.w94_1 = sourceCursor;
    this.x94_1 = requestId;
    this.y94_1 = requestingTeam;
    this.z94_1 = approvingTeam;
    this.a95_1 = isPending;
  }
  l93() {
    return this.w94_1;
  }
  l9e(sourceCursor, requestId, requestingTeam, approvingTeam, isPending) {
    return new RevertApprovalRequest(sourceCursor, requestId, requestingTeam, approvingTeam, isPending);
  }
  j98(sourceCursor, requestId, requestingTeam, approvingTeam, isPending, $super) {
    sourceCursor = sourceCursor === VOID ? this.w94_1 : sourceCursor;
    requestId = requestId === VOID ? this.x94_1 : requestId;
    requestingTeam = requestingTeam === VOID ? this.y94_1 : requestingTeam;
    approvingTeam = approvingTeam === VOID ? this.z94_1 : approvingTeam;
    isPending = isPending === VOID ? this.a95_1 : isPending;
    return $super === VOID ? this.l9e(sourceCursor, requestId, requestingTeam, approvingTeam, isPending) : $super.l9e.call(this, sourceCursor, requestId, new GameTeam(requestingTeam), new GameTeam(approvingTeam), isPending);
  }
  toString() {
    return 'RevertApprovalRequest(sourceCursor=' + this.w94_1.toString() + ', requestId=' + this.x94_1 + ', requestingTeam=' + GameTeam__toString_impl_wfw0a6(this.y94_1) + ', approvingTeam=' + GameTeam__toString_impl_wfw0a6(this.z94_1) + ', isPending=' + this.a95_1 + ')';
  }
  hashCode() {
    var result = this.w94_1.hashCode();
    result = imul(result, 31) + this.x94_1 | 0;
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.y94_1) | 0;
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.z94_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a95_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertApprovalRequest))
      return false;
    if (!this.w94_1.equals(other.w94_1))
      return false;
    if (!(this.x94_1 === other.x94_1))
      return false;
    if (!(this.y94_1 === other.y94_1))
      return false;
    if (!(this.z94_1 === other.z94_1))
      return false;
    if (!(this.a95_1 === other.a95_1))
      return false;
    return true;
  }
  static o9e(seen0, sourceCursor, requestId, requestingTeam, approvingTeam, isPending, serializationConstructorMarker) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_38().m9e_1);
    }
    var $this = createThis(this);
    $this.w94_1 = sourceCursor;
    $this.x94_1 = requestId;
    $this.y94_1 = requestingTeam;
    $this.z94_1 = approvingTeam;
    $this.a95_1 = isPending;
    return $this;
  }
}
class Companion_11 {}
class $serializer_9 {
  constructor() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.StartMasterFixingEvents', this, 2);
    tmp0_serialDesc.h1b('sourceCursor', false);
    tmp0_serialDesc.h1b('masterFixingCommunicationId', false);
    this.p9e_1 = tmp0_serialDesc;
  }
  q9e(encoder, value) {
    var tmp0_desc = this.p9e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.e95_1);
    tmp1_output.z14(tmp0_desc, 1, value.f95_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.q9e(encoder, value instanceof StartMasterFixingEvents ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.p9e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.p13(tmp0_desc);
    if (tmp6_input.e14()) {
      tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.u13(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp6_input.q13(tmp0_desc);
    return StartMasterFixingEvents.r9e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  dz() {
    return this.p9e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), IntSerializer_getInstance()];
  }
}
class StartMasterFixingEvents {
  constructor(sourceCursor, masterFixingCommunicationId) {
    this.e95_1 = sourceCursor;
    this.f95_1 = masterFixingCommunicationId;
  }
  l93() {
    return this.e95_1;
  }
  s9e(sourceCursor, masterFixingCommunicationId) {
    return new StartMasterFixingEvents(sourceCursor, masterFixingCommunicationId);
  }
  l98(sourceCursor, masterFixingCommunicationId, $super) {
    sourceCursor = sourceCursor === VOID ? this.e95_1 : sourceCursor;
    masterFixingCommunicationId = masterFixingCommunicationId === VOID ? this.f95_1 : masterFixingCommunicationId;
    return $super === VOID ? this.s9e(sourceCursor, masterFixingCommunicationId) : $super.s9e.call(this, sourceCursor, masterFixingCommunicationId);
  }
  toString() {
    return 'StartMasterFixingEvents(sourceCursor=' + this.e95_1.toString() + ', masterFixingCommunicationId=' + this.f95_1 + ')';
  }
  hashCode() {
    var result = this.e95_1.hashCode();
    result = imul(result, 31) + this.f95_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StartMasterFixingEvents))
      return false;
    if (!this.e95_1.equals(other.e95_1))
      return false;
    if (!(this.f95_1 === other.f95_1))
      return false;
    return true;
  }
  static r9e(seen0, sourceCursor, masterFixingCommunicationId, serializationConstructorMarker) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_39().p9e_1);
    }
    var $this = createThis(this);
    $this.e95_1 = sourceCursor;
    $this.f95_1 = masterFixingCommunicationId;
    return $this;
  }
}
class Companion_12 {}
class $serializer_10 {
  constructor() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.GameNotificationInfo', this, 3);
    tmp0_serialDesc.h1b('sourceCursor', false);
    tmp0_serialDesc.h1b('notification', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.t9e_1 = tmp0_serialDesc;
  }
  u9e(encoder, value) {
    var tmp0_desc = this.t9e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.t93_1);
    tmp1_output.g15(tmp0_desc, 1, $serializer_getInstance_28(), value.u93_1);
    tmp1_output.g15(tmp0_desc, 2, $serializer_getInstance_2(), new GameTeam(value.v93_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.u9e(encoder, value instanceof GameNotificationInfo ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.t9e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.p13(tmp0_desc);
    if (tmp7_input.e14()) {
      tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_28(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      var tmp = $serializer_getInstance_2();
      var tmp_0 = tmp6_local2;
      var tmp_1 = tmp7_input.b14(tmp0_desc, 2, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp6_local2 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b14(tmp0_desc, 1, $serializer_getInstance_28(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            var tmp_2 = $serializer_getInstance_2();
            var tmp_3 = tmp6_local2;
            var tmp_4 = tmp7_input.b14(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp6_local2 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp7_input.q13(tmp0_desc);
    return GameNotificationInfo.v9e(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  }
  dz() {
    return this.t9e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), $serializer_getInstance_28(), $serializer_getInstance_2()];
  }
}
class GameNotificationInfo {
  constructor(sourceCursor, notification, gameTeam) {
    this.t93_1 = sourceCursor;
    this.u93_1 = notification;
    this.v93_1 = gameTeam;
  }
  l93() {
    return this.t93_1;
  }
  w9e(sourceCursor, notification, gameTeam) {
    return new GameNotificationInfo(sourceCursor, notification, gameTeam);
  }
  i98(sourceCursor, notification, gameTeam, $super) {
    sourceCursor = sourceCursor === VOID ? this.t93_1 : sourceCursor;
    notification = notification === VOID ? this.u93_1 : notification;
    gameTeam = gameTeam === VOID ? this.v93_1 : gameTeam;
    return $super === VOID ? this.w9e(sourceCursor, notification, gameTeam) : $super.w9e.call(this, sourceCursor, notification, new GameTeam(gameTeam));
  }
  toString() {
    return 'GameNotificationInfo(sourceCursor=' + this.t93_1.toString() + ', notification=' + this.u93_1.toString() + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.v93_1) + ')';
  }
  hashCode() {
    var result = this.t93_1.hashCode();
    result = imul(result, 31) + this.u93_1.hashCode() | 0;
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.v93_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameNotificationInfo))
      return false;
    if (!this.t93_1.equals(other.t93_1))
      return false;
    if (!this.u93_1.equals(other.u93_1))
      return false;
    if (!(this.v93_1 === other.v93_1))
      return false;
    return true;
  }
  static v9e(seen0, sourceCursor, notification, gameTeam, serializationConstructorMarker) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_40().t9e_1);
    }
    var $this = createThis(this);
    $this.t93_1 = sourceCursor;
    $this.u93_1 = notification;
    $this.v93_1 = gameTeam;
    return $this;
  }
}
class Companion_13 {}
class $serializer_11 {
  constructor() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.RevertRequestTokenResult.RevertRequestToken', this, 1);
    tmp0_serialDesc.h1b('tokenId', false);
    this.x9e_1 = tmp0_serialDesc;
  }
  y9e(encoder, value) {
    var tmp0_desc = this.x9e_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.z14(tmp0_desc, 0, value.z9e_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.y9e(encoder, value instanceof RevertRequestToken ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.x9e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.u13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return RevertRequestToken.a9f(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.x9e_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance()];
  }
}
class Companion_14 {}
class $serializer_12 {
  constructor() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.RevertRequestTokenResult.InternalRevertRequestTokenError', this, 1);
    tmp0_serialDesc.h1b('message', false);
    this.b9f_1 = tmp0_serialDesc;
  }
  c9f(encoder, value) {
    var tmp0_desc = this.b9f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    tmp1_output.e15(tmp0_desc, 0, value.v95_1);
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.c9f(encoder, value instanceof InternalRevertRequestTokenError ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.b9f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.p13(tmp0_desc);
    if (tmp5_input.e14()) {
      tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z13(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp5_input.q13(tmp0_desc);
    return InternalRevertRequestTokenError.d9f(tmp3_bitMask0, tmp4_local0, null);
  }
  dz() {
    return this.b9f_1;
  }
  y1b() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  }
}
class RevertRequestTokenResult {}
class RevertRequestToken {
  constructor(tokenId) {
    this.z9e_1 = tokenId;
  }
  toString() {
    return 'RevertRequestToken(tokenId=' + this.z9e_1 + ')';
  }
  hashCode() {
    return this.z9e_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertRequestToken))
      return false;
    if (!(this.z9e_1 === other.z9e_1))
      return false;
    return true;
  }
  static a9f(seen0, tokenId, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_41().x9e_1);
    }
    var $this = createThis(this);
    $this.z9e_1 = tokenId;
    return $this;
  }
}
class InternalRevertRequestTokenError {
  constructor(message) {
    this.v95_1 = message;
  }
  toString() {
    return 'InternalRevertRequestTokenError(message=' + this.v95_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.v95_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InternalRevertRequestTokenError))
      return false;
    if (!(this.v95_1 === other.v95_1))
      return false;
    return true;
  }
  static d9f(seen0, message, serializationConstructorMarker) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_42().b9f_1);
    }
    var $this = createThis(this);
    $this.v95_1 = message;
    return $this;
  }
}
class Companion_15 {
  a2g() {
    var tmp = getKClass(RevertRequestTokenResult);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(InternalRevertRequestTokenError), getKClass(RevertRequestToken)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_42(), $serializer_getInstance_41()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer.i10('steelart.beast.network.RevertRequestTokenResult', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e9f_1 = lazy(tmp_0, StartMasterFixingResult$Companion$_anonymous__supoin);
  }
  a2g() {
    return _get_$cachedSerializer__te6jhj_4(this);
  }
  m1c(typeParamsSerializers) {
    return this.a2g();
  }
}
class StartMasterFixingResult extends Enum {}
class Companion_17 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, RevertGameEventInfo$Companion$$childSerializers$_anonymous__5j8ztk);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f9f_1 = [null, tmp_1, lazy(tmp_2, RevertGameEventInfo$Companion$$childSerializers$_anonymous__5j8ztk_0), null, null];
  }
}
class $serializer_13 {
  constructor() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('steelart.beast.network.RevertGameEventInfo', this, 5);
    tmp0_serialDesc.h1b('sourceCursor', false);
    tmp0_serialDesc.h1b('event', false);
    tmp0_serialDesc.h1b('revertingChanges', false);
    tmp0_serialDesc.h1b('checkInfo', false);
    tmp0_serialDesc.h1b('gameTeam', false);
    this.g9f_1 = tmp0_serialDesc;
  }
  h9f(encoder, value) {
    var tmp0_desc = this.g9f_1;
    var tmp1_output = encoder.p13(tmp0_desc);
    var tmp2_cached = Companion_getInstance_19().f9f_1;
    tmp1_output.g15(tmp0_desc, 0, $serializer_getInstance_1(), value.w93_1);
    tmp1_output.g15(tmp0_desc, 1, tmp2_cached[1].k3(), value.x93_1);
    tmp1_output.g15(tmp0_desc, 2, tmp2_cached[2].k3(), value.y93_1);
    tmp1_output.g15(tmp0_desc, 3, $serializer_getInstance_29(), value.z93_1);
    tmp1_output.g15(tmp0_desc, 4, $serializer_getInstance_2(), new GameTeam(value.a94_1));
    tmp1_output.q13(tmp0_desc);
  }
  ez(encoder, value) {
    return this.h9f(encoder, value instanceof RevertGameEventInfo ? value : THROW_CCE());
  }
  fz(decoder) {
    var tmp0_desc = this.g9f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.p13(tmp0_desc);
    var tmp10_cached = Companion_getInstance_19().f9f_1;
    if (tmp9_input.e14()) {
      tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, $serializer_getInstance_29(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      var tmp = $serializer_getInstance_2();
      var tmp_0 = tmp8_local4;
      var tmp_1 = tmp9_input.b14(tmp0_desc, 4, tmp, tmp_0 == null ? null : new GameTeam(tmp_0));
      tmp8_local4 = tmp_1 == null ? null : tmp_1.r3p_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.f14(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b14(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b14(tmp0_desc, 1, tmp10_cached[1].k3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.b14(tmp0_desc, 2, tmp10_cached[2].k3(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.b14(tmp0_desc, 3, $serializer_getInstance_29(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            var tmp_2 = $serializer_getInstance_2();
            var tmp_3 = tmp8_local4;
            var tmp_4 = tmp9_input.b14(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new GameTeam(tmp_3));
            tmp8_local4 = tmp_4 == null ? null : tmp_4.r3p_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException.z10(tmp2_index);
        }
      }
    tmp9_input.q13(tmp0_desc);
    return RevertGameEventInfo.i9f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  }
  dz() {
    return this.g9f_1;
  }
  y1b() {
    var tmp0_cached = Companion_getInstance_19().f9f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), tmp0_cached[1].k3(), tmp0_cached[2].k3(), $serializer_getInstance_29(), $serializer_getInstance_2()];
  }
}
class RevertGameEventInfo {
  constructor(sourceCursor, event, revertingChanges, checkInfo, gameTeam) {
    Companion_getInstance_19();
    this.w93_1 = sourceCursor;
    this.x93_1 = event;
    this.y93_1 = revertingChanges;
    this.z93_1 = checkInfo;
    this.a94_1 = gameTeam;
  }
  l93() {
    return this.w93_1;
  }
  j9f(sourceCursor, event, revertingChanges, checkInfo, gameTeam) {
    return new RevertGameEventInfo(sourceCursor, event, revertingChanges, checkInfo, gameTeam);
  }
  g98(sourceCursor, event, revertingChanges, checkInfo, gameTeam, $super) {
    sourceCursor = sourceCursor === VOID ? this.w93_1 : sourceCursor;
    event = event === VOID ? this.x93_1 : event;
    revertingChanges = revertingChanges === VOID ? this.y93_1 : revertingChanges;
    checkInfo = checkInfo === VOID ? this.z93_1 : checkInfo;
    gameTeam = gameTeam === VOID ? this.a94_1 : gameTeam;
    return $super === VOID ? this.j9f(sourceCursor, event, revertingChanges, checkInfo, gameTeam) : $super.j9f.call(this, sourceCursor, event, revertingChanges, checkInfo, new GameTeam(gameTeam));
  }
  toString() {
    return 'RevertGameEventInfo(sourceCursor=' + this.w93_1.toString() + ', event=' + toString(this.x93_1) + ', revertingChanges=' + toString(this.y93_1) + ', checkInfo=' + this.z93_1.toString() + ', gameTeam=' + GameTeam__toString_impl_wfw0a6(this.a94_1) + ')';
  }
  hashCode() {
    var result = this.w93_1.hashCode();
    result = imul(result, 31) + hashCode(this.x93_1) | 0;
    result = imul(result, 31) + hashCode(this.y93_1) | 0;
    result = imul(result, 31) + this.z93_1.hashCode() | 0;
    result = imul(result, 31) + GameTeam__hashCode_impl_gu24w3(this.a94_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RevertGameEventInfo))
      return false;
    if (!this.w93_1.equals(other.w93_1))
      return false;
    if (!equals(this.x93_1, other.x93_1))
      return false;
    if (!equals(this.y93_1, other.y93_1))
      return false;
    if (!this.z93_1.equals(other.z93_1))
      return false;
    if (!(this.a94_1 === other.a94_1))
      return false;
    return true;
  }
  static i9f(seen0, sourceCursor, event, revertingChanges, checkInfo, gameTeam, serializationConstructorMarker) {
    Companion_getInstance_19();
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_43().g9f_1);
    }
    var $this = createThis(this);
    $this.w93_1 = sourceCursor;
    $this.x93_1 = event;
    $this.y93_1 = revertingChanges;
    $this.z93_1 = checkInfo;
    $this.a94_1 = gameTeam;
    return $this;
  }
}
//endregion
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
var $serializer_instance;
function $serializer_getInstance_30() {
  if ($serializer_instance === VOID)
    new $serializer_0();
  return $serializer_instance;
}
function get_comparisonInfoSourceCursor() {
  _init_properties_ServerDrivenConfigurationKrpc_kt__776o1j();
  return comparisonInfoSourceCursor;
}
var comparisonInfoSourceCursor;
function ServerDrivenConfigurationKrpc$createMasterFixingEventsConsumer$o$submitFixingEvent$slambda($fixingId, $event) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.s92($fixingId, $event, $completion);
  }, 1);
}
function closeConnection($this) {
  var tmp0_safe_receiver = $this.y92_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1n();
  }
  $this.y92_1 = null;
  var tmp1_safe_receiver = $this.c93_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.f90('Client connection closed');
  }
  $this.c93_1 = null;
  var tmp2_safe_receiver = $this.b93_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.f7();
  }
  $this.b93_1 = null;
  $this.a93_1 = null;
}
function connectToServer($this) {
  closeConnection($this);
  var httpClient = HttpClient(ServerDrivenConfigurationKrpc$connectToServer$lambda($this));
  var rpcClient = rpc(httpClient, ServerDrivenConfigurationKrpc$connectToServer$lambda_0($this));
  launch(httpClient, VOID, VOID, ServerDrivenConfigurationKrpc$connectToServer$slambda(rpcClient));
  $this.c93_1 = rpcClient;
  $this.b93_1 = httpClient;
  var tmp = $this;
  // Inline function 'kotlinx.rpc.withService' call
  tmp.a93_1 = withService(rpcClient, getKClass(BeastServerInteraction));
}
function setupFromResult($this, result) {
  var tmp;
  if (result instanceof Connected) {
    tmp = new ServerDuelGameSetupKrpc($this, result.h93_1);
  } else {
    if (equals(result, GameWithSuchNameIsInProgress_getInstance()) || equals(result, NotFound_getInstance_0())) {
      tmp = null;
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function *processThrowableFromClient($this, e, info, $completion) {
  var tmp;
  if (!(e instanceof CancellationException)) {
    tmp = !isInterface(e, InteractionServerException);
  } else {
    tmp = false;
  }
  if (tmp) {
    yield* ensureNotNull($this.a93_1).m93(info.l93(), 'Exception while procession: ' + e.message, $completion);
  }
  throw e;
}
function *updateMasterFixingEventsConsumer($this, consumer, $completion) {
  $this.z92_1 = consumer;
  var _iterator__ex2g4s = $this.e93_1.y4().p1();
  while (_iterator__ex2g4s.q1()) {
    var agent = _iterator__ex2g4s.r1();
    var tmp0_safe_receiver = isInterface(agent, MasterFixingSupportingAgent) ? agent : null;
    if (tmp0_safe_receiver == null)
      null;
    else
      yield* tmp0_safe_receiver.w6q(consumer, $completion);
  }
  return Unit_instance;
}
function createMasterFixingEventsConsumer($this, fixingId) {
  return new ServerDrivenConfigurationKrpc$createMasterFixingEventsConsumer$1($this, fixingId);
}
function getRevisionFromInfo($this, info) {
  var tmp0_safe_receiver = info instanceof ChooseAnswerRequestFromServer ? info : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o93_1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = info instanceof GameNotificationInfo ? info : null;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.u93_1;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.y3p_1;
    tmp = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.e3q_1;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var tmp5_elvis_lhs = tmp;
  var tmp_0;
  if (tmp5_elvis_lhs == null) {
    var tmp6_safe_receiver = info instanceof RevertGameEventInfo ? info : null;
    var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.z93_1;
    tmp_0 = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.e3q_1;
  } else {
    tmp_0 = tmp5_elvis_lhs;
  }
  return tmp_0;
}
function ServerDrivenConfigurationKrpc$authenticationCapabilities$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.c94($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda(this$0) {
  return ($this$install) => {
    $this$install.m8g_1 = this$0.v92_1;
    return Unit_instance;
  };
}
function ServerDrivenConfigurationKrpc$connectToServer$lambda(this$0) {
  return ($this$HttpClient) => {
    installKrpc($this$HttpClient);
    var tmp = Companion_getInstance();
    $this$HttpClient.e86(tmp, ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda(this$0));
    return Unit_instance;
  };
}
function ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda_0(this$0) {
  return ($this$url, it) => {
    $this$url.e7t_1 = this$0.t92_1.k92_1;
    $this$url.n7u(Companion_getInstance_0().r7u_1);
    $this$url.m7u(0);
    set_encodedPath($this$url, this$0.t92_1.n92_1);
    return Unit_instance;
  };
}
function ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda_1(this$0) {
  return ($this$url, it) => {
    $this$url.e7t_1 = this$0.t92_1.k92_1;
    $this$url.m7u(this$0.t92_1.l92_1);
    set_encodedPath($this$url, this$0.t92_1.n92_1);
    return Unit_instance;
  };
}
function ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda_2($this$rpcConfig) {
  $this$rpcConfig.t8o(ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda$lambda);
  return Unit_instance;
}
function ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda$lambda($this$serialization) {
  json($this$serialization, get_JsonFormat());
  return Unit_instance;
}
function ServerDrivenConfigurationKrpc$connectToServer$lambda_0(this$0) {
  return ($this$rpc) => {
    var tmp;
    if (this$0.t92_1.l92_1 == null) {
      $this$rpc.u8h(ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda_0(this$0));
      tmp = Unit_instance;
    } else {
      $this$rpc.u8h(ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda_1(this$0));
      tmp = Unit_instance;
    }
    rpcConfig($this$rpc, ServerDrivenConfigurationKrpc$connectToServer$lambda$lambda_2);
    return Unit_instance;
  };
}
function ServerDrivenConfigurationKrpc$connectToServer$slambda$lambda($rpcClient) {
  return (cause) => {
    println('webSocketSession coroutineContext is closed: ' + toString_0(cause));
    $rpcClient.g90();
    return Unit_instance;
  };
}
function ServerDrivenConfigurationKrpc$connectToServer$slambda($rpcClient) {
  return constructCallableReference(function *($this$launch, $completion) {
    var webSocketSession = yield* $rpcClient.k91().m1q($completion);
    println('Received webSocketSession: ' + toString(webSocketSession));
    var tmp = get_job(webSocketSession.d1m());
    tmp.g1n(ServerDrivenConfigurationKrpc$connectToServer$slambda$lambda($rpcClient));
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$waitConnection$slambda$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    this$0.x92_1.p25(it);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$waitConnection$slambda($interaction, $messageRpcClient, this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      var tmp_0 = $interaction.d94();
      var tmp_1 = ServerDrivenConfigurationKrpc$waitConnection$slambda$slambda(this$0);
      tmp = yield* tmp_0.j24(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), $completion);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          println('Server message stream failed: ' + e_0.message);
          $messageRpcClient.f90('Server message stream failed');
          tmp_2 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_2;
    }
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$pingConnection$slambda$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* delay(new Long(2000, 0), $completion);
    println('Need to try reconnect!');
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.g93_1;
    yield* this_0.y2a(null, $completion);
    try {
      var tmp0_safe_receiver = this$0.c93_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.f90('Need to try reconnect!');
      }
    }finally {
      this_0.k2a(null);
    }
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$pingConnection$slambda$slambda$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.e94($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$pingConnection$slambda$slambda_0(this$0, $failJob) {
  return constructCallableReference(function *($this$launch, $completion) {
    yield* this$0.f94(ServerDrivenConfigurationKrpc$pingConnection$slambda$slambda$slambda(), $completion);
    $failJob.o1n();
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$pingConnection$slambda(this$0) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var failJob = launch($this$coroutineScope, VOID, VOID, ServerDrivenConfigurationKrpc$pingConnection$slambda$slambda(this$0));
    return launch($this$coroutineScope, VOID, VOID, ServerDrivenConfigurationKrpc$pingConnection$slambda$slambda_0(this$0, failJob));
  }, 1);
}
function ServerDrivenConfigurationKrpc$resetCommunication$slambda(this$0) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.c6l($completion);
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.d93_1;
    yield* this_0.y2a(null, $completion);
    try {
      this$0.z92_1 = null;
    }finally {
      this_0.k2a(null);
    }
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$loginWithAccessCode$slambda($accessCode) {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.u6k($accessCode, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$prepareSandboxSession$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.o6l($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$restoreSession$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.v6k($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$logout$slambda() {
  return constructCallableReference(function *(it, $completion) {
    yield* it.w6k($completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$getUserSettings$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.x6k($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$patchUserSettings$slambda($patch) {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.y6k($patch, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$resetUserSettings$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.z6k($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$getActiveGameSessions$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.a6l($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$requestLobbyList$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.b6l($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$createNewGame$slambda($gameName) {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.g94($gameName, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$connectNewGame$slambda($gameCode) {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.h94($gameCode, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$reconnectGame$slambda($gameCode, $gameTeam, $lastSeenInfoSourceCursor) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.f6l($gameCode, $gameTeam, $lastSeenInfoSourceCursor, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$cancelGame$slambda($gameCode) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.h6l($gameCode, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$requestCompletedGames$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.j6l($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$requestSandboxGames$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.k6l($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$getCompletedGame$slambda($gameCode, $isSandboxGame) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.l6l($gameCode, $isSandboxGame, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$locateRetainedResource$slambda($request) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.m6l($request, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$replayGameReplay$slambda($gameCode, $isSandboxGame) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.i94($gameCode, $isSandboxGame, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$shareSandboxReplay$slambda($gameCode) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.j94($gameCode, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$shareFullGameReplay$slambda($gameCode) {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.q6l($gameCode, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$requestPendingReplayConsents$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.r6l($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$respondToReplayConsent$slambda($gameCode, $approved) {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.s6l($gameCode, $approved, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$reconnectSandboxGame$slambda($gameCode) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.t6l($gameCode, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$initSandboxGame$slambda($gameSetupState) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.k94($gameSetupState, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$startSandboxGame$slambda($gameCode, $checkCode, $sandboxEventsNumber, $startParams) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.l94(ensureNotNull($gameCode), $checkCode, $sandboxEventsNumber, $startParams, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$submitEventForSandboxGame$slambda($gameCode, $applyingEventNumber, $checkCodeBeforeEvent, $event) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.m94($gameCode, $applyingEventNumber, $checkCodeBeforeEvent, $event, $completion);
  }, 1);
}
function *processClient$requestInfoAndTrackCursor(lastSeenInfoSourceCursor, interaction, $completion) {
  var info = yield* interaction.n94($completion);
  if (get_canBeUsedForResume(info.l93())) {
    lastSeenInfoSourceCursor._v = info.l93();
  }
  return info;
}
function *processClient$onReconnect($goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, this$0, interaction, $completion) {
  if ($goingBeastGame instanceof Duel) {
    var result = yield* interaction.f6l($goingBeastGame.u6o_1, $goingBeastGame.v6o_1, lastSeenInfoSourceCursor._v, $completion);
    if (result instanceof Resumed) {
      lastSeenInfoSourceCursor._v = result.q6m_1;
    } else {
      if (result instanceof Terminal)
        return new SessionEnded(result.v6m_1);
      else {
        if (equals(result, NotFound_getInstance()) || equals(result, Forbidden_getInstance()))
          return SessionCanceled_getInstance();
        else {
          noWhenBranchMatchedException();
        }
      }
    }
  } else {
    if ($goingBeastGame instanceof Sandbox) {
      var reconnectSandboxGame = yield* interaction.t6l($goingBeastGame.z6o_1, $completion);
      if (reconnectSandboxGame instanceof SandboxGameWasCanceled) {
        return new SessionEnded(GameStatus_Canceled_getInstance());
      }
      if (!(reconnectSandboxGame instanceof ReconnectSandboxPlaying)) {
        // Inline function 'kotlin.error' call
        var message = 'Reconnect sandbox game result should be ReconnectSandboxPlaying, instead it is ' + toString(reconnectSandboxGame);
        throw IllegalStateException.o(toString(message));
      }
    } else {
      if ($goingBeastGame instanceof Replay) {
        // Inline function 'kotlin.TODO' call
        var reason = 'Support replay!!!';
        throw NotImplementedError.le('An operation is not implemented: ' + reason);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  var tmp1_elvis_lhs = lastProcessedInfo._v;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var last = tmp;
  var lastSeenRevision = getRevisionFromInfo(this$0, last);
  while (true) {
    var info = yield* /*#__NOINLINE__*/processClient$requestInfoAndTrackCursor(lastSeenInfoSourceCursor, interaction, $completion);
    if (equals(last, get_adjustToExcludeSourceCursor(info))) {
      if (info instanceof ChooseAnswerRequestFromServer) {
        return info;
      }
      return null;
    }
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (info instanceof SessionFinished) {
      tmp_3 = true;
    } else {
      tmp_3 = info instanceof SessionCanceled;
    }
    if (tmp_3) {
      tmp_2 = true;
    } else {
      tmp_2 = info instanceof SessionEnded;
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      tmp_1 = info instanceof SessionReloadRequired;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = info instanceof ChooseAnswerRequestFromServer;
    }
    if (tmp_0) {
      return info;
    }
    var revisionFromInfo = getRevisionFromInfo(this$0, info);
    if (!(revisionFromInfo == null) && (lastSeenRevision == null || revisionFromInfo > lastSeenRevision)) {
      return info;
    }
  }
}
function *invoke$waitAndSubmitAnswer$onReconnectForAnswer(answerIndex, $goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, this$0, interaction, $completion) {
  var reconnectedInfo = yield* /*#__NOINLINE__*/processClient$onReconnect($goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, this$0, interaction, $completion);
  if (!(reconnectedInfo instanceof ChooseAnswerRequestFromServer)) {
    // Inline function 'kotlin.error' call
    var message = 'Info from reconnecting should be ChooseAnswerRequestFromServer for answer request, instead it is ' + toString_0(reconnectedInfo);
    throw IllegalStateException.o(toString(message));
  }
  yield* interaction.o94(reconnectedInfo.n93_1, answerIndex, $completion);
  return null;
}
function ServerDrivenConfigurationKrpc$processClient$slambda$waitAndSubmitAnswer$onReconnectForAnswer$ref($answerIndex, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0) {
  return constructCallableReference(function *(p0, $completion) {
    return yield* /*#__NOINLINE__*/invoke$waitAndSubmitAnswer$onReconnectForAnswer($answerIndex, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0, p0, $completion);
  }, 1, 1, 51, 'onReconnectForAnswer', [$answerIndex, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0]);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$waitAndSubmitAnswer$slambda($info, $answerIndex) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.o94($info.l93(), $answerIndex, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$process$slambda$slambda($gameQuestion, $answerDeferred, this$0, $info, $answerJob, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* invoke$waitAndSubmitAnswer(this$0, $answerJob, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, $info, $gameQuestion, $answerDeferred, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        yield* /*#__NOINLINE__*/processThrowableFromClient(this$0, e, $info, $completion);
        tmp_0 = throwKotlinNothingValueException();
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$process$slambda($answerJob, $theScope, this$0, $info, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo) {
  return constructCallableReference(function *(gameQuestion, answerDeferred, $completion) {
    var tmp = CoroutineStart_UNDISPATCHED_getInstance();
    $answerJob._v = launch($theScope, VOID, tmp, ServerDrivenConfigurationKrpc$processClient$slambda$process$slambda$slambda(gameQuestion, answerDeferred, this$0, $info, $answerJob, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo));
    return Unit_instance;
  }, 2);
}
function *invoke$reconnectReader(incomingInfos, $goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, this$0, interaction, $completion) {
  while (_ChannelResult___get_isSuccess__impl__odq1z9(incomingInfos.p22())) {
  }
  return yield* /*#__NOINLINE__*/processClient$onReconnect($goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, this$0, interaction, $completion);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$reconnectReader$ref($incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0) {
  return constructCallableReference(function *(p0, $completion) {
    return yield* /*#__NOINLINE__*/invoke$reconnectReader($incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0, p0, $completion);
  }, 1, 1, 52, 'reconnectReader', [$incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0]);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.n94($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda_0($incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0) {
  return constructCallableReference(function *(it, $completion) {
    return yield* /*#__NOINLINE__*/invoke$reconnectReader($incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0, it, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$slambda(this$0, $onReloadRequired, $incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo) {
  return constructCallableReference(function *($this$launch, $completion) {
    $l$loop_0: while (get_isActive($this$launch)) {
      var tmp = ServerDrivenConfigurationKrpc$processClient$slambda$reconnectReader$ref($incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0);
      var info = yield* this$0.p94(tmp, ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda(), $completion);
      if (info instanceof IncorrectServerStateForRequest) {
        var tmp0_elvis_lhs = yield* this$0.f94(ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda_0($incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, this$0), $completion);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        info = tmp_0;
      }
      if (info instanceof SessionReloadRequired) {
        var tmp1_safe_receiver = $onReloadRequired;
        if (tmp1_safe_receiver == null)
          null;
        else
          tmp1_safe_receiver();
        throw GameSessionReloadRequiredException.j6t();
      }
      yield* $incomingInfos.j22(info, $completion);
      var tmp_1;
      var tmp_2;
      if (info instanceof SessionFinished) {
        tmp_2 = true;
      } else {
        tmp_2 = info instanceof SessionCanceled;
      }
      if (tmp_2) {
        tmp_1 = true;
      } else {
        tmp_1 = info instanceof SessionEnded;
      }
      if (tmp_1)
        break $l$loop_0;
    }
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda_1($info, $approved) {
  return constructCallableReference(function *(it, $completion) {
    yield* it.v94($info.r94_1, $approved, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$slambda_0(this$0, $info) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp0_safe_receiver = this$0.e93_1.w4(new GameTeam($info.t94_1));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : (yield* tmp0_safe_receiver.v6q($info.s94_1, $completion));
    var approved = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    yield* this$0.f94(ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda_1($info, approved), $completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda_2($info, $approved) {
  return constructCallableReference(function *(it, $completion) {
    yield* it.b95($info.x94_1, $approved, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$processClient$slambda$slambda_1(this$0, $info) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp0_safe_receiver = this$0.e93_1.w4(new GameTeam($info.z94_1));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : (yield* tmp0_safe_receiver.t6q($info.y94_1, $completion));
    var approved = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    yield* this$0.f94(ServerDrivenConfigurationKrpc$processClient$slambda$slambda$slambda_2($info, approved), $completion);
    return Unit_instance;
  }, 1);
}
function *invoke$waitAndSubmitAnswer(this$0, answerJob, $goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, info, gameQuestion, answerDeferred, $completion) {
  var answer = yield* boundAwait(answerDeferred, $completion);
  var tmp;
  if (answer == null) {
    tmp = -1;
  } else {
    // Inline function 'kotlin.also' call
    var this_0 = indexOf(gameQuestion.s3o(), answer);
    if (this_0 < 0) {
      throw IllegalStateException.o('Given answer ' + toString(answer) + ' in not found in question ' + toString(gameQuestion));
    }
    tmp = this_0;
  }
  var answerIndex = tmp;
  var tmp_0 = ServerDrivenConfigurationKrpc$processClient$slambda$waitAndSubmitAnswer$onReconnectForAnswer$ref(answerIndex, $goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, this$0);
  yield* this$0.p94(tmp_0, ServerDrivenConfigurationKrpc$processClient$slambda$waitAndSubmitAnswer$slambda(info, answerIndex), $completion);
  answerJob._v = null;
  return Unit_instance;
}
function *invoke$process(this$0, info, answerJob, theScope, $goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo, $completion) {
  return yield* processInfo(this$0, this$0.e93_1, info, ServerDrivenConfigurationKrpc$processClient$slambda$process$slambda(answerJob, theScope, this$0, info, $goingBeastGame, lastSeenInfoSourceCursor, lastProcessedInfo), $completion);
}
function ServerDrivenConfigurationKrpc$processClient$slambda($lastSeenInfoSourceCursor, this$0, $approvalJob, $approvalRequestId, $lastProcessedInfo, $answerJob, $onReloadRequired, $goingBeastGame) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var incomingInfos = Channel(2147483647);
    var infoReader = launch($this$coroutineScope, VOID, VOID, ServerDrivenConfigurationKrpc$processClient$slambda$slambda(this$0, $onReloadRequired, incomingInfos, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo));
    $l$loop_2: while (true) {
      var info = yield* incomingInfos.n22($completion);
      if (get_canBeUsedForResume(info.l93())) {
        $lastSeenInfoSourceCursor._v = info.l93();
      }
      if (info instanceof PingMessage) {
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = this$0.e93_1.i3().p1();
        while (_iterator__ex2g4s.q1()) {
          // Inline function 'kotlin.collections.component2' call
          var agent = _iterator__ex2g4s.r1().k3();
          yield* agent.s6q(info.d95_1, $completion);
        }
        continue $l$loop_2;
      }
      if (info instanceof MasterFixingApprovalRequest) {
        if (info.u94_1) {
          var tmp0_safe_receiver = $approvalJob._v;
          if (tmp0_safe_receiver == null)
            null;
          else
            yield* cancelAndJoin(tmp0_safe_receiver, $completion);
          $approvalRequestId._v = info.r94_1;
          $approvalJob._v = launch($this$coroutineScope, VOID, VOID, ServerDrivenConfigurationKrpc$processClient$slambda$slambda_0(this$0, info));
        } else if ($approvalRequestId._v === info.r94_1) {
          var tmp1_safe_receiver = $approvalJob._v;
          if (tmp1_safe_receiver == null)
            null;
          else
            yield* cancelAndJoin(tmp1_safe_receiver, $completion);
          $approvalJob._v = null;
          $approvalRequestId._v = null;
        }
        continue $l$loop_2;
      }
      if (info instanceof RevertApprovalRequest) {
        if (info.a95_1) {
          var tmp2_safe_receiver = $approvalJob._v;
          if (tmp2_safe_receiver == null)
            null;
          else
            yield* cancelAndJoin(tmp2_safe_receiver, $completion);
          $approvalRequestId._v = info.x94_1;
          $approvalJob._v = launch($this$coroutineScope, VOID, VOID, ServerDrivenConfigurationKrpc$processClient$slambda$slambda_1(this$0, info));
        } else if ($approvalRequestId._v === info.x94_1) {
          var tmp3_safe_receiver = $approvalJob._v;
          if (tmp3_safe_receiver == null)
            null;
          else
            yield* cancelAndJoin(tmp3_safe_receiver, $completion);
          $approvalJob._v = null;
          $approvalRequestId._v = null;
        }
        continue $l$loop_2;
      }
      if (info instanceof StartMasterFixingEvents) {
        // Inline function 'kotlinx.coroutines.sync.withLock' call
        var this_0 = this$0.d93_1;
        yield* this_0.y2a(null, $completion);
        try {
          yield* /*#__NOINLINE__*/updateMasterFixingEventsConsumer(this$0, info.f95_1 < 0 ? null : createMasterFixingEventsConsumer(this$0, info.f95_1), $completion);
        }finally {
          this_0.k2a(null);
        }
      }
      var tmp;
      if (info instanceof GameNotificationInfo) {
        var tmp_0 = info.u93_1.x3p_1;
        tmp = tmp_0 instanceof InitGameStateEvent;
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlinx.coroutines.sync.withLock' call
        var this_1 = this$0.d93_1;
        yield* this_1.y2a(null, $completion);
        try {
          yield* /*#__NOINLINE__*/updateMasterFixingEventsConsumer(this$0, null, $completion);
        }finally {
          this_1.k2a(null);
        }
      }
      $lastProcessedInfo._v = get_adjustToExcludeSourceCursor(info);
      try {
        var theScope = $this$coroutineScope;
        var tmp_1;
        if (info instanceof GameNotificationInfo) {
          var tmp_2 = info.u93_1.x3p_1;
          tmp_1 = tmp_2 instanceof DraftStateEvent;
        } else {
          tmp_1 = false;
        }
        var keepsPendingDraftAnswer = tmp_1;
        if (!($answerJob._v == null) && !keepsPendingDraftAnswer) {
          var tmp_3;
          if (info instanceof GameNotificationInfo) {
            var tmp_4 = info.u93_1.x3p_1;
            tmp_3 = tmp_4 instanceof InitGameStateEvent;
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            var tmp4_safe_receiver = $answerJob._v;
            if (tmp4_safe_receiver == null)
              null;
            else
              yield* cancelAndJoin(tmp4_safe_receiver, $completion);
          } else {
            var tmp5_safe_receiver = $answerJob._v;
            if (tmp5_safe_receiver == null)
              null;
            else {
              tmp5_safe_receiver.o1n();
            }
          }
        }
        var shouldContinue = yield* /*#__NOINLINE__*/invoke$process(this$0, info, $answerJob, theScope, $goingBeastGame, $lastSeenInfoSourceCursor, $lastProcessedInfo, $completion);
        if (!shouldContinue)
          break $l$loop_2;
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          yield* /*#__NOINLINE__*/processThrowableFromClient(this$0, e, info, $completion);
          throwKotlinNothingValueException();
        } else {
          throw $p;
        }
      }
    }
    var tmp6_safe_receiver = $approvalJob._v;
    if (tmp6_safe_receiver == null)
      null;
    else
      yield* cancelAndJoin(tmp6_safe_receiver, $completion);
    yield* cancelAndJoin(infoReader, $completion);
    incomingInfos.a23();
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$pingElement$slambda($element, $isOnlyForTeam) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.w6l($element, $isOnlyForTeam, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$requestGamePresence$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return yield* it.x6l($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$reloadGame$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.z6l($completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$reloadGameByCode$slambda($gameCode) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.a6m($gameCode, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDrivenConfigurationKrpc$requestRevertTurn$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.g95($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$requestRevertTurn$slambda_0($token) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.h95($token, $completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$startMasterFixingEvents$slambda() {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.i95($completion);
  }, 1);
}
function ServerDrivenConfigurationKrpc$submitGameStateError$slambda($revision, $errorMessage, $clientStackTrace) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.c6m($revision, $errorMessage, $clientStackTrace, $completion);
    return Unit_instance;
  }, 1);
}
function rethrowExceptionIfNeeded(e) {
  _init_properties_ServerDrivenConfigurationKrpc_kt__776o1j();
  var message = e.message;
  if ((message == null ? null : contains_0(message, 'Sandbox access is not allowed')) === true)
    throw SandboxAccessDeniedException.a96();
  if ((message == null ? null : contains_0(message, 'Authentication required')) === true) {
    throw BeastAuthenticationRequiredException.f96();
  }
  if ((message == null ? null : contains_0(message, 'Internal Server Error:')) === true) {
    throw WrappedServerError.k96(message);
  }
  if (isInterface(e, InteractionServerException)) {
    throw e;
  }
}
function *onReconnectInternal($this, interaction, $completion) {
  var reconnectResult = yield* interaction.h94($this.p96_1.m96_1, $completion);
  if (reconnectResult instanceof Connected) {
    // Inline function 'kotlin.require' call
    if (!reconnectResult.h93_1.equals($this.p96_1)) {
      var message = 'Reconnect result setup id ' + reconnectResult.h93_1.toString() + ' is different from the given setup id ' + $this.p96_1.toString();
      throw IllegalArgumentException.h2(toString(message));
    }
    var tmp1_safe_receiver = $this.q96_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* interaction.w96($this.p96_1, tmp1_safe_receiver, $completion);
    }
    var tmp2_safe_receiver = $this.r96_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* interaction.x96($this.p96_1, tmp2_safe_receiver, $completion);
    }
    var tmp3_safe_receiver = $this.s96_1;
    var tmp = tmp3_safe_receiver;
    if ((tmp == null ? null : new GameTeam(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp3_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_0 == null ? null : new GameTeam(tmp_0)).r3p_1;
      yield* interaction.y96($this.p96_1, it, $completion);
    }
    var tmp4_safe_receiver = $this.t96_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* interaction.z96($this.p96_1, tmp4_safe_receiver, $completion);
    }
    var tmp5_safe_receiver = $this.u96_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      yield* interaction.a97($this.p96_1, tmp5_safe_receiver, $completion);
    }
    return true;
  } else {
    if (equals(reconnectResult, GameWithSuchNameIsInProgress_getInstance()) || equals(reconnectResult, NotFound_getInstance_0())) {
      return false;
    } else {
      noWhenBranchMatchedException();
    }
  }
}
function ServerDuelGameSetupKrpc$onReconnectWhenSubmitting$slambda(this$0) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* /*#__NOINLINE__*/onReconnectInternal(this$0, interaction, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDuelGameSetupKrpc$submitGameContentVersion$slambda(this$0, $gameContentVersion) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.w96(this$0.p96_1, $gameContentVersion, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDuelGameSetupKrpc$submitContract$slambda(this$0, $rules) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.x96(this$0.p96_1, $rules, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDuelGameSetupKrpc$submitGameTeam$slambda(this$0, $gameTeam) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.y96(this$0.p96_1, $gameTeam, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDuelGameSetupKrpc$submitIsRecordingGameMode$slambda(this$0, $isRecordingGameMode) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.z96(this$0.p96_1, $isRecordingGameMode, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDuelGameSetupKrpc$submitIsPubliclyObserved$slambda(this$0, $isPubliclyObserved) {
  return constructCallableReference(function *(interaction, $completion) {
    yield* interaction.a97(this$0.p96_1, $isPubliclyObserved, $completion);
    return Unit_instance;
  }, 1);
}
function ServerDuelGameSetupKrpc$startGame$slambda(this$0) {
  return constructCallableReference(function *(interaction, $completion) {
    return (yield* /*#__NOINLINE__*/onReconnectInternal(this$0, interaction, $completion)) ? null : false;
  }, 1);
}
function ServerDuelGameSetupKrpc$startGame$slambda_0(this$0) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.b97(this$0.p96_1, $completion);
  }, 1);
}
function ServerDuelGameSetupKrpc$processUpdatesFromServer$slambda(this$0) {
  return constructCallableReference(function *(interaction, $completion) {
    return (yield* /*#__NOINLINE__*/onReconnectInternal(this$0, interaction, $completion)) ? null : new GameStarted(null);
  }, 1);
}
function ServerDuelGameSetupKrpc$processUpdatesFromServer$slambda_0(this$0) {
  return constructCallableReference(function *(interaction, $completion) {
    return yield* interaction.c97(this$0.p96_1, $completion);
  }, 1);
}
function revertCurrentIndexAndCreateRevertResult($this, revertChanges, previousRevision, previousCheckCode) {
  var currentElementStatus = whatWillBeReapply($this, $this.u97_1);
  var previousToReverted = whatWillBeReapply($this, $this.u97_1 - 1 | 0);
  var willBeInfo = $this.p97_1.u2($this.u97_1);
  var tmp;
  if (willBeInfo instanceof ChooseAnswerRequestFromServer) {
    tmp = to(willBeInfo.q93_1, willBeInfo.r93_1);
  } else {
    tmp = to(null, false);
  }
  var _destruct__k2r9zo = tmp;
  var revertedToQuestion = _destruct__k2r9zo.jm();
  var mayNothingInRevertQuestion = _destruct__k2r9zo.km();
  var tmp_0;
  if ($this.u97_1 > 0) {
    var tmp_1 = $this.p97_1.u2($this.u97_1 - 1 | 0);
    var tmp0_safe_receiver = tmp_1 instanceof ChooseAnswerRequestFromServer ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = revertCurrentIndexAndCreateRevertResult$x(tmp0_safe_receiver, tmp0_safe_receiver.q93_1);
    }
    tmp_0 = tmp_2;
  } else {
    tmp_0 = null;
  }
  var previousQuestionData = tmp_0;
  var tmp_3;
  if ($this.u97_1 > 0) {
    var tmp_4 = $this.p97_1.u2($this.u97_1 - 1 | 0);
    var tmp1_safe_receiver = tmp_4 instanceof GameNotificationInfo ? tmp_4 : null;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u93_1;
    tmp_3 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.x3p_1;
  } else {
    tmp_3 = null;
  }
  var previousGameStateEvent = tmp_3;
  return new RevertResult(revertChanges, previousRevision, previousCheckCode, currentElementStatus, previousToReverted, revertedToQuestion, mayNothingInRevertQuestion, previousQuestionData, previousGameStateEvent);
}
function whatWillBeReapply($this, indexOfReplay) {
  if (indexOfReplay < 0)
    return WhatWillBeReapply_NoStateBefore_getInstance();
  var revertedFromServer = $this.p97_1.u2(indexOfReplay);
  var tmp;
  if (revertedFromServer instanceof GameNotificationInfo) {
    var tmp_0;
    var tmp_1 = revertedFromServer.u93_1.x3p_1;
    if (tmp_1 instanceof InitGameStateEvent) {
      tmp_0 = WhatWillBeReapply_InitialStateNotification_getInstance();
    } else {
      tmp_0 = WhatWillBeReapply_GameNotification_getInstance();
    }
    tmp = tmp_0;
  } else {
    if (revertedFromServer instanceof ChooseAnswerRequestFromServer) {
      tmp = WhatWillBeReapply_GameQuestion_getInstance();
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Should not be other events in full replay, ' + toString(revertedFromServer);
      throw IllegalStateException.o(toString(message));
    }
  }
  var whatWillBeReapply = tmp;
  return whatWillBeReapply;
}
function FullGameReplayDriverImpl$performRevertStates$slambda($isFirstRevert, this$0) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if (!$isFirstRevert._v) {
      var _unary__edvuaz = this$0.u97_1;
      this$0.u97_1 = _unary__edvuaz - 1 | 0;
      tmp = Unit_instance;
    }
    var currentInfo = this$0.p97_1.u2(this$0.u97_1);
    var tmp_0;
    if (currentInfo instanceof GameNotificationInfo) {
      var _destruct__k2r9zo = removeLast(this$0.s97_1);
      var revertChanges = _destruct__k2r9zo.jm();
      var previousRevision = _destruct__k2r9zo.km();
      var previousCheckCode = _destruct__k2r9zo.fx();
      // Inline function 'kotlin.with' call
      var $this$with = this$0.x97();
      var _iterator__ex2g4s = revertChanges.p1();
      while (_iterator__ex2g4s.q1()) {
        var revertChange = _iterator__ex2g4s.r1();
        apply($this$with, revertChange);
      }
      $this$with.g38_1 = previousRevision;
      if (!(previousCheckCode == null)) {
        var actualCheckCode = calculateCheckCode($this$with);
        // Inline function 'kotlin.require' call
        if (!equals(previousCheckCode, actualCheckCode)) {
          var message = 'Check code from server = ' + previousCheckCode.toString() + ' is not equal to local ' + actualCheckCode.toString();
          throw IllegalArgumentException.h2(toString(message));
        }
      }
      tmp_0 = revertCurrentIndexAndCreateRevertResult(this$0, revertChanges, previousRevision, previousCheckCode);
    } else {
      if (currentInfo instanceof ChooseAnswerRequestFromServer) {
        var agent = ensureNotNull(this$0.o97_1.w4(new GameTeam(currentInfo.p93_1)));
        var predefinedAnswer = get_predefinedAnswer(currentInfo);
        agent.o6t().d6y(predefinedAnswer);
        tmp_0 = revertCurrentIndexAndCreateRevertResult(this$0, emptyList(), -1, null);
      } else {
        // Inline function 'kotlin.error' call
        var message_0 = 'Should not be other events in full replay, ' + toString(currentInfo);
        throw IllegalStateException.o(toString(message_0));
      }
    }
    // Inline function 'kotlin.also' call
    var this_0 = tmp_0;
    $isFirstRevert._v = false;
    return this_0;
  }, 0);
}
function revertCurrentIndexAndCreateRevertResult$x($it, q) {
  return new QuestionDataToRestore(q, $it.r93_1, get_predefinedAnswer($it));
}
function FullGameReplayDriverImpl$performGameReplay$lambda($event) {
  return ($this$withStateRuntime) => $event.o37($this$withStateRuntime);
}
function FullGameReplayDriverImpl$performGameReplay$slambda$slambda$slambda() {
  return constructCallableReference(function *(_unused_var__etf5q3, answerDeferred, $completion) {
    yield* boundAwait(answerDeferred, $completion);
    return Unit_instance;
  }, 2);
}
function FullGameReplayDriverImpl$performGameReplay$slambda$slambda(this$0, $info) {
  return constructCallableReference(function *($this$async, $completion) {
    return yield* processInfo(this$0, this$0.o97_1, $info, FullGameReplayDriverImpl$performGameReplay$slambda$slambda$slambda(), $completion);
  }, 1);
}
function FullGameReplayDriverImpl$performGameReplay$slambda$slambda_0($deferred, this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var doneStatus = yield* $deferred.m1q($completion);
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.t97_1;
    yield* this_0.y2a(null, $completion);
    var tmp;
    try {
      this$0.v97_1 = null;
      var _unary__edvuaz = this$0.u97_1;
      this$0.u97_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz;
    }finally {
      this_0.k2a(null);
    }
    this$0.y97().l1t(doneStatus);
    return Unit_instance;
  }, 1);
}
function FullGameReplayDriverImpl$performGameReplay$slambda(this$0, $info) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var scopeCoroutineContext = $this$coroutineScope.d1m().ae(Key_instance);
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = this$0.t97_1;
    yield* this_0.y2a(null, $completion);
    var tmp;
    try {
      // Inline function 'kotlin.also' call
      var this_1 = async($this$coroutineScope, VOID, VOID, FullGameReplayDriverImpl$performGameReplay$slambda$slambda(this$0, $info));
      this$0.v97_1 = this_1;
      tmp = this_1;
    }finally {
      this_0.k2a(null);
    }
    var deferred = tmp;
    this$0.w97_1 = CompletableDeferred();
    launch($this$coroutineScope, VOID, VOID, FullGameReplayDriverImpl$performGameReplay$slambda$slambda_0(deferred, this$0));
    var r = yield* this$0.y97().m1q($completion);
    if (scopeCoroutineContext == null)
      null;
    else {
      cancelChildren(scopeCoroutineContext);
    }
    return r;
  }, 1);
}
function get_adjustToExcludeSourceCursor(_this__u8e3s4) {
  _init_properties_ServerDrivenConfigurationKrpc_kt__776o1j();
  var tmp;
  if (_this__u8e3s4 instanceof SessionFinished) {
    tmp = _this__u8e3s4.o98(get_comparisonInfoSourceCursor());
  } else {
    if (_this__u8e3s4 instanceof SessionCanceled) {
      tmp = _this__u8e3s4;
    } else {
      if (_this__u8e3s4 instanceof SessionEnded) {
        tmp = _this__u8e3s4;
      } else {
        if (_this__u8e3s4 instanceof SessionReloadRequired) {
          tmp = _this__u8e3s4;
        } else {
          if (_this__u8e3s4 instanceof ChooseAnswerRequestFromServer) {
            tmp = _this__u8e3s4.m98(get_comparisonInfoSourceCursor());
          } else {
            if (_this__u8e3s4 instanceof StartMasterFixingEvents) {
              tmp = _this__u8e3s4.l98(get_comparisonInfoSourceCursor());
            } else {
              if (_this__u8e3s4 instanceof MasterFixingApprovalRequest) {
                tmp = _this__u8e3s4.k98(get_comparisonInfoSourceCursor());
              } else {
                if (_this__u8e3s4 instanceof RevertApprovalRequest) {
                  tmp = _this__u8e3s4.j98(get_comparisonInfoSourceCursor());
                } else {
                  if (_this__u8e3s4 instanceof GameNotificationInfo) {
                    tmp = _this__u8e3s4.i98(get_comparisonInfoSourceCursor());
                  } else {
                    if (_this__u8e3s4 instanceof PingMessage) {
                      tmp = _this__u8e3s4.h98(get_comparisonInfoSourceCursor());
                    } else {
                      if (_this__u8e3s4 instanceof RevertGameEventInfo) {
                        tmp = _this__u8e3s4.g98(get_comparisonInfoSourceCursor());
                      } else {
                        if (_this__u8e3s4 instanceof IncorrectServerStateForRequest) {
                          throw TranslatedServerError.f98('Incorrect server state for request');
                        } else {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function *processInfo(diagnostics, agentMap, info, submitAnswer, $completion) {
  if (!(info instanceof PingMessage)) {
    if (info instanceof ChooseAnswerRequestFromServer) {
      var agent = ensureNotNull(agentMap.w4(new GameTeam(info.p93_1)));
      var gameState = yield* agent.s6t($completion);
      if (!(gameState.g4k() === info.o93_1)) {
        // Inline function 'kotlin.error' call
        var message = 'Game state revision ' + gameState.g4k() + ' is different from the question revision ' + info.o93_1;
        throw IllegalStateException.o(toString(message));
      }
      var predefinedAnswerIndex = info.s93_1;
      if (!(predefinedAnswerIndex == null)) {
        var answer = get_predefinedAnswer(info);
        agent.o6t().c6y(answer);
      }
      // Inline function 'kotlin.with' call
      var $this$with = withDiagnostics(gameState, diagnostics);
      var answerDeferred = yield* agent.p6t($this$with, info.q93_1, info.r93_1, $completion);
      yield* submitAnswer(info.q93_1, answerDeferred, $completion);
    } else {
      if (info instanceof GameNotificationInfo) {
        var tmp;
        if (info.v93_1 === get_anyGameTeamMarker()) {
          tmp = agentMap.y4();
        } else {
          tmp = listOf_0(ensureNotNull(agentMap.w4(new GameTeam(info.v93_1))));
        }
        var toNotify = tmp;
        var _iterator__ex2g4s = toNotify.p1();
        while (_iterator__ex2g4s.q1()) {
          var provider = _iterator__ex2g4s.r1();
          yield* provider.r6t(info.u93_1, $completion);
        }
      } else {
        if (info instanceof RevertGameEventInfo) {
          var tmp_0;
          if (info.a94_1 === get_anyGameTeamMarker()) {
            tmp_0 = agentMap.y4();
          } else {
            tmp_0 = listOf_0(ensureNotNull(agentMap.w4(new GameTeam(info.a94_1))));
          }
          var toNotify_0 = tmp_0;
          var _iterator__ex2g4s_0 = toNotify_0.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var provider_0 = _iterator__ex2g4s_0.r1();
            yield* provider_0.u6q(info.x93_1, info.y93_1, info.z93_1, $completion);
          }
        } else {
          if (!(info instanceof StartMasterFixingEvents)) {
            if (!(info instanceof MasterFixingApprovalRequest)) {
              if (!(info instanceof RevertApprovalRequest)) {
                if (info instanceof SessionFinished) {
                  return false;
                } else {
                  if (info instanceof SessionCanceled) {
                    throw GameSessionIsCanceledException.w98();
                  } else {
                    if (info instanceof SessionReloadRequired)
                      throw GameSessionReloadRequiredException.j6t();
                    else {
                      if (info instanceof SessionEnded) {
                        switch (info.p98_1.w1_1) {
                          case 1:
                            return false;
                          case 2:
                            throw GameSessionIsCanceledException.w98();
                          case 3:
                            var tmp2_elvis_lhs = info.q98_1;
                            throw GameSessionFailedException.b99(tmp2_elvis_lhs == null ? 'Session failed' : tmp2_elvis_lhs);
                          case 0:
                            // Inline function 'kotlin.error' call

                            var message_0 = 'Active is not a terminal session status';
                            throw IllegalStateException.o(toString(message_0));
                          default:
                            noWhenBranchMatchedException();
                            break;
                        }
                      } else {
                        if (equals(info, IncorrectServerStateForRequest_getInstance()))
                          throw TranslatedServerError.f98('Incorrect server state for request');
                        else {
                          noWhenBranchMatchedException();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return true;
}
function createReplayTimeline($context_GameRuntimeDiagnostics_htysfc, fullReplay) {
  _init_properties_ServerDrivenConfigurationKrpc_kt__776o1j();
  var gameState = null;
  var answerIndex = 0;
  // Inline function 'kotlin.collections.mutableListOf' call
  var checkpoints = ArrayList.p2();
  var _iterator__ex2g4s = fullReplay.p1();
  $l$loop_0: while (_iterator__ex2g4s.q1()) {
    var info = _iterator__ex2g4s.r1();
    if (info instanceof ChooseAnswerRequestFromServer) {
      if (!(info.s93_1 == null)) {
        answerIndex = answerIndex + 1 | 0;
      }
    } else {
      if (info instanceof GameNotificationInfo) {
        var event = info.u93_1.x3p_1;
        if (event instanceof InitGameStateEvent) {
          gameState = event.a54_1.y4l();
          continue $l$loop_0;
        }
        var tmp1_elvis_lhs = gameState;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var state = tmp;
        // Inline function 'kotlin.with' call
        var changes = withStateRuntime($context_GameRuntimeDiagnostics_htysfc, state, createReplayTimeline$lambda(event));
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = changes.p1();
        while (_iterator__ex2g4s_0.q1()) {
          var element = _iterator__ex2g4s_0.r1();
          apply(state, element);
        }
        var targetAnswerIndex = answerIndex;
        var tmp0_safe_receiver = event instanceof StartPhaseEvent ? event : null;
        var phase = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i5a_1;
        if (phase instanceof DawnPhase) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = new Dawn(state.e38_1, targetAnswerIndex);
          checkpoints.d2(element_0);
        } else {
          if (phase instanceof PlayerTurnPhase) {
            // Inline function 'kotlin.collections.plusAssign' call
            var element_1 = new Turn(state.e38_1, targetAnswerIndex, state.f38_1, get_objectType(state, phase.x4g_1));
            checkpoints.d2(element_1);
          } else {
            if (equals(phase, NightPhase_getInstance())) {
              // Inline function 'kotlin.collections.plusAssign' call
              var element_2 = new Night(state.e38_1, targetAnswerIndex);
              checkpoints.d2(element_2);
            }
          }
        }
      }
    }
  }
  return replayTimeline(checkpoints);
}
function createReplayTimeline$lambda($event) {
  return ($this$withStateRuntime) => $event.o37($this$withStateRuntime);
}
var properties_initialized_ServerDrivenConfigurationKrpc_kt_wqtvcp;
function _init_properties_ServerDrivenConfigurationKrpc_kt__776o1j() {
  if (!properties_initialized_ServerDrivenConfigurationKrpc_kt_wqtvcp) {
    properties_initialized_ServerDrivenConfigurationKrpc_kt_wqtvcp = true;
    comparisonInfoSourceCursor = get_terminalInfoSourceCursor();
  }
}
function BeastServerInteraction$$rpcServiceStub$Companion$serverMessagesInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return service.d94();
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestServerVersionInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.e94($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestAuthenticationCapabilitiesInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.c94($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$loginWithAccessCodeInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.u6k((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$restoreSessionInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.v6k($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$logoutInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.w6k($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$getUserSettingsInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.x6k($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$patchUserSettingsInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.y6k(tmp instanceof BeastUserSettingsPatch ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$resetUserSettingsInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.z6k($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$resetCommunicationInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.c6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$getActiveGameSessionsInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.a6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestLobbyListInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.b6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$createNewGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.g94((tmp == null ? true : typeof tmp === 'string') ? tmp : null, $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$connectNewGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.h94(tmp instanceof GameCode ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$reconnectGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameCode ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    var tmp_2 = tmp_1 instanceof GameTeam ? tmp_1.r3p_1 : THROW_CCE();
    var tmp_3 = parameters[2];
    return yield* service.f6l(tmp_0, tmp_2, (tmp_3 == null ? true : tmp_3 instanceof InfoSourceCursor) ? tmp_3 : null, $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$cancelGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.h6l(tmp instanceof GameCode ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$setGameContentVersionInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameSetupId ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.w96(tmp_0, tmp_1 instanceof GameContentVersion ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$setGameContractInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameSetupId ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.x96(tmp_0, (tmp_1 == null ? true : isInterface(tmp_1, GameRules)) ? tmp_1 : null, $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$setGameTeamInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameSetupId ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.y96(tmp_0, tmp_1 instanceof GameTeam ? tmp_1.r3p_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$setRecordingGameModeInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameSetupId ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.z96(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$setPubliclyObservedInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameSetupId ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.a97(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$startGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.b97(tmp instanceof GameSetupId ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestSetupUpdateInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.c97(tmp instanceof GameSetupId ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$prepareSandboxSessionInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.o6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$initSandboxGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.k94(tmp instanceof GameSetupState ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$applyEventForSandboxInitInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameCode ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    var tmp_2 = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE();
    var tmp_3 = parameters[2];
    var tmp_4 = tmp_3 instanceof GameStateCheckCode ? tmp_3 : THROW_CCE();
    var tmp_5 = parameters[3];
    return yield* service.m94(tmp_0, tmp_2, tmp_4, (!(tmp_5 == null) ? isInterface(tmp_5, GameStateEvent) : false) ? tmp_5 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$startSandboxGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameCode ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    var tmp_2 = tmp_1 instanceof GameStateCheckCode ? tmp_1 : THROW_CCE();
    var tmp_3 = parameters[2];
    var tmp_4 = (!(tmp_3 == null) ? typeof tmp_3 === 'number' : false) ? tmp_3 : THROW_CCE();
    var tmp_5 = parameters[3];
    return yield* service.l94(tmp_0, tmp_2, tmp_4, tmp_5 instanceof SandboxStartParams ? tmp_5 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$reconnectSandboxGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.t6l(tmp instanceof GameCode ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestInfoInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.n94($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestGamePresenceInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.x6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$submitAnswerInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof InfoSourceCursor ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.o94(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$startMasterFixingEventsInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.i95($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$approveMasterFixingInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.v94(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$approveRevertInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.b95(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$submitMasterFixingEventInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.s92(tmp_0, (tmp_1 == null ? true : isInterface(tmp_1, GameStateEvent)) ? tmp_1 : null, $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$pingElementInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = (!(tmp == null) ? isInterface(tmp, PingElement) : false) ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.w6l(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$getRevertRequestTokenInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.g95($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestRevertTurnInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.h95(tmp instanceof RevertRequestToken ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$reloadGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.z6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$reloadGameByCodeInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.a6m(tmp instanceof GameCode ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$submitGameStateErrorInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    var tmp_2 = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE();
    var tmp_3 = parameters[2];
    return yield* service.c6m(tmp_0, tmp_2, (tmp_3 == null ? true : typeof tmp_3 === 'string') ? tmp_3 : null, $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestCompletedGamesInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.j6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestSandboxGamesInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.k6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$getCompletedGameInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameCode ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.l6l(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$locateRetainedResourceInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.m6l(tmp instanceof BeastResourceLookupRequest ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestFullReplayInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameCode ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.i94(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$shareSandboxReplayInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.j94(tmp instanceof GameCode ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$shareFullGameReplayInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    return yield* service.q6l(tmp instanceof GameCode ? tmp : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$requestPendingReplayConsentsInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    return yield* service.r6l($completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$respondToReplayConsentInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof GameCode ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.s6l(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
function BeastServerInteraction$$rpcServiceStub$Companion$submitErrorInvokator$slambda() {
  return constructCallableReference(function *(service, parameters, $completion) {
    var tmp = parameters[0];
    var tmp_0 = tmp instanceof InfoSourceCursor ? tmp : THROW_CCE();
    var tmp_1 = parameters[1];
    return yield* service.m93(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE(), $completion);
  }, 2);
}
var Companion_instance_3;
function Companion_getInstance_2() {
  if (Companion_instance_3 === VOID)
    new Companion_0();
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_3() {
  return Companion_instance_4;
}
var $serializer_instance_0;
function $serializer_getInstance_31() {
  if ($serializer_instance_0 === VOID)
    new $serializer_1();
  return $serializer_instance_0;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.h9d_1.k3();
}
function ConnectNewGameResult$GameWithSuchNameIsInProgress$_anonymous__2odg4u() {
  var tmp = GameWithSuchNameIsInProgress_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('steelart.beast.network.ConnectNewGameResult.GameWithSuchNameIsInProgress', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.i9d_1.k3();
}
function ConnectNewGameResult$NotFound$_anonymous__ds3gix() {
  var tmp = NotFound_getInstance_0();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('steelart.beast.network.ConnectNewGameResult.NotFound', tmp, tmp$ret$0);
}
var GameWithSuchNameIsInProgress_instance;
function GameWithSuchNameIsInProgress_getInstance() {
  if (GameWithSuchNameIsInProgress_instance === VOID)
    new GameWithSuchNameIsInProgress();
  return GameWithSuchNameIsInProgress_instance;
}
var NotFound_instance;
function NotFound_getInstance_0() {
  if (NotFound_instance === VOID)
    new NotFound();
  return NotFound_instance;
}
var Companion_instance_5;
function Companion_getInstance_4() {
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_5() {
  return Companion_instance_6;
}
var $serializer_instance_1;
function $serializer_getInstance_32() {
  if ($serializer_instance_1 === VOID)
    new $serializer_2();
  return $serializer_instance_1;
}
var Companion_instance_7;
function Companion_getInstance_6() {
  return Companion_instance_7;
}
function SessionEnded$Companion$$childSerializers$_anonymous__lsru5i() {
  return createSimpleEnumSerializer('steelart.beast.network.GameStatus', values());
}
var Companion_instance_8;
function Companion_getInstance_7() {
  if (Companion_instance_8 === VOID)
    new Companion_5();
  return Companion_instance_8;
}
var $serializer_instance_2;
function $serializer_getInstance_33() {
  if ($serializer_instance_2 === VOID)
    new $serializer_3();
  return $serializer_instance_2;
}
function _get_$cachedSerializer__te6jhj_1($this) {
  return $this.r9d_1.k3();
}
function SessionCanceled$_anonymous__mdb0zc() {
  var tmp = SessionCanceled_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('steelart.beast.network.SessionCanceled', tmp, tmp$ret$0);
}
var SessionCanceled_instance;
function SessionCanceled_getInstance() {
  if (SessionCanceled_instance === VOID)
    new SessionCanceled();
  return SessionCanceled_instance;
}
var Companion_instance_9;
function Companion_getInstance_8() {
  return Companion_instance_9;
}
var $serializer_instance_3;
function $serializer_getInstance_34() {
  if ($serializer_instance_3 === VOID)
    new $serializer_4();
  return $serializer_instance_3;
}
var Companion_instance_10;
function Companion_getInstance_9() {
  return Companion_instance_10;
}
var $serializer_instance_4;
function $serializer_getInstance_35() {
  if ($serializer_instance_4 === VOID)
    new $serializer_5();
  return $serializer_instance_4;
}
function _get_$cachedSerializer__te6jhj_2($this) {
  return $this.a9e_1.k3();
}
function SessionReloadRequired$_anonymous__1y78g9() {
  var tmp = SessionReloadRequired_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('steelart.beast.network.SessionReloadRequired', tmp, tmp$ret$0);
}
var SessionReloadRequired_instance;
function SessionReloadRequired_getInstance() {
  if (SessionReloadRequired_instance === VOID)
    new SessionReloadRequired();
  return SessionReloadRequired_instance;
}
function _get_$cachedSerializer__te6jhj_3($this) {
  return $this.c9e_1.k3();
}
function IncorrectServerStateForRequest$_anonymous__c8ld54() {
  var tmp = IncorrectServerStateForRequest_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer.l1c('steelart.beast.network.IncorrectServerStateForRequest', tmp, tmp$ret$0);
}
var IncorrectServerStateForRequest_instance;
function IncorrectServerStateForRequest_getInstance() {
  if (IncorrectServerStateForRequest_instance === VOID)
    new IncorrectServerStateForRequest();
  return IncorrectServerStateForRequest_instance;
}
function PingMessage$Companion$$childSerializers$_anonymous__ej5lbp() {
  return Companion_instance.a2g();
}
var Companion_instance_11;
function Companion_getInstance_10() {
  if (Companion_instance_11 === VOID)
    new Companion_8();
  return Companion_instance_11;
}
var $serializer_instance_5;
function $serializer_getInstance_36() {
  if ($serializer_instance_5 === VOID)
    new $serializer_6();
  return $serializer_instance_5;
}
var Companion_instance_12;
function Companion_getInstance_11() {
  return Companion_instance_12;
}
var $serializer_instance_6;
function $serializer_getInstance_37() {
  if ($serializer_instance_6 === VOID)
    new $serializer_7();
  return $serializer_instance_6;
}
var Companion_instance_13;
function Companion_getInstance_12() {
  return Companion_instance_13;
}
var $serializer_instance_7;
function $serializer_getInstance_38() {
  if ($serializer_instance_7 === VOID)
    new $serializer_8();
  return $serializer_instance_7;
}
var Companion_instance_14;
function Companion_getInstance_13() {
  return Companion_instance_14;
}
var $serializer_instance_8;
function $serializer_getInstance_39() {
  if ($serializer_instance_8 === VOID)
    new $serializer_9();
  return $serializer_instance_8;
}
var Companion_instance_15;
function Companion_getInstance_14() {
  return Companion_instance_15;
}
var $serializer_instance_9;
function $serializer_getInstance_40() {
  if ($serializer_instance_9 === VOID)
    new $serializer_10();
  return $serializer_instance_9;
}
var Companion_instance_16;
function Companion_getInstance_15() {
  return Companion_instance_16;
}
var $serializer_instance_10;
function $serializer_getInstance_41() {
  if ($serializer_instance_10 === VOID)
    new $serializer_11();
  return $serializer_instance_10;
}
var Companion_instance_17;
function Companion_getInstance_16() {
  return Companion_instance_17;
}
var $serializer_instance_11;
function $serializer_getInstance_42() {
  if ($serializer_instance_11 === VOID)
    new $serializer_12();
  return $serializer_instance_11;
}
var Companion_instance_18;
function Companion_getInstance_17() {
  return Companion_instance_18;
}
function _get_$cachedSerializer__te6jhj_4($this) {
  return $this.e9f_1.k3();
}
function StartMasterFixingResult$Companion$_anonymous__supoin() {
  return createSimpleEnumSerializer('steelart.beast.network.StartMasterFixingResult', values_0());
}
var StartMasterFixingResult_Started_instance;
var StartMasterFixingResult_NotApproved_instance;
var StartMasterFixingResult_ForbiddenDuringParallelDraft_instance;
function values_0() {
  return [StartMasterFixingResult_Started_getInstance(), StartMasterFixingResult_NotApproved_getInstance(), StartMasterFixingResult_ForbiddenDuringParallelDraft_getInstance()];
}
var Companion_instance_19;
function Companion_getInstance_18() {
  StartMasterFixingResult_initEntries();
  if (Companion_instance_19 === VOID)
    new Companion_16();
  return Companion_instance_19;
}
var StartMasterFixingResult_entriesInitialized;
function StartMasterFixingResult_initEntries() {
  if (StartMasterFixingResult_entriesInitialized)
    return Unit_instance;
  StartMasterFixingResult_entriesInitialized = true;
  StartMasterFixingResult_Started_instance = new StartMasterFixingResult('Started', 0);
  StartMasterFixingResult_NotApproved_instance = new StartMasterFixingResult('NotApproved', 1);
  StartMasterFixingResult_ForbiddenDuringParallelDraft_instance = new StartMasterFixingResult('ForbiddenDuringParallelDraft', 2);
  Companion_getInstance_18();
}
function RevertGameEventInfo$Companion$$childSerializers$_anonymous__5j8ztk() {
  return Companion_instance_0.a2g();
}
function RevertGameEventInfo$Companion$$childSerializers$_anonymous__5j8ztk_0() {
  return new ArrayListSerializer(Companion_instance_1.a2g());
}
var Companion_instance_20;
function Companion_getInstance_19() {
  if (Companion_instance_20 === VOID)
    new Companion_17();
  return Companion_instance_20;
}
var $serializer_instance_12;
function $serializer_getInstance_43() {
  if ($serializer_instance_12 === VOID)
    new $serializer_13();
  return $serializer_instance_12;
}
function get_predefinedAnswer(_this__u8e3s4) {
  // Inline function 'kotlin.let' call
  var it = ensureNotNull(_this__u8e3s4.s93_1);
  return it >= 0 ? get(_this__u8e3s4.q93_1.s3o(), it) : null;
}
function StartMasterFixingResult_Started_getInstance() {
  StartMasterFixingResult_initEntries();
  return StartMasterFixingResult_Started_instance;
}
function StartMasterFixingResult_NotApproved_getInstance() {
  StartMasterFixingResult_initEntries();
  return StartMasterFixingResult_NotApproved_instance;
}
function StartMasterFixingResult_ForbiddenDuringParallelDraft_getInstance() {
  StartMasterFixingResult_initEntries();
  return StartMasterFixingResult_ForbiddenDuringParallelDraft_instance;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
protoOf($serializer_0).z1b = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ClientConnectionSettings, 'ClientConnectionSettings', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
initMetadataForClass(RevertStateData, 'RevertStateData');
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(ServerDrivenConfigurationKrpc$createMasterFixingEventsConsumer$1, VOID, VOID, VOID, VOID, [1]);
protoOf(ServerDrivenConfigurationKrpc).g6l = reconnectGame$default;
protoOf(ServerDrivenConfigurationKrpc).v6l = processClient$default;
initMetadataForClass(ServerDrivenConfigurationKrpc, 'ServerDrivenConfigurationKrpc', VOID, VOID, [ServerDrivenConfiguration], [0, 1, 2, 3, 7, 4, 5, 6, 8]);
initMetadataForInterface(InteractionServerException, 'InteractionServerException');
initMetadataForClass(ServerHasAnotherVersionError, 'ServerHasAnotherVersionError', VOID, VOID, [InteractionServerException]);
initMetadataForClass(ServerDuelGameSetupKrpc, 'ServerDuelGameSetupKrpc', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(FullGameReplayDriverImpl, 'FullGameReplayDriverImpl', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(SandboxAccessDeniedException, 'SandboxAccessDeniedException', SandboxAccessDeniedException.a96, VOID, [InteractionServerException, ServerDrivenConfigurationTransparentException]);
initMetadataForClass(BeastAuthenticationRequiredException, 'BeastAuthenticationRequiredException', BeastAuthenticationRequiredException.f96, VOID, [InteractionServerException, ServerDrivenConfigurationTransparentException]);
initMetadataForClass(WrappedServerError, 'WrappedServerError', VOID, VOID, [InteractionServerException]);
initMetadataForClass(TranslatedServerError, 'TranslatedServerError', VOID, VOID, [InteractionServerException]);
initMetadataForClass(GameSessionIsCanceledException, 'GameSessionIsCanceledException', GameSessionIsCanceledException.w98, VOID, [InteractionServerException, ServerDrivenConfigurationTransparentException]);
initMetadataForClass(GameSessionFailedException, 'GameSessionFailedException', GameSessionFailedException.b99, VOID, [InteractionServerException, ServerDrivenConfigurationTransparentException]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_0, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_1, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_2, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_3, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_4, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_5, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_6, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_7, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_8, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_9, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_10, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_11, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_12, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_13, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_14, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_15, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_16, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_17, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_18, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_19, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_20, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_21, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_22, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_23, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_24, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_25, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_26, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_27, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_28, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_29, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_30, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_31, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_32, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_33, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_34, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_35, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_36, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_37, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_38, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_39, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_40, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_41, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_42, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_43, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_44, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_45, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_46, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_47, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_48, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForClass(sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0_49, 'sam$kotlinx_rpc_descriptor_RpcInvokator_Method$0', VOID, VOID, [Method, FunctionAdapter], [2]);
initMetadataForCompanion(Companion_0, VOID, [RpcServiceDescriptor]);
initMetadataForInterface(BeastServerInteraction, 'BeastServerInteraction', VOID, VOID, VOID, [0, 1, 3, 2, 4], VOID, {1: Companion_getInstance_2});
initMetadataForClass($rpcServiceStub, '$rpcServiceStub', VOID, VOID, [BeastServerInteraction], [0, 1, 3, 2, 4]);
initMetadataForCompanion(Companion_1);
protoOf($serializer_1).z1b = typeParametersSerializers;
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(ConnectNewGameResult, 'ConnectNewGameResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
initMetadataForClass(Connected, 'Connected', VOID, VOID, [ConnectNewGameResult], VOID, VOID, {0: $serializer_getInstance_31});
initMetadataForObject(GameWithSuchNameIsInProgress, 'GameWithSuchNameIsInProgress', VOID, VOID, [ConnectNewGameResult, SerializerFactory], VOID, VOID, {0: GameWithSuchNameIsInProgress_getInstance});
initMetadataForObject(NotFound, 'NotFound', VOID, VOID, [ConnectNewGameResult, SerializerFactory], VOID, VOID, {0: NotFound_getInstance_0});
initMetadataForCompanion(Companion_2, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_3);
protoOf($serializer_2).z1b = typeParametersSerializers;
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameSetupId, 'GameSetupId', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
initMetadataForCompanion(Companion_4, VOID, [SerializerFactory]);
initMetadataForInterface(InfoFromServer, 'InfoFromServer', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
initMetadataForCompanion(Companion_5);
protoOf($serializer_3).z1b = typeParametersSerializers;
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SessionEnded, 'SessionEnded', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_33});
initMetadataForObject(SessionCanceled, 'SessionCanceled', VOID, VOID, [InfoFromServer, SerializerFactory], VOID, VOID, {0: SessionCanceled_getInstance});
initMetadataForCompanion(Companion_6);
protoOf($serializer_4).z1b = typeParametersSerializers;
initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ChooseAnswerRequestFromServer, 'ChooseAnswerRequestFromServer', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_34});
initMetadataForCompanion(Companion_7);
protoOf($serializer_5).z1b = typeParametersSerializers;
initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(SessionFinished, 'SessionFinished', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_35});
initMetadataForObject(SessionReloadRequired, 'SessionReloadRequired', VOID, VOID, [InfoFromServer, SerializerFactory], VOID, VOID, {0: SessionReloadRequired_getInstance});
initMetadataForObject(IncorrectServerStateForRequest, 'IncorrectServerStateForRequest', VOID, VOID, [InfoFromServer, SerializerFactory], VOID, VOID, {0: IncorrectServerStateForRequest_getInstance});
initMetadataForCompanion(Companion_8);
protoOf($serializer_6).z1b = typeParametersSerializers;
initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PingMessage, 'PingMessage', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_36});
initMetadataForCompanion(Companion_9);
protoOf($serializer_7).z1b = typeParametersSerializers;
initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(MasterFixingApprovalRequest, 'MasterFixingApprovalRequest', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_37});
initMetadataForCompanion(Companion_10);
protoOf($serializer_8).z1b = typeParametersSerializers;
initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertApprovalRequest, 'RevertApprovalRequest', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_38});
initMetadataForCompanion(Companion_11);
protoOf($serializer_9).z1b = typeParametersSerializers;
initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(StartMasterFixingEvents, 'StartMasterFixingEvents', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_39});
initMetadataForCompanion(Companion_12);
protoOf($serializer_10).z1b = typeParametersSerializers;
initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GameNotificationInfo, 'GameNotificationInfo', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_40});
initMetadataForCompanion(Companion_13);
protoOf($serializer_11).z1b = typeParametersSerializers;
initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_14);
protoOf($serializer_12).z1b = typeParametersSerializers;
initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForInterface(RevertRequestTokenResult, 'RevertRequestTokenResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_17});
initMetadataForClass(RevertRequestToken, 'RevertRequestToken', VOID, VOID, [RevertRequestTokenResult], VOID, VOID, {0: $serializer_getInstance_41});
initMetadataForClass(InternalRevertRequestTokenError, 'InternalRevertRequestTokenError', VOID, VOID, [RevertRequestTokenResult], VOID, VOID, {0: $serializer_getInstance_42});
initMetadataForCompanion(Companion_15, VOID, [SerializerFactory]);
initMetadataForCompanion(Companion_16, VOID, [SerializerFactory]);
initMetadataForClass(StartMasterFixingResult, 'StartMasterFixingResult', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_18});
initMetadataForCompanion(Companion_17);
protoOf($serializer_13).z1b = typeParametersSerializers;
initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RevertGameEventInfo, 'RevertGameEventInfo', VOID, VOID, [InfoFromServer], VOID, VOID, {0: $serializer_getInstance_43});
//endregion
//region block: init
Companion_instance_2 = new Companion();
Companion_instance_4 = new Companion_1();
Companion_instance_5 = new Companion_2();
Companion_instance_6 = new Companion_3();
Companion_instance_7 = new Companion_4();
Companion_instance_9 = new Companion_6();
Companion_instance_10 = new Companion_7();
Companion_instance_12 = new Companion_9();
Companion_instance_13 = new Companion_10();
Companion_instance_14 = new Companion_11();
Companion_instance_15 = new Companion_12();
Companion_instance_16 = new Companion_13();
Companion_instance_17 = new Companion_14();
Companion_instance_18 = new Companion_15();
//endregion
//region block: exports
export {
  ClientConnectionSettings as ClientConnectionSettings1hcwxx4tfft81,
  ServerDrivenConfigurationKrpc as ServerDrivenConfigurationKrpcmzyhiagna8ar,
};
//endregion
